"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RaceTeam_one_of_decls, _BlobStorage_one_of_decls, _SoftwareLicense_one_of_decls, _BlobContainers_one_of_decls, _BlobContainer_one_of_decls, _Vehicle_one_of_decls, _Project_one_of_decls, _ProjectConfig_one_of_decls, _OutputParameter_one_of_decls, _WorkflowSubmission_one_of_decls, _SubmissionRunGroups_one_of_decls, _CFDPartsList_one_of_decls, _StarCCMConfig_one_of_decls, _BasicNameValue_one_of_decls, _StarCCMParameterList_one_of_decls, _MiscellaneousParameterList_one_of_decls, _WorkflowRunGroup_one_of_decls, _WorkflowSubmissionTemplate_one_of_decls, _Workflow_one_of_decls, _WorkflowTask_one_of_decls, _PlatformJob_one_of_decls, _LicenseQueue_one_of_decls, _PlatformRemoteCommand_one_of_decls, _GMRef_one_of_decls, _PlatformCopyConfig_one_of_decls, _PlatformBatch_one_of_decls, _SecConfig_one_of_decls, _SecToken_one_of_decls, _JobFile_one_of_decls, _WorkflowTaskStatus_one_of_decls, _WorkflowJSONResult_one_of_decls, _RunConfig_one_of_decls, _FollowingCar_one_of_decls, _Coordinate_one_of_decls, _RunConfigCase_one_of_decls, _SelectedSystem_one_of_decls, _AttitudeState_one_of_decls, _Trajectory_one_of_decls, _AttitudeSet_one_of_decls, _DomainState_one_of_decls, _DomainSet_one_of_decls, _SimulationState_one_of_decls, _SimulationSet_one_of_decls, _PtapLocationSet_one_of_decls, _PtapLocation_one_of_decls, _RHRepoSet_one_of_decls, _RHRepo_one_of_decls, _DeploySet_one_of_decls, _DeployState_one_of_decls, _MethodologyState_one_of_decls, _User_one_of_decls, _ExternalUser_one_of_decls, _ExternalSystem_one_of_decls, _AccessRolePermissions_one_of_decls, _Locale_one_of_decls, _UserWorkflowMgmt_one_of_decls, _RescaleToken_one_of_decls, _Geometry_one_of_decls, _RaceTeamRole_one_of_decls, _MethodologySet_one_of_decls, _SystemMessage_one_of_decls, _SystemCode_one_of_decls, _WingState_one_of_decls, _AnsaDir_one_of_decls, _CarConfig_one_of_decls, _SteeringTable_one_of_decls, _CodeDir_one_of_decls, _CmdDir_one_of_decls, _CFDFile_one_of_decls, _Part_one_of_decls, _StarCCMDir_one_of_decls, _PeriscopeDir_one_of_decls, _TyreSet_one_of_decls, _TyreState_one_of_decls, _TyreLoadedRadius_one_of_decls, _TyreStateTransform_one_of_decls, _ProjectDocument_one_of_decls, _WorkflowRecord_one_of_decls, _AzureBlobStorageWebHook_one_of_decls, _ExecuteWorkflowTask_one_of_decls, _DocumentMeta_one_of_decls, _JobQueueItem_one_of_decls, _Metric_one_of_decls;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulationState = exports.DomainSet = exports.DomainState = exports.AttitudeSet = exports.Trajectory = exports.AttitudeState = exports.SelectedSystem = exports.RunConfigCase = exports.Coordinate = exports.FollowingCar = exports.RunConfig = exports.WorkflowJSONResult = exports.WorkflowTaskStatus = exports.JobFile = exports.SecToken = exports.SecConfig = exports.PlatformBatch = exports.PlatformCopyConfig = exports.GMRef = exports.PlatformRemoteCommand = exports.LicenseQueue = exports.PlatformJob = exports.WorkflowTask = exports.Workflow = exports.WorkflowSubmissionTemplate = exports.WorkflowRunGroup = exports.MiscellaneousParameterList = exports.StarCCMParameterList = exports.BasicNameValue = exports.StarCCMConfig = exports.CFDPartsList = exports.SubmissionRunGroups = exports.WorkflowSubmission = exports.OutputParameter = exports.ProjectConfig = exports.Project = exports.Vehicle = exports.BlobContainer = exports.BlobContainers = exports.SoftwareLicense = exports.BlobStorage = exports.RaceTeam = exports.SystemResult = exports.SystemType = exports.SimulationStateType = exports.CopyFileType = exports.SimScope = exports.ProjectStatus = exports.RunStatus = exports.Series = void 0;
exports.Metric = exports.JobQueueItem = exports.DocumentMeta = exports.ExecuteWorkflowTask = exports.AzureBlobStorageWebHook = exports.WorkflowRecord = exports.ProjectDocument = exports.TyreStateTransform = exports.TyreLoadedRadius = exports.TyreState = exports.TyreSet = exports.PeriscopeDir = exports.StarCCMDir = exports.Part = exports.CFDFile = exports.CmdDir = exports.CodeDir = exports.SteeringTable = exports.CarConfig = exports.AnsaDir = exports.WingState = exports.SystemCode = exports.SystemMessage = exports.MethodologySet = exports.RaceTeamRole = exports.Geometry = exports.RescaleToken = exports.UserWorkflowMgmt = exports.Locale = exports.AccessRolePermissions = exports.ExternalSystem = exports.ExternalUser = exports.User = exports.MethodologyState = exports.DeployState = exports.DeploySet = exports.RHRepo = exports.RHRepoSet = exports.PtapLocation = exports.PtapLocationSet = exports.SimulationSet = void 0;
/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.35.1
 * source: AeroStructures.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
const dependency_1 = __importStar(require("./RescaleProto"));
const pb_1 = __importStar(require("google-protobuf"));
var Series;
(function (Series) {
    Series[Series["NO_SERIES"] = 0] = "NO_SERIES";
    Series[Series["SERIES_NASCAR_CUP"] = 1] = "SERIES_NASCAR_CUP";
    Series[Series["SERIES_NASCAR_NBS"] = 2] = "SERIES_NASCAR_NBS";
    Series[Series["SERIES_NASCAR_TRUCK"] = 3] = "SERIES_NASCAR_TRUCK";
    Series[Series["SERIES_F1"] = 4] = "SERIES_F1";
    Series[Series["SERIES_INDY"] = 5] = "SERIES_INDY";
    Series[Series["SERIES_MOTOGP"] = 6] = "SERIES_MOTOGP";
    Series[Series["SERIES_IMSA_WEC"] = 7] = "SERIES_IMSA_WEC";
    Series[Series["SERIES_IMSA_SPORTCAR"] = 8] = "SERIES_IMSA_SPORTCAR";
    Series[Series["SERIES_TEST"] = 9] = "SERIES_TEST";
})(Series || (exports.Series = Series = {}));
var RunStatus;
(function (RunStatus) {
    RunStatus[RunStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RunStatus[RunStatus["CREATED"] = 10] = "CREATED";
    RunStatus[RunStatus["WAITING"] = 15] = "WAITING";
    RunStatus[RunStatus["SUBMITTED"] = 20] = "SUBMITTED";
    RunStatus[RunStatus["PENDING"] = 25] = "PENDING";
    RunStatus[RunStatus["RUNNING"] = 30] = "RUNNING";
    RunStatus[RunStatus["CANCELLED"] = 35] = "CANCELLED";
    RunStatus[RunStatus["COMPLETED"] = 40] = "COMPLETED";
    RunStatus[RunStatus["WARN_ON_ERROR"] = 45] = "WARN_ON_ERROR";
    RunStatus[RunStatus["ERROR"] = 50] = "ERROR";
})(RunStatus || (exports.RunStatus = RunStatus = {}));
var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus[ProjectStatus["NOT_USED"] = 0] = "NOT_USED";
    ProjectStatus[ProjectStatus["ACTIVE"] = 1] = "ACTIVE";
    ProjectStatus[ProjectStatus["ARCHIVED"] = 2] = "ARCHIVED";
})(ProjectStatus || (exports.ProjectStatus = ProjectStatus = {}));
var SimScope;
(function (SimScope) {
    SimScope[SimScope["NOT_USED_SIMSCOPE"] = 0] = "NOT_USED_SIMSCOPE";
    SimScope[SimScope["FULL"] = 1] = "FULL";
    SimScope[SimScope["HALF"] = 2] = "HALF";
})(SimScope || (exports.SimScope = SimScope = {}));
var CopyFileType;
(function (CopyFileType) {
    CopyFileType[CopyFileType["NOT_USED_VAL_File"] = 0] = "NOT_USED_VAL_File";
    CopyFileType[CopyFileType["CAD_STP"] = 1] = "CAD_STP";
    CopyFileType[CopyFileType["AXIS_JSON"] = 2] = "AXIS_JSON";
    CopyFileType[CopyFileType["CONFIG_V1"] = 3] = "CONFIG_V1";
    CopyFileType[CopyFileType["CMD_V1"] = 4] = "CMD_V1";
    CopyFileType[CopyFileType["VS_CAD_STP"] = 5] = "VS_CAD_STP";
    CopyFileType[CopyFileType["NOT_SPECIFIED"] = 100] = "NOT_SPECIFIED";
})(CopyFileType || (exports.CopyFileType = CopyFileType = {}));
var SimulationStateType;
(function (SimulationStateType) {
    SimulationStateType[SimulationStateType["FCRANS"] = 0] = "FCRANS";
    SimulationStateType[SimulationStateType["FCDES"] = 1] = "FCDES";
    SimulationStateType[SimulationStateType["FERANS"] = 2] = "FERANS";
})(SimulationStateType || (exports.SimulationStateType = SimulationStateType = {}));
var SystemType;
(function (SystemType) {
    SystemType[SystemType["testSystem"] = 0] = "testSystem";
    SystemType[SystemType["ensight"] = 1] = "ensight";
    SystemType[SystemType["mav"] = 2] = "mav";
    SystemType[SystemType["ansa"] = 3] = "ansa";
    SystemType[SystemType["periscope"] = 4] = "periscope";
    SystemType[SystemType["openfoam"] = 5] = "openfoam";
    SystemType[SystemType["starccmplus"] = 6] = "starccmplus";
    SystemType[SystemType["starccmp"] = 7] = "starccmp";
    SystemType[SystemType["vtkslice"] = 8] = "vtkslice";
    SystemType[SystemType["configs"] = 10] = "configs";
})(SystemType || (exports.SystemType = SystemType = {}));
var SystemResult;
(function (SystemResult) {
    SystemResult[SystemResult["NO_RESPONSE"] = 0] = "NO_RESPONSE";
    SystemResult[SystemResult["SUCCESS"] = 200] = "SUCCESS";
    SystemResult[SystemResult["RECORD_NOT_FOUND"] = 400] = "RECORD_NOT_FOUND";
    SystemResult[SystemResult["AUTHENTICATION_FAILURE"] = 401] = "AUTHENTICATION_FAILURE";
    SystemResult[SystemResult["GENERAL_ERROR"] = 500] = "GENERAL_ERROR";
})(SystemResult || (exports.SystemResult = SystemResult = {}));
class RaceTeam extends pb_1.Message {
    constructor(data) {
        super();
        _RaceTeam_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RaceTeam_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("series" in data && data.series != undefined) {
                this.series = data.series;
            }
            if ("blobStorage" in data && data.blobStorage != undefined) {
                this.blobStorage = data.blobStorage;
            }
            if ("noStartMavFromFT" in data && data.noStartMavFromFT != undefined) {
                this.noStartMavFromFT = data.noStartMavFromFT;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get series() {
        return pb_1.Message.getFieldWithDefault(this, 9, Series.NO_SERIES);
    }
    set series(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get blobStorage() {
        return pb_1.Message.getWrapperField(this, BlobStorage, 10);
    }
    set blobStorage(value) {
        pb_1.Message.setWrapperField(this, 10, value);
    }
    get has_blobStorage() {
        return pb_1.Message.getField(this, 10) != null;
    }
    get noStartMavFromFT() {
        return pb_1.Message.getFieldWithDefault(this, 11, false);
    }
    set noStartMavFromFT(value) {
        pb_1.Message.setField(this, 11, value);
    }
    static fromObject(data) {
        const message = new RaceTeam({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.series != null) {
            message.series = data.series;
        }
        if (data.blobStorage != null) {
            message.blobStorage = BlobStorage.fromObject(data.blobStorage);
        }
        if (data.noStartMavFromFT != null) {
            message.noStartMavFromFT = data.noStartMavFromFT;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.series != null) {
            data.series = this.series;
        }
        if (this.blobStorage != null) {
            data.blobStorage = this.blobStorage.toObject();
        }
        if (this.noStartMavFromFT != null) {
            data.noStartMavFromFT = this.noStartMavFromFT;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.name.length)
            writer.writeString(2, this.name);
        if (this._id.length)
            writer.writeString(3, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.description.length)
            writer.writeString(8, this.description);
        if (this.series != Series.NO_SERIES)
            writer.writeEnum(9, this.series);
        if (this.has_blobStorage)
            writer.writeMessage(10, this.blobStorage, () => this.blobStorage.serialize(writer));
        if (this.noStartMavFromFT != false)
            writer.writeBool(11, this.noStartMavFromFT);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RaceTeam();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.name = reader.readString();
                    break;
                case 3:
                    message._id = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.description = reader.readString();
                    break;
                case 9:
                    message.series = reader.readEnum();
                    break;
                case 10:
                    reader.readMessage(message.blobStorage, () => message.blobStorage = BlobStorage.deserialize(reader));
                    break;
                case 11:
                    message.noStartMavFromFT = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RaceTeam.deserialize(bytes);
    }
}
exports.RaceTeam = RaceTeam;
_RaceTeam_one_of_decls = new WeakMap();
class BlobStorage extends pb_1.Message {
    constructor(data) {
        super();
        _BlobStorage_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _BlobStorage_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("accountName" in data && data.accountName != undefined) {
                this.accountName = data.accountName;
            }
            if ("containers" in data && data.containers != undefined) {
                this.containers = data.containers;
            }
        }
    }
    get accountName() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set accountName(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get containers() {
        return pb_1.Message.getWrapperField(this, BlobContainers, 2);
    }
    set containers(value) {
        pb_1.Message.setWrapperField(this, 2, value);
    }
    get has_containers() {
        return pb_1.Message.getField(this, 2) != null;
    }
    static fromObject(data) {
        const message = new BlobStorage({});
        if (data.accountName != null) {
            message.accountName = data.accountName;
        }
        if (data.containers != null) {
            message.containers = BlobContainers.fromObject(data.containers);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.accountName != null) {
            data.accountName = this.accountName;
        }
        if (this.containers != null) {
            data.containers = this.containers.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.accountName.length)
            writer.writeString(1, this.accountName);
        if (this.has_containers)
            writer.writeMessage(2, this.containers, () => this.containers.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BlobStorage();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.accountName = reader.readString();
                    break;
                case 2:
                    reader.readMessage(message.containers, () => message.containers = BlobContainers.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return BlobStorage.deserialize(bytes);
    }
}
exports.BlobStorage = BlobStorage;
_BlobStorage_one_of_decls = new WeakMap();
class SoftwareLicense extends pb_1.Message {
    constructor(data) {
        super();
        _SoftwareLicense_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _SoftwareLicense_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("licenseType" in data && data.licenseType != undefined) {
                this.licenseType = data.licenseType;
            }
            if ("licenseServer" in data && data.licenseServer != undefined) {
                this.licenseServer = data.licenseServer;
            }
            if ("licensePort" in data && data.licensePort != undefined) {
                this.licensePort = data.licensePort;
            }
            if ("licensePath" in data && data.licensePath != undefined) {
                this.licensePath = data.licensePath;
            }
            if ("licenseFile" in data && data.licenseFile != undefined) {
                this.licenseFile = data.licenseFile;
            }
            if ("licenseKey" in data && data.licenseKey != undefined) {
                this.licenseKey = data.licenseKey;
            }
            if ("licenseUser" in data && data.licenseUser != undefined) {
                this.licenseUser = data.licenseUser;
            }
            if ("licensePassword" in data && data.licensePassword != undefined) {
                this.licensePassword = data.licensePassword;
            }
            if ("licenseVersion" in data && data.licenseVersion != undefined) {
                this.licenseVersion = data.licenseVersion;
            }
            if ("licenseVendor" in data && data.licenseVendor != undefined) {
                this.licenseVendor = data.licenseVendor;
            }
            if ("licenseFeature" in data && data.licenseFeature != undefined) {
                this.licenseFeature = data.licenseFeature;
            }
            if ("licenseCount" in data && data.licenseCount != undefined) {
                this.licenseCount = data.licenseCount;
            }
            if ("licenseExpiration" in data && data.licenseExpiration != undefined) {
                this.licenseExpiration = data.licenseExpiration;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get licenseType() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set licenseType(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get licenseServer() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set licenseServer(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get licensePort() {
        return pb_1.Message.getFieldWithDefault(this, 11, 0);
    }
    set licensePort(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get licensePath() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set licensePath(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get licenseFile() {
        return pb_1.Message.getFieldWithDefault(this, 13, "");
    }
    set licenseFile(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get licenseKey() {
        return pb_1.Message.getFieldWithDefault(this, 14, "");
    }
    set licenseKey(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get licenseUser() {
        return pb_1.Message.getFieldWithDefault(this, 15, "");
    }
    set licenseUser(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get licensePassword() {
        return pb_1.Message.getFieldWithDefault(this, 16, "");
    }
    set licensePassword(value) {
        pb_1.Message.setField(this, 16, value);
    }
    get licenseVersion() {
        return pb_1.Message.getFieldWithDefault(this, 17, "");
    }
    set licenseVersion(value) {
        pb_1.Message.setField(this, 17, value);
    }
    get licenseVendor() {
        return pb_1.Message.getFieldWithDefault(this, 18, "");
    }
    set licenseVendor(value) {
        pb_1.Message.setField(this, 18, value);
    }
    get licenseFeature() {
        return pb_1.Message.getFieldWithDefault(this, 19, "");
    }
    set licenseFeature(value) {
        pb_1.Message.setField(this, 19, value);
    }
    get licenseCount() {
        return pb_1.Message.getFieldWithDefault(this, 20, 0);
    }
    set licenseCount(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get licenseExpiration() {
        return pb_1.Message.getFieldWithDefault(this, 21, 0);
    }
    set licenseExpiration(value) {
        pb_1.Message.setField(this, 21, value);
    }
    static fromObject(data) {
        const message = new SoftwareLicense({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.licenseType != null) {
            message.licenseType = data.licenseType;
        }
        if (data.licenseServer != null) {
            message.licenseServer = data.licenseServer;
        }
        if (data.licensePort != null) {
            message.licensePort = data.licensePort;
        }
        if (data.licensePath != null) {
            message.licensePath = data.licensePath;
        }
        if (data.licenseFile != null) {
            message.licenseFile = data.licenseFile;
        }
        if (data.licenseKey != null) {
            message.licenseKey = data.licenseKey;
        }
        if (data.licenseUser != null) {
            message.licenseUser = data.licenseUser;
        }
        if (data.licensePassword != null) {
            message.licensePassword = data.licensePassword;
        }
        if (data.licenseVersion != null) {
            message.licenseVersion = data.licenseVersion;
        }
        if (data.licenseVendor != null) {
            message.licenseVendor = data.licenseVendor;
        }
        if (data.licenseFeature != null) {
            message.licenseFeature = data.licenseFeature;
        }
        if (data.licenseCount != null) {
            message.licenseCount = data.licenseCount;
        }
        if (data.licenseExpiration != null) {
            message.licenseExpiration = data.licenseExpiration;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.licenseType != null) {
            data.licenseType = this.licenseType;
        }
        if (this.licenseServer != null) {
            data.licenseServer = this.licenseServer;
        }
        if (this.licensePort != null) {
            data.licensePort = this.licensePort;
        }
        if (this.licensePath != null) {
            data.licensePath = this.licensePath;
        }
        if (this.licenseFile != null) {
            data.licenseFile = this.licenseFile;
        }
        if (this.licenseKey != null) {
            data.licenseKey = this.licenseKey;
        }
        if (this.licenseUser != null) {
            data.licenseUser = this.licenseUser;
        }
        if (this.licensePassword != null) {
            data.licensePassword = this.licensePassword;
        }
        if (this.licenseVersion != null) {
            data.licenseVersion = this.licenseVersion;
        }
        if (this.licenseVendor != null) {
            data.licenseVendor = this.licenseVendor;
        }
        if (this.licenseFeature != null) {
            data.licenseFeature = this.licenseFeature;
        }
        if (this.licenseCount != null) {
            data.licenseCount = this.licenseCount;
        }
        if (this.licenseExpiration != null) {
            data.licenseExpiration = this.licenseExpiration;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.name.length)
            writer.writeString(7, this.name);
        if (this.description.length)
            writer.writeString(8, this.description);
        if (this.licenseType.length)
            writer.writeString(9, this.licenseType);
        if (this.licenseServer.length)
            writer.writeString(10, this.licenseServer);
        if (this.licensePort != 0)
            writer.writeInt32(11, this.licensePort);
        if (this.licensePath.length)
            writer.writeString(12, this.licensePath);
        if (this.licenseFile.length)
            writer.writeString(13, this.licenseFile);
        if (this.licenseKey.length)
            writer.writeString(14, this.licenseKey);
        if (this.licenseUser.length)
            writer.writeString(15, this.licenseUser);
        if (this.licensePassword.length)
            writer.writeString(16, this.licensePassword);
        if (this.licenseVersion.length)
            writer.writeString(17, this.licenseVersion);
        if (this.licenseVendor.length)
            writer.writeString(18, this.licenseVendor);
        if (this.licenseFeature.length)
            writer.writeString(19, this.licenseFeature);
        if (this.licenseCount != 0)
            writer.writeInt32(20, this.licenseCount);
        if (this.licenseExpiration != 0)
            writer.writeInt64(21, this.licenseExpiration);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SoftwareLicense();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.name = reader.readString();
                    break;
                case 8:
                    message.description = reader.readString();
                    break;
                case 9:
                    message.licenseType = reader.readString();
                    break;
                case 10:
                    message.licenseServer = reader.readString();
                    break;
                case 11:
                    message.licensePort = reader.readInt32();
                    break;
                case 12:
                    message.licensePath = reader.readString();
                    break;
                case 13:
                    message.licenseFile = reader.readString();
                    break;
                case 14:
                    message.licenseKey = reader.readString();
                    break;
                case 15:
                    message.licenseUser = reader.readString();
                    break;
                case 16:
                    message.licensePassword = reader.readString();
                    break;
                case 17:
                    message.licenseVersion = reader.readString();
                    break;
                case 18:
                    message.licenseVendor = reader.readString();
                    break;
                case 19:
                    message.licenseFeature = reader.readString();
                    break;
                case 20:
                    message.licenseCount = reader.readInt32();
                    break;
                case 21:
                    message.licenseExpiration = reader.readInt64();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SoftwareLicense.deserialize(bytes);
    }
}
exports.SoftwareLicense = SoftwareLicense;
_SoftwareLicense_one_of_decls = new WeakMap();
class BlobContainers extends pb_1.Message {
    constructor(data) {
        super();
        _BlobContainers_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _BlobContainers_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("aeroGeometryStaging" in data && data.aeroGeometryStaging != undefined) {
                this.aeroGeometryStaging = data.aeroGeometryStaging;
            }
            if ("aeroWT" in data && data.aeroWT != undefined) {
                this.aeroWT = data.aeroWT;
            }
            if ("data" in data && data.data != undefined) {
                this.data = data.data;
            }
            if ("images" in data && data.images != undefined) {
                this.images = data.images;
            }
            if ("aeroPostProcess" in data && data.aeroPostProcess != undefined) {
                this.aeroPostProcess = data.aeroPostProcess;
            }
            if ("periscope" in data && data.periscope != undefined) {
                this.periscope = data.periscope;
            }
            if ("aeroVehicleStatesStaging" in data && data.aeroVehicleStatesStaging != undefined) {
                this.aeroVehicleStatesStaging = data.aeroVehicleStatesStaging;
            }
            if ("aeroMethodTemplateStaging" in data && data.aeroMethodTemplateStaging != undefined) {
                this.aeroMethodTemplateStaging = data.aeroMethodTemplateStaging;
            }
            if ("aeroMethodCodeStaging" in data && data.aeroMethodCodeStaging != undefined) {
                this.aeroMethodCodeStaging = data.aeroMethodCodeStaging;
            }
        }
    }
    get aeroGeometryStaging() {
        return pb_1.Message.getWrapperField(this, BlobContainer, 1);
    }
    set aeroGeometryStaging(value) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_aeroGeometryStaging() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get aeroWT() {
        return pb_1.Message.getWrapperField(this, BlobContainer, 2);
    }
    set aeroWT(value) {
        pb_1.Message.setWrapperField(this, 2, value);
    }
    get has_aeroWT() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get data() {
        return pb_1.Message.getWrapperField(this, BlobContainer, 3);
    }
    set data(value) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_data() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get images() {
        return pb_1.Message.getWrapperField(this, BlobContainer, 4);
    }
    set images(value) {
        pb_1.Message.setWrapperField(this, 4, value);
    }
    get has_images() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get aeroPostProcess() {
        return pb_1.Message.getWrapperField(this, BlobContainer, 5);
    }
    set aeroPostProcess(value) {
        pb_1.Message.setWrapperField(this, 5, value);
    }
    get has_aeroPostProcess() {
        return pb_1.Message.getField(this, 5) != null;
    }
    get periscope() {
        return pb_1.Message.getWrapperField(this, BlobContainer, 6);
    }
    set periscope(value) {
        pb_1.Message.setWrapperField(this, 6, value);
    }
    get has_periscope() {
        return pb_1.Message.getField(this, 6) != null;
    }
    get aeroVehicleStatesStaging() {
        return pb_1.Message.getWrapperField(this, BlobContainer, 7);
    }
    set aeroVehicleStatesStaging(value) {
        pb_1.Message.setWrapperField(this, 7, value);
    }
    get has_aeroVehicleStatesStaging() {
        return pb_1.Message.getField(this, 7) != null;
    }
    get aeroMethodTemplateStaging() {
        return pb_1.Message.getWrapperField(this, BlobContainer, 9);
    }
    set aeroMethodTemplateStaging(value) {
        pb_1.Message.setWrapperField(this, 9, value);
    }
    get has_aeroMethodTemplateStaging() {
        return pb_1.Message.getField(this, 9) != null;
    }
    get aeroMethodCodeStaging() {
        return pb_1.Message.getWrapperField(this, BlobContainer, 10);
    }
    set aeroMethodCodeStaging(value) {
        pb_1.Message.setWrapperField(this, 10, value);
    }
    get has_aeroMethodCodeStaging() {
        return pb_1.Message.getField(this, 10) != null;
    }
    static fromObject(data) {
        const message = new BlobContainers({});
        if (data.aeroGeometryStaging != null) {
            message.aeroGeometryStaging = BlobContainer.fromObject(data.aeroGeometryStaging);
        }
        if (data.aeroWT != null) {
            message.aeroWT = BlobContainer.fromObject(data.aeroWT);
        }
        if (data.data != null) {
            message.data = BlobContainer.fromObject(data.data);
        }
        if (data.images != null) {
            message.images = BlobContainer.fromObject(data.images);
        }
        if (data.aeroPostProcess != null) {
            message.aeroPostProcess = BlobContainer.fromObject(data.aeroPostProcess);
        }
        if (data.periscope != null) {
            message.periscope = BlobContainer.fromObject(data.periscope);
        }
        if (data.aeroVehicleStatesStaging != null) {
            message.aeroVehicleStatesStaging = BlobContainer.fromObject(data.aeroVehicleStatesStaging);
        }
        if (data.aeroMethodTemplateStaging != null) {
            message.aeroMethodTemplateStaging = BlobContainer.fromObject(data.aeroMethodTemplateStaging);
        }
        if (data.aeroMethodCodeStaging != null) {
            message.aeroMethodCodeStaging = BlobContainer.fromObject(data.aeroMethodCodeStaging);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.aeroGeometryStaging != null) {
            data.aeroGeometryStaging = this.aeroGeometryStaging.toObject();
        }
        if (this.aeroWT != null) {
            data.aeroWT = this.aeroWT.toObject();
        }
        if (this.data != null) {
            data.data = this.data.toObject();
        }
        if (this.images != null) {
            data.images = this.images.toObject();
        }
        if (this.aeroPostProcess != null) {
            data.aeroPostProcess = this.aeroPostProcess.toObject();
        }
        if (this.periscope != null) {
            data.periscope = this.periscope.toObject();
        }
        if (this.aeroVehicleStatesStaging != null) {
            data.aeroVehicleStatesStaging = this.aeroVehicleStatesStaging.toObject();
        }
        if (this.aeroMethodTemplateStaging != null) {
            data.aeroMethodTemplateStaging = this.aeroMethodTemplateStaging.toObject();
        }
        if (this.aeroMethodCodeStaging != null) {
            data.aeroMethodCodeStaging = this.aeroMethodCodeStaging.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_aeroGeometryStaging)
            writer.writeMessage(1, this.aeroGeometryStaging, () => this.aeroGeometryStaging.serialize(writer));
        if (this.has_aeroWT)
            writer.writeMessage(2, this.aeroWT, () => this.aeroWT.serialize(writer));
        if (this.has_data)
            writer.writeMessage(3, this.data, () => this.data.serialize(writer));
        if (this.has_images)
            writer.writeMessage(4, this.images, () => this.images.serialize(writer));
        if (this.has_aeroPostProcess)
            writer.writeMessage(5, this.aeroPostProcess, () => this.aeroPostProcess.serialize(writer));
        if (this.has_periscope)
            writer.writeMessage(6, this.periscope, () => this.periscope.serialize(writer));
        if (this.has_aeroVehicleStatesStaging)
            writer.writeMessage(7, this.aeroVehicleStatesStaging, () => this.aeroVehicleStatesStaging.serialize(writer));
        if (this.has_aeroMethodTemplateStaging)
            writer.writeMessage(9, this.aeroMethodTemplateStaging, () => this.aeroMethodTemplateStaging.serialize(writer));
        if (this.has_aeroMethodCodeStaging)
            writer.writeMessage(10, this.aeroMethodCodeStaging, () => this.aeroMethodCodeStaging.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BlobContainers();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.aeroGeometryStaging, () => message.aeroGeometryStaging = BlobContainer.deserialize(reader));
                    break;
                case 2:
                    reader.readMessage(message.aeroWT, () => message.aeroWT = BlobContainer.deserialize(reader));
                    break;
                case 3:
                    reader.readMessage(message.data, () => message.data = BlobContainer.deserialize(reader));
                    break;
                case 4:
                    reader.readMessage(message.images, () => message.images = BlobContainer.deserialize(reader));
                    break;
                case 5:
                    reader.readMessage(message.aeroPostProcess, () => message.aeroPostProcess = BlobContainer.deserialize(reader));
                    break;
                case 6:
                    reader.readMessage(message.periscope, () => message.periscope = BlobContainer.deserialize(reader));
                    break;
                case 7:
                    reader.readMessage(message.aeroVehicleStatesStaging, () => message.aeroVehicleStatesStaging = BlobContainer.deserialize(reader));
                    break;
                case 9:
                    reader.readMessage(message.aeroMethodTemplateStaging, () => message.aeroMethodTemplateStaging = BlobContainer.deserialize(reader));
                    break;
                case 10:
                    reader.readMessage(message.aeroMethodCodeStaging, () => message.aeroMethodCodeStaging = BlobContainer.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return BlobContainers.deserialize(bytes);
    }
}
exports.BlobContainers = BlobContainers;
_BlobContainers_one_of_decls = new WeakMap();
class BlobContainer extends pb_1.Message {
    constructor(data) {
        super();
        _BlobContainer_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _BlobContainer_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("inputDirName" in data && data.inputDirName != undefined) {
                this.inputDirName = data.inputDirName;
            }
            if ("outputDirName" in data && data.outputDirName != undefined) {
                this.outputDirName = data.outputDirName;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get inputDirName() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set inputDirName(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get outputDirName() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set outputDirName(value) {
        pb_1.Message.setField(this, 3, value);
    }
    static fromObject(data) {
        const message = new BlobContainer({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.inputDirName != null) {
            message.inputDirName = data.inputDirName;
        }
        if (data.outputDirName != null) {
            message.outputDirName = data.outputDirName;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.inputDirName != null) {
            data.inputDirName = this.inputDirName;
        }
        if (this.outputDirName != null) {
            data.outputDirName = this.outputDirName;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.inputDirName.length)
            writer.writeString(2, this.inputDirName);
        if (this.outputDirName.length)
            writer.writeString(3, this.outputDirName);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BlobContainer();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.inputDirName = reader.readString();
                    break;
                case 3:
                    message.outputDirName = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return BlobContainer.deserialize(bytes);
    }
}
exports.BlobContainer = BlobContainer;
_BlobContainer_one_of_decls = new WeakMap();
class Vehicle extends pb_1.Message {
    constructor(data) {
        super();
        _Vehicle_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [14, 15, 18], __classPrivateFieldGet(this, _Vehicle_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("vehicleId" in data && data.vehicleId != undefined) {
                this.vehicleId = data.vehicleId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("model" in data && data.model != undefined) {
                this.model = data.model;
            }
            if ("year" in data && data.year != undefined) {
                this.year = data.year;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("attitudeSets" in data && data.attitudeSets != undefined) {
                this.attitudeSets = data.attitudeSets;
            }
            if ("permissions" in data && data.permissions != undefined) {
                this.permissions = data.permissions;
            }
            if ("series" in data && data.series != undefined) {
                this.series = data.series;
            }
            if ("projSequence" in data && data.projSequence != undefined) {
                this.projSequence = data.projSequence;
            }
            if ("methodSets" in data && data.methodSets != undefined) {
                this.methodSets = data.methodSets;
            }
            if ("length_m" in data && data.length_m != undefined) {
                this.length_m = data.length_m;
            }
            if ("width_m" in data && data.width_m != undefined) {
                this.width_m = data.width_m;
            }
            if ("height_m" in data && data.height_m != undefined) {
                this.height_m = data.height_m;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get vehicleId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set vehicleId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get model() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set model(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get year() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set year(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get attitudeSets() {
        return pb_1.Message.getRepeatedWrapperField(this, AttitudeSet, 14);
    }
    set attitudeSets(value) {
        pb_1.Message.setRepeatedWrapperField(this, 14, value);
    }
    get permissions() {
        return pb_1.Message.getFieldWithDefault(this, 15, []);
    }
    set permissions(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get series() {
        return pb_1.Message.getFieldWithDefault(this, 16, Series.NO_SERIES);
    }
    set series(value) {
        pb_1.Message.setField(this, 16, value);
    }
    get projSequence() {
        return pb_1.Message.getFieldWithDefault(this, 17, 0);
    }
    set projSequence(value) {
        pb_1.Message.setField(this, 17, value);
    }
    get methodSets() {
        return pb_1.Message.getRepeatedWrapperField(this, MethodologySet, 18);
    }
    set methodSets(value) {
        pb_1.Message.setRepeatedWrapperField(this, 18, value);
    }
    get length_m() {
        return pb_1.Message.getFieldWithDefault(this, 19, 0);
    }
    set length_m(value) {
        pb_1.Message.setField(this, 19, value);
    }
    get width_m() {
        return pb_1.Message.getFieldWithDefault(this, 20, 0);
    }
    set width_m(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get height_m() {
        return pb_1.Message.getFieldWithDefault(this, 21, 0);
    }
    set height_m(value) {
        pb_1.Message.setField(this, 21, value);
    }
    static fromObject(data) {
        const message = new Vehicle({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.vehicleId != null) {
            message.vehicleId = data.vehicleId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.model != null) {
            message.model = data.model;
        }
        if (data.year != null) {
            message.year = data.year;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.attitudeSets != null) {
            message.attitudeSets = data.attitudeSets.map(item => AttitudeSet.fromObject(item));
        }
        if (data.permissions != null) {
            message.permissions = data.permissions;
        }
        if (data.series != null) {
            message.series = data.series;
        }
        if (data.projSequence != null) {
            message.projSequence = data.projSequence;
        }
        if (data.methodSets != null) {
            message.methodSets = data.methodSets.map(item => MethodologySet.fromObject(item));
        }
        if (data.length_m != null) {
            message.length_m = data.length_m;
        }
        if (data.width_m != null) {
            message.width_m = data.width_m;
        }
        if (data.height_m != null) {
            message.height_m = data.height_m;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.vehicleId != null) {
            data.vehicleId = this.vehicleId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.model != null) {
            data.model = this.model;
        }
        if (this.year != null) {
            data.year = this.year;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.attitudeSets != null) {
            data.attitudeSets = this.attitudeSets.map((item) => item.toObject());
        }
        if (this.permissions != null) {
            data.permissions = this.permissions;
        }
        if (this.series != null) {
            data.series = this.series;
        }
        if (this.projSequence != null) {
            data.projSequence = this.projSequence;
        }
        if (this.methodSets != null) {
            data.methodSets = this.methodSets.map((item) => item.toObject());
        }
        if (this.length_m != null) {
            data.length_m = this.length_m;
        }
        if (this.width_m != null) {
            data.width_m = this.width_m;
        }
        if (this.height_m != null) {
            data.height_m = this.height_m;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.vehicleId.length)
            writer.writeString(2, this.vehicleId);
        if (this._id.length)
            writer.writeString(3, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.name.length)
            writer.writeString(8, this.name);
        if (this.model.length)
            writer.writeString(9, this.model);
        if (this.year.length)
            writer.writeString(10, this.year);
        if (this.description.length)
            writer.writeString(11, this.description);
        if (this.attitudeSets.length)
            writer.writeRepeatedMessage(14, this.attitudeSets, (item) => item.serialize(writer));
        if (this.permissions.length)
            writer.writeRepeatedString(15, this.permissions);
        if (this.series != Series.NO_SERIES)
            writer.writeEnum(16, this.series);
        if (this.projSequence != 0)
            writer.writeInt64(17, this.projSequence);
        if (this.methodSets.length)
            writer.writeRepeatedMessage(18, this.methodSets, (item) => item.serialize(writer));
        if (this.length_m != 0)
            writer.writeFloat(19, this.length_m);
        if (this.width_m != 0)
            writer.writeFloat(20, this.width_m);
        if (this.height_m != 0)
            writer.writeFloat(21, this.height_m);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Vehicle();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.vehicleId = reader.readString();
                    break;
                case 3:
                    message._id = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.name = reader.readString();
                    break;
                case 9:
                    message.model = reader.readString();
                    break;
                case 10:
                    message.year = reader.readString();
                    break;
                case 11:
                    message.description = reader.readString();
                    break;
                case 14:
                    reader.readMessage(message.attitudeSets, () => pb_1.Message.addToRepeatedWrapperField(message, 14, AttitudeSet.deserialize(reader), AttitudeSet));
                    break;
                case 15:
                    pb_1.Message.addToRepeatedField(message, 15, reader.readString());
                    break;
                case 16:
                    message.series = reader.readEnum();
                    break;
                case 17:
                    message.projSequence = reader.readInt64();
                    break;
                case 18:
                    reader.readMessage(message.methodSets, () => pb_1.Message.addToRepeatedWrapperField(message, 18, MethodologySet.deserialize(reader), MethodologySet));
                    break;
                case 19:
                    message.length_m = reader.readFloat();
                    break;
                case 20:
                    message.width_m = reader.readFloat();
                    break;
                case 21:
                    message.height_m = reader.readFloat();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Vehicle.deserialize(bytes);
    }
}
exports.Vehicle = Vehicle;
_Vehicle_one_of_decls = new WeakMap();
class Project extends pb_1.Message {
    constructor(data) {
        super();
        _Project_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [19, 21, 30], __classPrivateFieldGet(this, _Project_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("projectId" in data && data.projectId != undefined) {
                this.projectId = data.projectId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("createByUserName" in data && data.createByUserName != undefined) {
                this.createByUserName = data.createByUserName;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("engineer" in data && data.engineer != undefined) {
                this.engineer = data.engineer;
            }
            if ("status" in data && data.status != undefined) {
                this.status = data.status;
            }
            if ("methodSet" in data && data.methodSet != undefined) {
                this.methodSet = data.methodSet;
            }
            if ("attitudeSet" in data && data.attitudeSet != undefined) {
                this.attitudeSet = data.attitudeSet;
            }
            if ("tyreSet" in data && data.tyreSet != undefined) {
                this.tyreSet = data.tyreSet;
            }
            if ("domainSet" in data && data.domainSet != undefined) {
                this.domainSet = data.domainSet;
            }
            if ("simulationSet" in data && data.simulationSet != undefined) {
                this.simulationSet = data.simulationSet;
            }
            if ("geometryList" in data && data.geometryList != undefined) {
                this.geometryList = data.geometryList;
            }
            if ("vehicleId" in data && data.vehicleId != undefined) {
                this.vehicleId = data.vehicleId;
            }
            if ("adminDocuments" in data && data.adminDocuments != undefined) {
                this.adminDocuments = data.adminDocuments;
            }
            if ("currentRunId" in data && data.currentRunId != undefined) {
                this.currentRunId = data.currentRunId;
            }
            if ("startDate" in data && data.startDate != undefined) {
                this.startDate = data.startDate;
            }
            if ("endDate" in data && data.endDate != undefined) {
                this.endDate = data.endDate;
            }
            if ("baselineGeometry" in data && data.baselineGeometry != undefined) {
                this.baselineGeometry = data.baselineGeometry;
            }
            if ("outputParams" in data && data.outputParams != undefined) {
                this.outputParams = data.outputParams;
            }
            if ("externalDocumentUrl" in data && data.externalDocumentUrl != undefined) {
                this.externalDocumentUrl = data.externalDocumentUrl;
            }
            if ("area" in data && data.area != undefined) {
                this.area = data.area;
            }
            if ("baselineSubmissionTemplate" in data && data.baselineSubmissionTemplate != undefined) {
                this.baselineSubmissionTemplate = data.baselineSubmissionTemplate;
            }
            if ("contributors" in data && data.contributors != undefined) {
                this.contributors = data.contributors;
            }
            if ("referenceRun" in data && data.referenceRun != undefined) {
                this.referenceRun = data.referenceRun;
            }
            if ("projectConfig" in data && data.projectConfig != undefined) {
                this.projectConfig = data.projectConfig;
            }
            if ("isBaseline" in data && data.isBaseline != undefined) {
                this.isBaseline = data.isBaseline;
            }
            if ("runSequence" in data && data.runSequence != undefined) {
                this.runSequence = data.runSequence;
            }
            if ("shortName" in data && data.shortName != undefined) {
                this.shortName = data.shortName;
            }
            if ("referenceRunName" in data && data.referenceRunName != undefined) {
                this.referenceRunName = data.referenceRunName;
            }
            if ("baselineRunId" in data && data.baselineRunId != undefined) {
                this.baselineRunId = data.baselineRunId;
            }
            if ("baselineRunName" in data && data.baselineRunName != undefined) {
                this.baselineRunName = data.baselineRunName;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get projectId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set projectId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get createByUserName() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set createByUserName(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get engineer() {
        return pb_1.Message.getWrapperField(this, User, 11);
    }
    set engineer(value) {
        pb_1.Message.setWrapperField(this, 11, value);
    }
    get has_engineer() {
        return pb_1.Message.getField(this, 11) != null;
    }
    get status() {
        return pb_1.Message.getFieldWithDefault(this, 12, ProjectStatus.NOT_USED);
    }
    set status(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get methodSet() {
        return pb_1.Message.getWrapperField(this, MethodologySet, 14);
    }
    set methodSet(value) {
        pb_1.Message.setWrapperField(this, 14, value);
    }
    get has_methodSet() {
        return pb_1.Message.getField(this, 14) != null;
    }
    get attitudeSet() {
        return pb_1.Message.getWrapperField(this, AttitudeSet, 15);
    }
    set attitudeSet(value) {
        pb_1.Message.setWrapperField(this, 15, value);
    }
    get has_attitudeSet() {
        return pb_1.Message.getField(this, 15) != null;
    }
    get tyreSet() {
        return pb_1.Message.getWrapperField(this, TyreSet, 16);
    }
    set tyreSet(value) {
        pb_1.Message.setWrapperField(this, 16, value);
    }
    get has_tyreSet() {
        return pb_1.Message.getField(this, 16) != null;
    }
    get domainSet() {
        return pb_1.Message.getWrapperField(this, DomainSet, 17);
    }
    set domainSet(value) {
        pb_1.Message.setWrapperField(this, 17, value);
    }
    get has_domainSet() {
        return pb_1.Message.getField(this, 17) != null;
    }
    get simulationSet() {
        return pb_1.Message.getWrapperField(this, SimulationSet, 18);
    }
    set simulationSet(value) {
        pb_1.Message.setWrapperField(this, 18, value);
    }
    get has_simulationSet() {
        return pb_1.Message.getField(this, 18) != null;
    }
    get geometryList() {
        return pb_1.Message.getRepeatedWrapperField(this, Geometry, 19);
    }
    set geometryList(value) {
        pb_1.Message.setRepeatedWrapperField(this, 19, value);
    }
    get vehicleId() {
        return pb_1.Message.getFieldWithDefault(this, 20, "");
    }
    set vehicleId(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get adminDocuments() {
        return pb_1.Message.getRepeatedWrapperField(this, ProjectDocument, 21);
    }
    set adminDocuments(value) {
        pb_1.Message.setRepeatedWrapperField(this, 21, value);
    }
    get currentRunId() {
        return pb_1.Message.getFieldWithDefault(this, 22, "");
    }
    set currentRunId(value) {
        pb_1.Message.setField(this, 22, value);
    }
    get startDate() {
        return pb_1.Message.getFieldWithDefault(this, 23, 0);
    }
    set startDate(value) {
        pb_1.Message.setField(this, 23, value);
    }
    get endDate() {
        return pb_1.Message.getFieldWithDefault(this, 24, 0);
    }
    set endDate(value) {
        pb_1.Message.setField(this, 24, value);
    }
    get baselineGeometry() {
        return pb_1.Message.getWrapperField(this, Geometry, 25);
    }
    set baselineGeometry(value) {
        pb_1.Message.setWrapperField(this, 25, value);
    }
    get has_baselineGeometry() {
        return pb_1.Message.getField(this, 25) != null;
    }
    get outputParams() {
        return pb_1.Message.getFieldWithDefault(this, 26, "");
    }
    set outputParams(value) {
        pb_1.Message.setField(this, 26, value);
    }
    get externalDocumentUrl() {
        return pb_1.Message.getFieldWithDefault(this, 27, "");
    }
    set externalDocumentUrl(value) {
        pb_1.Message.setField(this, 27, value);
    }
    get area() {
        return pb_1.Message.getFieldWithDefault(this, 28, "");
    }
    set area(value) {
        pb_1.Message.setField(this, 28, value);
    }
    get baselineSubmissionTemplate() {
        return pb_1.Message.getFieldWithDefault(this, 29, "");
    }
    set baselineSubmissionTemplate(value) {
        pb_1.Message.setField(this, 29, value);
    }
    get contributors() {
        return pb_1.Message.getRepeatedWrapperField(this, User, 30);
    }
    set contributors(value) {
        pb_1.Message.setRepeatedWrapperField(this, 30, value);
    }
    get referenceRun() {
        return pb_1.Message.getFieldWithDefault(this, 31, "");
    }
    set referenceRun(value) {
        pb_1.Message.setField(this, 31, value);
    }
    get projectConfig() {
        return pb_1.Message.getWrapperField(this, ProjectConfig, 32);
    }
    set projectConfig(value) {
        pb_1.Message.setWrapperField(this, 32, value);
    }
    get has_projectConfig() {
        return pb_1.Message.getField(this, 32) != null;
    }
    get isBaseline() {
        return pb_1.Message.getFieldWithDefault(this, 33, false);
    }
    set isBaseline(value) {
        pb_1.Message.setField(this, 33, value);
    }
    get runSequence() {
        return pb_1.Message.getFieldWithDefault(this, 34, 0);
    }
    set runSequence(value) {
        pb_1.Message.setField(this, 34, value);
    }
    get shortName() {
        return pb_1.Message.getFieldWithDefault(this, 35, "");
    }
    set shortName(value) {
        pb_1.Message.setField(this, 35, value);
    }
    get referenceRunName() {
        return pb_1.Message.getFieldWithDefault(this, 36, "");
    }
    set referenceRunName(value) {
        pb_1.Message.setField(this, 36, value);
    }
    get baselineRunId() {
        return pb_1.Message.getFieldWithDefault(this, 37, "");
    }
    set baselineRunId(value) {
        pb_1.Message.setField(this, 37, value);
    }
    get baselineRunName() {
        return pb_1.Message.getFieldWithDefault(this, 38, "");
    }
    set baselineRunName(value) {
        pb_1.Message.setField(this, 38, value);
    }
    static fromObject(data) {
        const message = new Project({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.projectId != null) {
            message.projectId = data.projectId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.createByUserName != null) {
            message.createByUserName = data.createByUserName;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.engineer != null) {
            message.engineer = User.fromObject(data.engineer);
        }
        if (data.status != null) {
            message.status = data.status;
        }
        if (data.methodSet != null) {
            message.methodSet = MethodologySet.fromObject(data.methodSet);
        }
        if (data.attitudeSet != null) {
            message.attitudeSet = AttitudeSet.fromObject(data.attitudeSet);
        }
        if (data.tyreSet != null) {
            message.tyreSet = TyreSet.fromObject(data.tyreSet);
        }
        if (data.domainSet != null) {
            message.domainSet = DomainSet.fromObject(data.domainSet);
        }
        if (data.simulationSet != null) {
            message.simulationSet = SimulationSet.fromObject(data.simulationSet);
        }
        if (data.geometryList != null) {
            message.geometryList = data.geometryList.map(item => Geometry.fromObject(item));
        }
        if (data.vehicleId != null) {
            message.vehicleId = data.vehicleId;
        }
        if (data.adminDocuments != null) {
            message.adminDocuments = data.adminDocuments.map(item => ProjectDocument.fromObject(item));
        }
        if (data.currentRunId != null) {
            message.currentRunId = data.currentRunId;
        }
        if (data.startDate != null) {
            message.startDate = data.startDate;
        }
        if (data.endDate != null) {
            message.endDate = data.endDate;
        }
        if (data.baselineGeometry != null) {
            message.baselineGeometry = Geometry.fromObject(data.baselineGeometry);
        }
        if (data.outputParams != null) {
            message.outputParams = data.outputParams;
        }
        if (data.externalDocumentUrl != null) {
            message.externalDocumentUrl = data.externalDocumentUrl;
        }
        if (data.area != null) {
            message.area = data.area;
        }
        if (data.baselineSubmissionTemplate != null) {
            message.baselineSubmissionTemplate = data.baselineSubmissionTemplate;
        }
        if (data.contributors != null) {
            message.contributors = data.contributors.map(item => User.fromObject(item));
        }
        if (data.referenceRun != null) {
            message.referenceRun = data.referenceRun;
        }
        if (data.projectConfig != null) {
            message.projectConfig = ProjectConfig.fromObject(data.projectConfig);
        }
        if (data.isBaseline != null) {
            message.isBaseline = data.isBaseline;
        }
        if (data.runSequence != null) {
            message.runSequence = data.runSequence;
        }
        if (data.shortName != null) {
            message.shortName = data.shortName;
        }
        if (data.referenceRunName != null) {
            message.referenceRunName = data.referenceRunName;
        }
        if (data.baselineRunId != null) {
            message.baselineRunId = data.baselineRunId;
        }
        if (data.baselineRunName != null) {
            message.baselineRunName = data.baselineRunName;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.projectId != null) {
            data.projectId = this.projectId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.createByUserName != null) {
            data.createByUserName = this.createByUserName;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.engineer != null) {
            data.engineer = this.engineer.toObject();
        }
        if (this.status != null) {
            data.status = this.status;
        }
        if (this.methodSet != null) {
            data.methodSet = this.methodSet.toObject();
        }
        if (this.attitudeSet != null) {
            data.attitudeSet = this.attitudeSet.toObject();
        }
        if (this.tyreSet != null) {
            data.tyreSet = this.tyreSet.toObject();
        }
        if (this.domainSet != null) {
            data.domainSet = this.domainSet.toObject();
        }
        if (this.simulationSet != null) {
            data.simulationSet = this.simulationSet.toObject();
        }
        if (this.geometryList != null) {
            data.geometryList = this.geometryList.map((item) => item.toObject());
        }
        if (this.vehicleId != null) {
            data.vehicleId = this.vehicleId;
        }
        if (this.adminDocuments != null) {
            data.adminDocuments = this.adminDocuments.map((item) => item.toObject());
        }
        if (this.currentRunId != null) {
            data.currentRunId = this.currentRunId;
        }
        if (this.startDate != null) {
            data.startDate = this.startDate;
        }
        if (this.endDate != null) {
            data.endDate = this.endDate;
        }
        if (this.baselineGeometry != null) {
            data.baselineGeometry = this.baselineGeometry.toObject();
        }
        if (this.outputParams != null) {
            data.outputParams = this.outputParams;
        }
        if (this.externalDocumentUrl != null) {
            data.externalDocumentUrl = this.externalDocumentUrl;
        }
        if (this.area != null) {
            data.area = this.area;
        }
        if (this.baselineSubmissionTemplate != null) {
            data.baselineSubmissionTemplate = this.baselineSubmissionTemplate;
        }
        if (this.contributors != null) {
            data.contributors = this.contributors.map((item) => item.toObject());
        }
        if (this.referenceRun != null) {
            data.referenceRun = this.referenceRun;
        }
        if (this.projectConfig != null) {
            data.projectConfig = this.projectConfig.toObject();
        }
        if (this.isBaseline != null) {
            data.isBaseline = this.isBaseline;
        }
        if (this.runSequence != null) {
            data.runSequence = this.runSequence;
        }
        if (this.shortName != null) {
            data.shortName = this.shortName;
        }
        if (this.referenceRunName != null) {
            data.referenceRunName = this.referenceRunName;
        }
        if (this.baselineRunId != null) {
            data.baselineRunId = this.baselineRunId;
        }
        if (this.baselineRunName != null) {
            data.baselineRunName = this.baselineRunName;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.projectId.length)
            writer.writeString(2, this.projectId);
        if (this._id.length)
            writer.writeString(3, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.createByUserName.length)
            writer.writeString(8, this.createByUserName);
        if (this.name.length)
            writer.writeString(9, this.name);
        if (this.description.length)
            writer.writeString(10, this.description);
        if (this.has_engineer)
            writer.writeMessage(11, this.engineer, () => this.engineer.serialize(writer));
        if (this.status != ProjectStatus.NOT_USED)
            writer.writeEnum(12, this.status);
        if (this.has_methodSet)
            writer.writeMessage(14, this.methodSet, () => this.methodSet.serialize(writer));
        if (this.has_attitudeSet)
            writer.writeMessage(15, this.attitudeSet, () => this.attitudeSet.serialize(writer));
        if (this.has_tyreSet)
            writer.writeMessage(16, this.tyreSet, () => this.tyreSet.serialize(writer));
        if (this.has_domainSet)
            writer.writeMessage(17, this.domainSet, () => this.domainSet.serialize(writer));
        if (this.has_simulationSet)
            writer.writeMessage(18, this.simulationSet, () => this.simulationSet.serialize(writer));
        if (this.geometryList.length)
            writer.writeRepeatedMessage(19, this.geometryList, (item) => item.serialize(writer));
        if (this.vehicleId.length)
            writer.writeString(20, this.vehicleId);
        if (this.adminDocuments.length)
            writer.writeRepeatedMessage(21, this.adminDocuments, (item) => item.serialize(writer));
        if (this.currentRunId.length)
            writer.writeString(22, this.currentRunId);
        if (this.startDate != 0)
            writer.writeInt64(23, this.startDate);
        if (this.endDate != 0)
            writer.writeInt64(24, this.endDate);
        if (this.has_baselineGeometry)
            writer.writeMessage(25, this.baselineGeometry, () => this.baselineGeometry.serialize(writer));
        if (this.outputParams.length)
            writer.writeString(26, this.outputParams);
        if (this.externalDocumentUrl.length)
            writer.writeString(27, this.externalDocumentUrl);
        if (this.area.length)
            writer.writeString(28, this.area);
        if (this.baselineSubmissionTemplate.length)
            writer.writeString(29, this.baselineSubmissionTemplate);
        if (this.contributors.length)
            writer.writeRepeatedMessage(30, this.contributors, (item) => item.serialize(writer));
        if (this.referenceRun.length)
            writer.writeString(31, this.referenceRun);
        if (this.has_projectConfig)
            writer.writeMessage(32, this.projectConfig, () => this.projectConfig.serialize(writer));
        if (this.isBaseline != false)
            writer.writeBool(33, this.isBaseline);
        if (this.runSequence != 0)
            writer.writeInt64(34, this.runSequence);
        if (this.shortName.length)
            writer.writeString(35, this.shortName);
        if (this.referenceRunName.length)
            writer.writeString(36, this.referenceRunName);
        if (this.baselineRunId.length)
            writer.writeString(37, this.baselineRunId);
        if (this.baselineRunName.length)
            writer.writeString(38, this.baselineRunName);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Project();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.projectId = reader.readString();
                    break;
                case 3:
                    message._id = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.createByUserName = reader.readString();
                    break;
                case 9:
                    message.name = reader.readString();
                    break;
                case 10:
                    message.description = reader.readString();
                    break;
                case 11:
                    reader.readMessage(message.engineer, () => message.engineer = User.deserialize(reader));
                    break;
                case 12:
                    message.status = reader.readEnum();
                    break;
                case 14:
                    reader.readMessage(message.methodSet, () => message.methodSet = MethodologySet.deserialize(reader));
                    break;
                case 15:
                    reader.readMessage(message.attitudeSet, () => message.attitudeSet = AttitudeSet.deserialize(reader));
                    break;
                case 16:
                    reader.readMessage(message.tyreSet, () => message.tyreSet = TyreSet.deserialize(reader));
                    break;
                case 17:
                    reader.readMessage(message.domainSet, () => message.domainSet = DomainSet.deserialize(reader));
                    break;
                case 18:
                    reader.readMessage(message.simulationSet, () => message.simulationSet = SimulationSet.deserialize(reader));
                    break;
                case 19:
                    reader.readMessage(message.geometryList, () => pb_1.Message.addToRepeatedWrapperField(message, 19, Geometry.deserialize(reader), Geometry));
                    break;
                case 20:
                    message.vehicleId = reader.readString();
                    break;
                case 21:
                    reader.readMessage(message.adminDocuments, () => pb_1.Message.addToRepeatedWrapperField(message, 21, ProjectDocument.deserialize(reader), ProjectDocument));
                    break;
                case 22:
                    message.currentRunId = reader.readString();
                    break;
                case 23:
                    message.startDate = reader.readInt64();
                    break;
                case 24:
                    message.endDate = reader.readInt64();
                    break;
                case 25:
                    reader.readMessage(message.baselineGeometry, () => message.baselineGeometry = Geometry.deserialize(reader));
                    break;
                case 26:
                    message.outputParams = reader.readString();
                    break;
                case 27:
                    message.externalDocumentUrl = reader.readString();
                    break;
                case 28:
                    message.area = reader.readString();
                    break;
                case 29:
                    message.baselineSubmissionTemplate = reader.readString();
                    break;
                case 30:
                    reader.readMessage(message.contributors, () => pb_1.Message.addToRepeatedWrapperField(message, 30, User.deserialize(reader), User));
                    break;
                case 31:
                    message.referenceRun = reader.readString();
                    break;
                case 32:
                    reader.readMessage(message.projectConfig, () => message.projectConfig = ProjectConfig.deserialize(reader));
                    break;
                case 33:
                    message.isBaseline = reader.readBool();
                    break;
                case 34:
                    message.runSequence = reader.readInt64();
                    break;
                case 35:
                    message.shortName = reader.readString();
                    break;
                case 36:
                    message.referenceRunName = reader.readString();
                    break;
                case 37:
                    message.baselineRunId = reader.readString();
                    break;
                case 38:
                    message.baselineRunName = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Project.deserialize(bytes);
    }
}
exports.Project = Project;
_Project_one_of_decls = new WeakMap();
class ProjectConfig extends pb_1.Message {
    constructor(data) {
        super();
        _ProjectConfig_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _ProjectConfig_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("projectConfigId" in data && data.projectConfigId != undefined) {
                this.projectConfigId = data.projectConfigId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("configJSON" in data && data.configJSON != undefined) {
                this.configJSON = data.configJSON;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get projectConfigId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set projectConfigId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get configJSON() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set configJSON(value) {
        pb_1.Message.setField(this, 10, value);
    }
    static fromObject(data) {
        const message = new ProjectConfig({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.projectConfigId != null) {
            message.projectConfigId = data.projectConfigId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.configJSON != null) {
            message.configJSON = data.configJSON;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.projectConfigId != null) {
            data.projectConfigId = this.projectConfigId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.configJSON != null) {
            data.configJSON = this.configJSON;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.projectConfigId.length)
            writer.writeString(2, this.projectConfigId);
        if (this._id.length)
            writer.writeString(3, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.name.length)
            writer.writeString(8, this.name);
        if (this.description.length)
            writer.writeString(9, this.description);
        if (this.configJSON.length)
            writer.writeString(10, this.configJSON);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ProjectConfig();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.projectConfigId = reader.readString();
                    break;
                case 3:
                    message._id = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.name = reader.readString();
                    break;
                case 9:
                    message.description = reader.readString();
                    break;
                case 10:
                    message.configJSON = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return ProjectConfig.deserialize(bytes);
    }
}
exports.ProjectConfig = ProjectConfig;
_ProjectConfig_one_of_decls = new WeakMap();
class OutputParameter extends pb_1.Message {
    constructor(data) {
        super();
        _OutputParameter_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _OutputParameter_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("value" in data && data.value != undefined) {
                this.value = data.value;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get value() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set value(value) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data) {
        const message = new OutputParameter({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.value != null) {
            message.value = data.value;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.value != null) {
            data.value = this.value;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.value.length)
            writer.writeString(2, this.value);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new OutputParameter();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.value = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return OutputParameter.deserialize(bytes);
    }
}
exports.OutputParameter = OutputParameter;
_OutputParameter_one_of_decls = new WeakMap();
class WorkflowSubmission extends pb_1.Message {
    constructor(data) {
        super();
        _WorkflowSubmission_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [23, 24], __classPrivateFieldGet(this, _WorkflowSubmission_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("createByUserName" in data && data.createByUserName != undefined) {
                this.createByUserName = data.createByUserName;
            }
            if ("workflowSubmissionId" in data && data.workflowSubmissionId != undefined) {
                this.workflowSubmissionId = data.workflowSubmissionId;
            }
            if ("submitDate" in data && data.submitDate != undefined) {
                this.submitDate = data.submitDate;
            }
            if ("submitByUser" in data && data.submitByUser != undefined) {
                this.submitByUser = data.submitByUser;
            }
            if ("projectId" in data && data.projectId != undefined) {
                this.projectId = data.projectId;
            }
            if ("projectName" in data && data.projectName != undefined) {
                this.projectName = data.projectName;
            }
            if ("overallStatus" in data && data.overallStatus != undefined) {
                this.overallStatus = data.overallStatus;
            }
            if ("runConfig" in data && data.runConfig != undefined) {
                this.runConfig = data.runConfig;
            }
            if ("systemRunId" in data && data.systemRunId != undefined) {
                this.systemRunId = data.systemRunId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("dupeSubmissionId" in data && data.dupeSubmissionId != undefined) {
                this.dupeSubmissionId = data.dupeSubmissionId;
            }
            if ("templateOriginId" in data && data.templateOriginId != undefined) {
                this.templateOriginId = data.templateOriginId;
            }
            if ("submissionRunGroups" in data && data.submissionRunGroups != undefined) {
                this.submissionRunGroups = data.submissionRunGroups;
            }
            if ("runLog" in data && data.runLog != undefined) {
                this.runLog = data.runLog;
            }
            if ("shortName" in data && data.shortName != undefined) {
                this.shortName = data.shortName;
            }
            if ("cfdPartsList" in data && data.cfdPartsList != undefined) {
                this.cfdPartsList = data.cfdPartsList;
            }
            if ("templateOriginName" in data && data.templateOriginName != undefined) {
                this.templateOriginName = data.templateOriginName;
            }
            if ("submitUser" in data && data.submitUser != undefined) {
                this.submitUser = data.submitUser;
            }
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
            if ("notes" in data && data.notes != undefined) {
                this.notes = data.notes;
            }
            if ("length_m" in data && data.length_m != undefined) {
                this.length_m = data.length_m;
            }
            if ("width_m" in data && data.width_m != undefined) {
                this.width_m = data.width_m;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get createByUserName() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set createByUserName(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get workflowSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set workflowSubmissionId(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get submitDate() {
        return pb_1.Message.getFieldWithDefault(this, 9, 0);
    }
    set submitDate(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get submitByUser() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set submitByUser(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get projectId() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set projectId(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get projectName() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set projectName(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get overallStatus() {
        return pb_1.Message.getFieldWithDefault(this, 13, RunStatus.UNSPECIFIED);
    }
    set overallStatus(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get runConfig() {
        return pb_1.Message.getWrapperField(this, RunConfig, 14);
    }
    set runConfig(value) {
        pb_1.Message.setWrapperField(this, 14, value);
    }
    get has_runConfig() {
        return pb_1.Message.getField(this, 14) != null;
    }
    get systemRunId() {
        return pb_1.Message.getFieldWithDefault(this, 16, "");
    }
    set systemRunId(value) {
        pb_1.Message.setField(this, 16, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 20, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get dupeSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 21, "");
    }
    set dupeSubmissionId(value) {
        pb_1.Message.setField(this, 21, value);
    }
    get templateOriginId() {
        return pb_1.Message.getFieldWithDefault(this, 22, "");
    }
    set templateOriginId(value) {
        pb_1.Message.setField(this, 22, value);
    }
    get submissionRunGroups() {
        return pb_1.Message.getRepeatedWrapperField(this, SubmissionRunGroups, 23);
    }
    set submissionRunGroups(value) {
        pb_1.Message.setRepeatedWrapperField(this, 23, value);
    }
    get runLog() {
        return pb_1.Message.getFieldWithDefault(this, 24, []);
    }
    set runLog(value) {
        pb_1.Message.setField(this, 24, value);
    }
    get shortName() {
        return pb_1.Message.getFieldWithDefault(this, 25, "");
    }
    set shortName(value) {
        pb_1.Message.setField(this, 25, value);
    }
    get cfdPartsList() {
        return pb_1.Message.getWrapperField(this, CFDPartsList, 26);
    }
    set cfdPartsList(value) {
        pb_1.Message.setWrapperField(this, 26, value);
    }
    get has_cfdPartsList() {
        return pb_1.Message.getField(this, 26) != null;
    }
    get templateOriginName() {
        return pb_1.Message.getFieldWithDefault(this, 28, "");
    }
    set templateOriginName(value) {
        pb_1.Message.setField(this, 28, value);
    }
    get submitUser() {
        return pb_1.Message.getWrapperField(this, User, 29);
    }
    set submitUser(value) {
        pb_1.Message.setWrapperField(this, 29, value);
    }
    get has_submitUser() {
        return pb_1.Message.getField(this, 29) != null;
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 30, "");
    }
    set type(value) {
        pb_1.Message.setField(this, 30, value);
    }
    get notes() {
        return pb_1.Message.getFieldWithDefault(this, 31, "");
    }
    set notes(value) {
        pb_1.Message.setField(this, 31, value);
    }
    get length_m() {
        return pb_1.Message.getFieldWithDefault(this, 32, 0);
    }
    set length_m(value) {
        pb_1.Message.setField(this, 32, value);
    }
    get width_m() {
        return pb_1.Message.getFieldWithDefault(this, 33, 0);
    }
    set width_m(value) {
        pb_1.Message.setField(this, 33, value);
    }
    static fromObject(data) {
        const message = new WorkflowSubmission({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.createByUserName != null) {
            message.createByUserName = data.createByUserName;
        }
        if (data.workflowSubmissionId != null) {
            message.workflowSubmissionId = data.workflowSubmissionId;
        }
        if (data.submitDate != null) {
            message.submitDate = data.submitDate;
        }
        if (data.submitByUser != null) {
            message.submitByUser = data.submitByUser;
        }
        if (data.projectId != null) {
            message.projectId = data.projectId;
        }
        if (data.projectName != null) {
            message.projectName = data.projectName;
        }
        if (data.overallStatus != null) {
            message.overallStatus = data.overallStatus;
        }
        if (data.runConfig != null) {
            message.runConfig = RunConfig.fromObject(data.runConfig);
        }
        if (data.systemRunId != null) {
            message.systemRunId = data.systemRunId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.dupeSubmissionId != null) {
            message.dupeSubmissionId = data.dupeSubmissionId;
        }
        if (data.templateOriginId != null) {
            message.templateOriginId = data.templateOriginId;
        }
        if (data.submissionRunGroups != null) {
            message.submissionRunGroups = data.submissionRunGroups.map(item => SubmissionRunGroups.fromObject(item));
        }
        if (data.runLog != null) {
            message.runLog = data.runLog;
        }
        if (data.shortName != null) {
            message.shortName = data.shortName;
        }
        if (data.cfdPartsList != null) {
            message.cfdPartsList = CFDPartsList.fromObject(data.cfdPartsList);
        }
        if (data.templateOriginName != null) {
            message.templateOriginName = data.templateOriginName;
        }
        if (data.submitUser != null) {
            message.submitUser = User.fromObject(data.submitUser);
        }
        if (data.type != null) {
            message.type = data.type;
        }
        if (data.notes != null) {
            message.notes = data.notes;
        }
        if (data.length_m != null) {
            message.length_m = data.length_m;
        }
        if (data.width_m != null) {
            message.width_m = data.width_m;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.createByUserName != null) {
            data.createByUserName = this.createByUserName;
        }
        if (this.workflowSubmissionId != null) {
            data.workflowSubmissionId = this.workflowSubmissionId;
        }
        if (this.submitDate != null) {
            data.submitDate = this.submitDate;
        }
        if (this.submitByUser != null) {
            data.submitByUser = this.submitByUser;
        }
        if (this.projectId != null) {
            data.projectId = this.projectId;
        }
        if (this.projectName != null) {
            data.projectName = this.projectName;
        }
        if (this.overallStatus != null) {
            data.overallStatus = this.overallStatus;
        }
        if (this.runConfig != null) {
            data.runConfig = this.runConfig.toObject();
        }
        if (this.systemRunId != null) {
            data.systemRunId = this.systemRunId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.dupeSubmissionId != null) {
            data.dupeSubmissionId = this.dupeSubmissionId;
        }
        if (this.templateOriginId != null) {
            data.templateOriginId = this.templateOriginId;
        }
        if (this.submissionRunGroups != null) {
            data.submissionRunGroups = this.submissionRunGroups.map((item) => item.toObject());
        }
        if (this.runLog != null) {
            data.runLog = this.runLog;
        }
        if (this.shortName != null) {
            data.shortName = this.shortName;
        }
        if (this.cfdPartsList != null) {
            data.cfdPartsList = this.cfdPartsList.toObject();
        }
        if (this.templateOriginName != null) {
            data.templateOriginName = this.templateOriginName;
        }
        if (this.submitUser != null) {
            data.submitUser = this.submitUser.toObject();
        }
        if (this.type != null) {
            data.type = this.type;
        }
        if (this.notes != null) {
            data.notes = this.notes;
        }
        if (this.length_m != null) {
            data.length_m = this.length_m;
        }
        if (this.width_m != null) {
            data.width_m = this.width_m;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.createByUserName.length)
            writer.writeString(7, this.createByUserName);
        if (this.workflowSubmissionId.length)
            writer.writeString(8, this.workflowSubmissionId);
        if (this.submitDate != 0)
            writer.writeInt64(9, this.submitDate);
        if (this.submitByUser.length)
            writer.writeString(10, this.submitByUser);
        if (this.projectId.length)
            writer.writeString(11, this.projectId);
        if (this.projectName.length)
            writer.writeString(12, this.projectName);
        if (this.overallStatus != RunStatus.UNSPECIFIED)
            writer.writeEnum(13, this.overallStatus);
        if (this.has_runConfig)
            writer.writeMessage(14, this.runConfig, () => this.runConfig.serialize(writer));
        if (this.systemRunId.length)
            writer.writeString(16, this.systemRunId);
        if (this.name.length)
            writer.writeString(20, this.name);
        if (this.dupeSubmissionId.length)
            writer.writeString(21, this.dupeSubmissionId);
        if (this.templateOriginId.length)
            writer.writeString(22, this.templateOriginId);
        if (this.submissionRunGroups.length)
            writer.writeRepeatedMessage(23, this.submissionRunGroups, (item) => item.serialize(writer));
        if (this.runLog.length)
            writer.writeRepeatedString(24, this.runLog);
        if (this.shortName.length)
            writer.writeString(25, this.shortName);
        if (this.has_cfdPartsList)
            writer.writeMessage(26, this.cfdPartsList, () => this.cfdPartsList.serialize(writer));
        if (this.templateOriginName.length)
            writer.writeString(28, this.templateOriginName);
        if (this.has_submitUser)
            writer.writeMessage(29, this.submitUser, () => this.submitUser.serialize(writer));
        if (this.type.length)
            writer.writeString(30, this.type);
        if (this.notes.length)
            writer.writeString(31, this.notes);
        if (this.length_m != 0)
            writer.writeFloat(32, this.length_m);
        if (this.width_m != 0)
            writer.writeFloat(33, this.width_m);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WorkflowSubmission();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.createByUserName = reader.readString();
                    break;
                case 8:
                    message.workflowSubmissionId = reader.readString();
                    break;
                case 9:
                    message.submitDate = reader.readInt64();
                    break;
                case 10:
                    message.submitByUser = reader.readString();
                    break;
                case 11:
                    message.projectId = reader.readString();
                    break;
                case 12:
                    message.projectName = reader.readString();
                    break;
                case 13:
                    message.overallStatus = reader.readEnum();
                    break;
                case 14:
                    reader.readMessage(message.runConfig, () => message.runConfig = RunConfig.deserialize(reader));
                    break;
                case 16:
                    message.systemRunId = reader.readString();
                    break;
                case 20:
                    message.name = reader.readString();
                    break;
                case 21:
                    message.dupeSubmissionId = reader.readString();
                    break;
                case 22:
                    message.templateOriginId = reader.readString();
                    break;
                case 23:
                    reader.readMessage(message.submissionRunGroups, () => pb_1.Message.addToRepeatedWrapperField(message, 23, SubmissionRunGroups.deserialize(reader), SubmissionRunGroups));
                    break;
                case 24:
                    pb_1.Message.addToRepeatedField(message, 24, reader.readString());
                    break;
                case 25:
                    message.shortName = reader.readString();
                    break;
                case 26:
                    reader.readMessage(message.cfdPartsList, () => message.cfdPartsList = CFDPartsList.deserialize(reader));
                    break;
                case 28:
                    message.templateOriginName = reader.readString();
                    break;
                case 29:
                    reader.readMessage(message.submitUser, () => message.submitUser = User.deserialize(reader));
                    break;
                case 30:
                    message.type = reader.readString();
                    break;
                case 31:
                    message.notes = reader.readString();
                    break;
                case 32:
                    message.length_m = reader.readFloat();
                    break;
                case 33:
                    message.width_m = reader.readFloat();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return WorkflowSubmission.deserialize(bytes);
    }
}
exports.WorkflowSubmission = WorkflowSubmission;
_WorkflowSubmission_one_of_decls = new WeakMap();
class SubmissionRunGroups extends pb_1.Message {
    constructor(data) {
        super();
        _SubmissionRunGroups_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1, 3], __classPrivateFieldGet(this, _SubmissionRunGroups_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("swapParts" in data && data.swapParts != undefined) {
                this.swapParts = data.swapParts;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("workflowRunGroups" in data && data.workflowRunGroups != undefined) {
                this.workflowRunGroups = data.workflowRunGroups;
            }
            if ("masterTemplatesCompleted" in data && data.masterTemplatesCompleted != undefined) {
                this.masterTemplatesCompleted = data.masterTemplatesCompleted;
            }
        }
    }
    get swapParts() {
        return pb_1.Message.getRepeatedWrapperField(this, Part, 1);
    }
    set swapParts(value) {
        pb_1.Message.setRepeatedWrapperField(this, 1, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get workflowRunGroups() {
        return pb_1.Message.getRepeatedWrapperField(this, WorkflowRunGroup, 3);
    }
    set workflowRunGroups(value) {
        pb_1.Message.setRepeatedWrapperField(this, 3, value);
    }
    get masterTemplatesCompleted() {
        return pb_1.Message.getFieldWithDefault(this, 4, false);
    }
    set masterTemplatesCompleted(value) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data) {
        const message = new SubmissionRunGroups({});
        if (data.swapParts != null) {
            message.swapParts = data.swapParts.map(item => Part.fromObject(item));
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.workflowRunGroups != null) {
            message.workflowRunGroups = data.workflowRunGroups.map(item => WorkflowRunGroup.fromObject(item));
        }
        if (data.masterTemplatesCompleted != null) {
            message.masterTemplatesCompleted = data.masterTemplatesCompleted;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.swapParts != null) {
            data.swapParts = this.swapParts.map((item) => item.toObject());
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.workflowRunGroups != null) {
            data.workflowRunGroups = this.workflowRunGroups.map((item) => item.toObject());
        }
        if (this.masterTemplatesCompleted != null) {
            data.masterTemplatesCompleted = this.masterTemplatesCompleted;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.swapParts.length)
            writer.writeRepeatedMessage(1, this.swapParts, (item) => item.serialize(writer));
        if (this.name.length)
            writer.writeString(2, this.name);
        if (this.workflowRunGroups.length)
            writer.writeRepeatedMessage(3, this.workflowRunGroups, (item) => item.serialize(writer));
        if (this.masterTemplatesCompleted != false)
            writer.writeBool(4, this.masterTemplatesCompleted);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubmissionRunGroups();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.swapParts, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Part.deserialize(reader), Part));
                    break;
                case 2:
                    message.name = reader.readString();
                    break;
                case 3:
                    reader.readMessage(message.workflowRunGroups, () => pb_1.Message.addToRepeatedWrapperField(message, 3, WorkflowRunGroup.deserialize(reader), WorkflowRunGroup));
                    break;
                case 4:
                    message.masterTemplatesCompleted = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SubmissionRunGroups.deserialize(bytes);
    }
}
exports.SubmissionRunGroups = SubmissionRunGroups;
_SubmissionRunGroups_one_of_decls = new WeakMap();
class CFDPartsList extends pb_1.Message {
    constructor(data) {
        super();
        _CFDPartsList_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [11], __classPrivateFieldGet(this, _CFDPartsList_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("workflowSubmissionId" in data && data.workflowSubmissionId != undefined) {
                this.workflowSubmissionId = data.workflowSubmissionId;
            }
            if ("baselineSubmissionId" in data && data.baselineSubmissionId != undefined) {
                this.baselineSubmissionId = data.baselineSubmissionId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("parts" in data && data.parts != undefined) {
                this.parts = data.parts;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get workflowSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set workflowSubmissionId(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get baselineSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set baselineSubmissionId(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get parts() {
        return pb_1.Message.getRepeatedWrapperField(this, CFDFile, 11);
    }
    set parts(value) {
        pb_1.Message.setRepeatedWrapperField(this, 11, value);
    }
    static fromObject(data) {
        const message = new CFDPartsList({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.workflowSubmissionId != null) {
            message.workflowSubmissionId = data.workflowSubmissionId;
        }
        if (data.baselineSubmissionId != null) {
            message.baselineSubmissionId = data.baselineSubmissionId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.parts != null) {
            message.parts = data.parts.map(item => CFDFile.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.workflowSubmissionId != null) {
            data.workflowSubmissionId = this.workflowSubmissionId;
        }
        if (this.baselineSubmissionId != null) {
            data.baselineSubmissionId = this.baselineSubmissionId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.parts != null) {
            data.parts = this.parts.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.workflowSubmissionId.length)
            writer.writeString(7, this.workflowSubmissionId);
        if (this.baselineSubmissionId.length)
            writer.writeString(8, this.baselineSubmissionId);
        if (this.name.length)
            writer.writeString(9, this.name);
        if (this.description.length)
            writer.writeString(10, this.description);
        if (this.parts.length)
            writer.writeRepeatedMessage(11, this.parts, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CFDPartsList();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.workflowSubmissionId = reader.readString();
                    break;
                case 8:
                    message.baselineSubmissionId = reader.readString();
                    break;
                case 9:
                    message.name = reader.readString();
                    break;
                case 10:
                    message.description = reader.readString();
                    break;
                case 11:
                    reader.readMessage(message.parts, () => pb_1.Message.addToRepeatedWrapperField(message, 11, CFDFile.deserialize(reader), CFDFile));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return CFDPartsList.deserialize(bytes);
    }
}
exports.CFDPartsList = CFDPartsList;
_CFDPartsList_one_of_decls = new WeakMap();
class StarCCMConfig extends pb_1.Message {
    constructor(data) {
        super();
        _StarCCMConfig_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [7, 8, 9], __classPrivateFieldGet(this, _StarCCMConfig_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("macroSteps" in data && data.macroSteps != undefined) {
                this.macroSteps = data.macroSteps;
            }
            if ("customSteps" in data && data.customSteps != undefined) {
                this.customSteps = data.customSteps;
            }
            if ("stepOrder" in data && data.stepOrder != undefined) {
                this.stepOrder = data.stepOrder;
            }
            if ("starccmParameters" in data && data.starccmParameters != undefined) {
                this.starccmParameters = data.starccmParameters;
            }
            if ("miscellaneousParameters" in data && data.miscellaneousParameters != undefined) {
                this.miscellaneousParameters = data.miscellaneousParameters;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get macroSteps() {
        return pb_1.Message.getRepeatedWrapperField(this, BasicNameValue, 7);
    }
    set macroSteps(value) {
        pb_1.Message.setRepeatedWrapperField(this, 7, value);
    }
    get customSteps() {
        return pb_1.Message.getFieldWithDefault(this, 8, []);
    }
    set customSteps(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get stepOrder() {
        return pb_1.Message.getFieldWithDefault(this, 9, []);
    }
    set stepOrder(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get starccmParameters() {
        return pb_1.Message.getWrapperField(this, StarCCMParameterList, 10);
    }
    set starccmParameters(value) {
        pb_1.Message.setWrapperField(this, 10, value);
    }
    get has_starccmParameters() {
        return pb_1.Message.getField(this, 10) != null;
    }
    get miscellaneousParameters() {
        return pb_1.Message.getWrapperField(this, MiscellaneousParameterList, 11);
    }
    set miscellaneousParameters(value) {
        pb_1.Message.setWrapperField(this, 11, value);
    }
    get has_miscellaneousParameters() {
        return pb_1.Message.getField(this, 11) != null;
    }
    static fromObject(data) {
        const message = new StarCCMConfig({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.macroSteps != null) {
            message.macroSteps = data.macroSteps.map(item => BasicNameValue.fromObject(item));
        }
        if (data.customSteps != null) {
            message.customSteps = data.customSteps;
        }
        if (data.stepOrder != null) {
            message.stepOrder = data.stepOrder;
        }
        if (data.starccmParameters != null) {
            message.starccmParameters = StarCCMParameterList.fromObject(data.starccmParameters);
        }
        if (data.miscellaneousParameters != null) {
            message.miscellaneousParameters = MiscellaneousParameterList.fromObject(data.miscellaneousParameters);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.macroSteps != null) {
            data.macroSteps = this.macroSteps.map((item) => item.toObject());
        }
        if (this.customSteps != null) {
            data.customSteps = this.customSteps;
        }
        if (this.stepOrder != null) {
            data.stepOrder = this.stepOrder;
        }
        if (this.starccmParameters != null) {
            data.starccmParameters = this.starccmParameters.toObject();
        }
        if (this.miscellaneousParameters != null) {
            data.miscellaneousParameters = this.miscellaneousParameters.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.macroSteps.length)
            writer.writeRepeatedMessage(7, this.macroSteps, (item) => item.serialize(writer));
        if (this.customSteps.length)
            writer.writeRepeatedString(8, this.customSteps);
        if (this.stepOrder.length)
            writer.writeRepeatedString(9, this.stepOrder);
        if (this.has_starccmParameters)
            writer.writeMessage(10, this.starccmParameters, () => this.starccmParameters.serialize(writer));
        if (this.has_miscellaneousParameters)
            writer.writeMessage(11, this.miscellaneousParameters, () => this.miscellaneousParameters.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StarCCMConfig();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    reader.readMessage(message.macroSteps, () => pb_1.Message.addToRepeatedWrapperField(message, 7, BasicNameValue.deserialize(reader), BasicNameValue));
                    break;
                case 8:
                    pb_1.Message.addToRepeatedField(message, 8, reader.readString());
                    break;
                case 9:
                    pb_1.Message.addToRepeatedField(message, 9, reader.readString());
                    break;
                case 10:
                    reader.readMessage(message.starccmParameters, () => message.starccmParameters = StarCCMParameterList.deserialize(reader));
                    break;
                case 11:
                    reader.readMessage(message.miscellaneousParameters, () => message.miscellaneousParameters = MiscellaneousParameterList.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return StarCCMConfig.deserialize(bytes);
    }
}
exports.StarCCMConfig = StarCCMConfig;
_StarCCMConfig_one_of_decls = new WeakMap();
class BasicNameValue extends pb_1.Message {
    constructor(data) {
        super();
        _BasicNameValue_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _BasicNameValue_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("value" in data && data.value != undefined) {
                this.value = data.value;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get value() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set value(value) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data) {
        const message = new BasicNameValue({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.value != null) {
            message.value = data.value;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.value != null) {
            data.value = this.value;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.value.length)
            writer.writeString(2, this.value);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BasicNameValue();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.value = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return BasicNameValue.deserialize(bytes);
    }
}
exports.BasicNameValue = BasicNameValue;
_BasicNameValue_one_of_decls = new WeakMap();
class StarCCMParameterList extends pb_1.Message {
    constructor(data) {
        super();
        _StarCCMParameterList_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [9], __classPrivateFieldGet(this, _StarCCMParameterList_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceteamId" in data && data.raceteamId != undefined) {
                this.raceteamId = data.raceteamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("isPreset" in data && data.isPreset != undefined) {
                this.isPreset = data.isPreset;
            }
            if ("paramList" in data && data.paramList != undefined) {
                this.paramList = data.paramList;
            }
        }
    }
    get raceteamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceteamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get isPreset() {
        return pb_1.Message.getFieldWithDefault(this, 8, false);
    }
    set isPreset(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get paramList() {
        return pb_1.Message.getRepeatedWrapperField(this, BasicNameValue, 9);
    }
    set paramList(value) {
        pb_1.Message.setRepeatedWrapperField(this, 9, value);
    }
    static fromObject(data) {
        const message = new StarCCMParameterList({});
        if (data.raceteamId != null) {
            message.raceteamId = data.raceteamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.isPreset != null) {
            message.isPreset = data.isPreset;
        }
        if (data.paramList != null) {
            message.paramList = data.paramList.map(item => BasicNameValue.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceteamId != null) {
            data.raceteamId = this.raceteamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.isPreset != null) {
            data.isPreset = this.isPreset;
        }
        if (this.paramList != null) {
            data.paramList = this.paramList.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceteamId.length)
            writer.writeString(1, this.raceteamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.name.length)
            writer.writeString(7, this.name);
        if (this.isPreset != false)
            writer.writeBool(8, this.isPreset);
        if (this.paramList.length)
            writer.writeRepeatedMessage(9, this.paramList, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StarCCMParameterList();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceteamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.name = reader.readString();
                    break;
                case 8:
                    message.isPreset = reader.readBool();
                    break;
                case 9:
                    reader.readMessage(message.paramList, () => pb_1.Message.addToRepeatedWrapperField(message, 9, BasicNameValue.deserialize(reader), BasicNameValue));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return StarCCMParameterList.deserialize(bytes);
    }
}
exports.StarCCMParameterList = StarCCMParameterList;
_StarCCMParameterList_one_of_decls = new WeakMap();
class MiscellaneousParameterList extends pb_1.Message {
    constructor(data) {
        super();
        _MiscellaneousParameterList_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [9], __classPrivateFieldGet(this, _MiscellaneousParameterList_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceteamId" in data && data.raceteamId != undefined) {
                this.raceteamId = data.raceteamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("isPreset" in data && data.isPreset != undefined) {
                this.isPreset = data.isPreset;
            }
            if ("paramList" in data && data.paramList != undefined) {
                this.paramList = data.paramList;
            }
        }
    }
    get raceteamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceteamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get isPreset() {
        return pb_1.Message.getFieldWithDefault(this, 8, false);
    }
    set isPreset(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get paramList() {
        return pb_1.Message.getRepeatedWrapperField(this, BasicNameValue, 9);
    }
    set paramList(value) {
        pb_1.Message.setRepeatedWrapperField(this, 9, value);
    }
    static fromObject(data) {
        const message = new MiscellaneousParameterList({});
        if (data.raceteamId != null) {
            message.raceteamId = data.raceteamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.isPreset != null) {
            message.isPreset = data.isPreset;
        }
        if (data.paramList != null) {
            message.paramList = data.paramList.map(item => BasicNameValue.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceteamId != null) {
            data.raceteamId = this.raceteamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.isPreset != null) {
            data.isPreset = this.isPreset;
        }
        if (this.paramList != null) {
            data.paramList = this.paramList.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceteamId.length)
            writer.writeString(1, this.raceteamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.name.length)
            writer.writeString(7, this.name);
        if (this.isPreset != false)
            writer.writeBool(8, this.isPreset);
        if (this.paramList.length)
            writer.writeRepeatedMessage(9, this.paramList, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MiscellaneousParameterList();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceteamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.name = reader.readString();
                    break;
                case 8:
                    message.isPreset = reader.readBool();
                    break;
                case 9:
                    reader.readMessage(message.paramList, () => pb_1.Message.addToRepeatedWrapperField(message, 9, BasicNameValue.deserialize(reader), BasicNameValue));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return MiscellaneousParameterList.deserialize(bytes);
    }
}
exports.MiscellaneousParameterList = MiscellaneousParameterList;
_MiscellaneousParameterList_one_of_decls = new WeakMap();
class WorkflowRunGroup extends pb_1.Message {
    constructor(data) {
        super();
        _WorkflowRunGroup_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [14], __classPrivateFieldGet(this, _WorkflowRunGroup_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("systemRunId" in data && data.systemRunId != undefined) {
                this.systemRunId = data.systemRunId;
            }
            if ("workflowSubmissionId" in data && data.workflowSubmissionId != undefined) {
                this.workflowSubmissionId = data.workflowSubmissionId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("runGroupCase" in data && data.runGroupCase != undefined) {
                this.runGroupCase = data.runGroupCase;
            }
            if ("geometry" in data && data.geometry != undefined) {
                this.geometry = data.geometry;
            }
            if ("resubmitAttempts" in data && data.resubmitAttempts != undefined) {
                this.resubmitAttempts = data.resubmitAttempts;
            }
            if ("methodSet" in data && data.methodSet != undefined) {
                this.methodSet = data.methodSet;
            }
            if ("workflow" in data && data.workflow != undefined) {
                this.workflow = data.workflow;
            }
            if ("dependent" in data && data.dependent != undefined) {
                this.dependent = data.dependent;
            }
            if ("dependentWrgIndex" in data && data.dependentWrgIndex != undefined) {
                this.dependentWrgIndex = data.dependentWrgIndex;
            }
            if ("overallStatus" in data && data.overallStatus != undefined) {
                this.overallStatus = data.overallStatus;
            }
            if ("containerRootDir" in data && data.containerRootDir != undefined) {
                this.containerRootDir = data.containerRootDir;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get systemRunId() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set systemRunId(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get workflowSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set workflowSubmissionId(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get runGroupCase() {
        return pb_1.Message.getWrapperField(this, RunConfigCase, 10);
    }
    set runGroupCase(value) {
        pb_1.Message.setWrapperField(this, 10, value);
    }
    get has_runGroupCase() {
        return pb_1.Message.getField(this, 10) != null;
    }
    get geometry() {
        return pb_1.Message.getWrapperField(this, Geometry, 11);
    }
    set geometry(value) {
        pb_1.Message.setWrapperField(this, 11, value);
    }
    get has_geometry() {
        return pb_1.Message.getField(this, 11) != null;
    }
    get resubmitAttempts() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set resubmitAttempts(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get methodSet() {
        return pb_1.Message.getWrapperField(this, MethodologySet, 13);
    }
    set methodSet(value) {
        pb_1.Message.setWrapperField(this, 13, value);
    }
    get has_methodSet() {
        return pb_1.Message.getField(this, 13) != null;
    }
    get workflow() {
        return pb_1.Message.getRepeatedWrapperField(this, Workflow, 14);
    }
    set workflow(value) {
        pb_1.Message.setRepeatedWrapperField(this, 14, value);
    }
    get dependent() {
        return pb_1.Message.getFieldWithDefault(this, 15, false);
    }
    set dependent(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get dependentWrgIndex() {
        return pb_1.Message.getFieldWithDefault(this, 16, 0);
    }
    set dependentWrgIndex(value) {
        pb_1.Message.setField(this, 16, value);
    }
    get overallStatus() {
        return pb_1.Message.getFieldWithDefault(this, 17, RunStatus.UNSPECIFIED);
    }
    set overallStatus(value) {
        pb_1.Message.setField(this, 17, value);
    }
    get containerRootDir() {
        return pb_1.Message.getFieldWithDefault(this, 18, "");
    }
    set containerRootDir(value) {
        pb_1.Message.setField(this, 18, value);
    }
    static fromObject(data) {
        const message = new WorkflowRunGroup({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.systemRunId != null) {
            message.systemRunId = data.systemRunId;
        }
        if (data.workflowSubmissionId != null) {
            message.workflowSubmissionId = data.workflowSubmissionId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.runGroupCase != null) {
            message.runGroupCase = RunConfigCase.fromObject(data.runGroupCase);
        }
        if (data.geometry != null) {
            message.geometry = Geometry.fromObject(data.geometry);
        }
        if (data.resubmitAttempts != null) {
            message.resubmitAttempts = data.resubmitAttempts;
        }
        if (data.methodSet != null) {
            message.methodSet = MethodologySet.fromObject(data.methodSet);
        }
        if (data.workflow != null) {
            message.workflow = data.workflow.map(item => Workflow.fromObject(item));
        }
        if (data.dependent != null) {
            message.dependent = data.dependent;
        }
        if (data.dependentWrgIndex != null) {
            message.dependentWrgIndex = data.dependentWrgIndex;
        }
        if (data.overallStatus != null) {
            message.overallStatus = data.overallStatus;
        }
        if (data.containerRootDir != null) {
            message.containerRootDir = data.containerRootDir;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.systemRunId != null) {
            data.systemRunId = this.systemRunId;
        }
        if (this.workflowSubmissionId != null) {
            data.workflowSubmissionId = this.workflowSubmissionId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.runGroupCase != null) {
            data.runGroupCase = this.runGroupCase.toObject();
        }
        if (this.geometry != null) {
            data.geometry = this.geometry.toObject();
        }
        if (this.resubmitAttempts != null) {
            data.resubmitAttempts = this.resubmitAttempts;
        }
        if (this.methodSet != null) {
            data.methodSet = this.methodSet.toObject();
        }
        if (this.workflow != null) {
            data.workflow = this.workflow.map((item) => item.toObject());
        }
        if (this.dependent != null) {
            data.dependent = this.dependent;
        }
        if (this.dependentWrgIndex != null) {
            data.dependentWrgIndex = this.dependentWrgIndex;
        }
        if (this.overallStatus != null) {
            data.overallStatus = this.overallStatus;
        }
        if (this.containerRootDir != null) {
            data.containerRootDir = this.containerRootDir;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.systemRunId.length)
            writer.writeString(7, this.systemRunId);
        if (this.workflowSubmissionId.length)
            writer.writeString(8, this.workflowSubmissionId);
        if (this.name.length)
            writer.writeString(9, this.name);
        if (this.has_runGroupCase)
            writer.writeMessage(10, this.runGroupCase, () => this.runGroupCase.serialize(writer));
        if (this.has_geometry)
            writer.writeMessage(11, this.geometry, () => this.geometry.serialize(writer));
        if (this.resubmitAttempts.length)
            writer.writeString(12, this.resubmitAttempts);
        if (this.has_methodSet)
            writer.writeMessage(13, this.methodSet, () => this.methodSet.serialize(writer));
        if (this.workflow.length)
            writer.writeRepeatedMessage(14, this.workflow, (item) => item.serialize(writer));
        if (this.dependent != false)
            writer.writeBool(15, this.dependent);
        if (this.dependentWrgIndex != 0)
            writer.writeInt32(16, this.dependentWrgIndex);
        if (this.overallStatus != RunStatus.UNSPECIFIED)
            writer.writeEnum(17, this.overallStatus);
        if (this.containerRootDir.length)
            writer.writeString(18, this.containerRootDir);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WorkflowRunGroup();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.systemRunId = reader.readString();
                    break;
                case 8:
                    message.workflowSubmissionId = reader.readString();
                    break;
                case 9:
                    message.name = reader.readString();
                    break;
                case 10:
                    reader.readMessage(message.runGroupCase, () => message.runGroupCase = RunConfigCase.deserialize(reader));
                    break;
                case 11:
                    reader.readMessage(message.geometry, () => message.geometry = Geometry.deserialize(reader));
                    break;
                case 12:
                    message.resubmitAttempts = reader.readString();
                    break;
                case 13:
                    reader.readMessage(message.methodSet, () => message.methodSet = MethodologySet.deserialize(reader));
                    break;
                case 14:
                    reader.readMessage(message.workflow, () => pb_1.Message.addToRepeatedWrapperField(message, 14, Workflow.deserialize(reader), Workflow));
                    break;
                case 15:
                    message.dependent = reader.readBool();
                    break;
                case 16:
                    message.dependentWrgIndex = reader.readInt32();
                    break;
                case 17:
                    message.overallStatus = reader.readEnum();
                    break;
                case 18:
                    message.containerRootDir = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return WorkflowRunGroup.deserialize(bytes);
    }
}
exports.WorkflowRunGroup = WorkflowRunGroup;
_WorkflowRunGroup_one_of_decls = new WeakMap();
class WorkflowSubmissionTemplate extends pb_1.Message {
    constructor(data) {
        super();
        _WorkflowSubmissionTemplate_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [9, 10], __classPrivateFieldGet(this, _WorkflowSubmissionTemplate_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("templateWorkflows" in data && data.templateWorkflows != undefined) {
                this.templateWorkflows = data.templateWorkflows;
            }
            if ("masterTemplates" in data && data.masterTemplates != undefined) {
                this.masterTemplates = data.masterTemplates;
            }
            if ("isMasterTemplate" in data && data.isMasterTemplate != undefined) {
                this.isMasterTemplate = data.isMasterTemplate;
            }
            if ("splitOnPartSwaps" in data && data.splitOnPartSwaps != undefined) {
                this.splitOnPartSwaps = data.splitOnPartSwaps;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get templateWorkflows() {
        return pb_1.Message.getRepeatedWrapperField(this, Workflow, 9);
    }
    set templateWorkflows(value) {
        pb_1.Message.setRepeatedWrapperField(this, 9, value);
    }
    get masterTemplates() {
        return pb_1.Message.getRepeatedWrapperField(this, WorkflowSubmissionTemplate, 10);
    }
    set masterTemplates(value) {
        pb_1.Message.setRepeatedWrapperField(this, 10, value);
    }
    get isMasterTemplate() {
        return pb_1.Message.getFieldWithDefault(this, 11, false);
    }
    set isMasterTemplate(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get splitOnPartSwaps() {
        return pb_1.Message.getFieldWithDefault(this, 12, false);
    }
    set splitOnPartSwaps(value) {
        pb_1.Message.setField(this, 12, value);
    }
    static fromObject(data) {
        const message = new WorkflowSubmissionTemplate({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.templateWorkflows != null) {
            message.templateWorkflows = data.templateWorkflows.map(item => Workflow.fromObject(item));
        }
        if (data.masterTemplates != null) {
            message.masterTemplates = data.masterTemplates.map(item => WorkflowSubmissionTemplate.fromObject(item));
        }
        if (data.isMasterTemplate != null) {
            message.isMasterTemplate = data.isMasterTemplate;
        }
        if (data.splitOnPartSwaps != null) {
            message.splitOnPartSwaps = data.splitOnPartSwaps;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.templateWorkflows != null) {
            data.templateWorkflows = this.templateWorkflows.map((item) => item.toObject());
        }
        if (this.masterTemplates != null) {
            data.masterTemplates = this.masterTemplates.map((item) => item.toObject());
        }
        if (this.isMasterTemplate != null) {
            data.isMasterTemplate = this.isMasterTemplate;
        }
        if (this.splitOnPartSwaps != null) {
            data.splitOnPartSwaps = this.splitOnPartSwaps;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.name.length)
            writer.writeString(7, this.name);
        if (this.description.length)
            writer.writeString(8, this.description);
        if (this.templateWorkflows.length)
            writer.writeRepeatedMessage(9, this.templateWorkflows, (item) => item.serialize(writer));
        if (this.masterTemplates.length)
            writer.writeRepeatedMessage(10, this.masterTemplates, (item) => item.serialize(writer));
        if (this.isMasterTemplate != false)
            writer.writeBool(11, this.isMasterTemplate);
        if (this.splitOnPartSwaps != false)
            writer.writeBool(12, this.splitOnPartSwaps);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WorkflowSubmissionTemplate();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.name = reader.readString();
                    break;
                case 8:
                    message.description = reader.readString();
                    break;
                case 9:
                    reader.readMessage(message.templateWorkflows, () => pb_1.Message.addToRepeatedWrapperField(message, 9, Workflow.deserialize(reader), Workflow));
                    break;
                case 10:
                    reader.readMessage(message.masterTemplates, () => pb_1.Message.addToRepeatedWrapperField(message, 10, WorkflowSubmissionTemplate.deserialize(reader), WorkflowSubmissionTemplate));
                    break;
                case 11:
                    message.isMasterTemplate = reader.readBool();
                    break;
                case 12:
                    message.splitOnPartSwaps = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return WorkflowSubmissionTemplate.deserialize(bytes);
    }
}
exports.WorkflowSubmissionTemplate = WorkflowSubmissionTemplate;
_WorkflowSubmissionTemplate_one_of_decls = new WeakMap();
class Workflow extends pb_1.Message {
    constructor(data) {
        super();
        _Workflow_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [12], __classPrivateFieldGet(this, _Workflow_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("workflowId" in data && data.workflowId != undefined) {
                this.workflowId = data.workflowId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("enabled" in data && data.enabled != undefined) {
                this.enabled = data.enabled;
            }
            if ("workflowTasks" in data && data.workflowTasks != undefined) {
                this.workflowTasks = data.workflowTasks;
            }
            if ("dependent" in data && data.dependent != undefined) {
                this.dependent = data.dependent;
            }
            if ("overallStatus" in data && data.overallStatus != undefined) {
                this.overallStatus = data.overallStatus;
            }
            if ("systemRunId" in data && data.systemRunId != undefined) {
                this.systemRunId = data.systemRunId;
            }
            if ("teamBlobStorage" in data && data.teamBlobStorage != undefined) {
                this.teamBlobStorage = data.teamBlobStorage;
            }
            if ("masterGeometry" in data && data.masterGeometry != undefined) {
                this.masterGeometry = data.masterGeometry;
            }
            if ("configJSON" in data && data.configJSON != undefined) {
                this.configJSON = data.configJSON;
            }
            if ("methodSet" in data && data.methodSet != undefined) {
                this.methodSet = data.methodSet;
            }
            if ("baselineRunName" in data && data.baselineRunName != undefined) {
                this.baselineRunName = data.baselineRunName;
            }
            if ("createdFromTemplate" in data && data.createdFromTemplate != undefined) {
                this.createdFromTemplate = data.createdFromTemplate;
            }
            if ("startTime" in data && data.startTime != undefined) {
                this.startTime = data.startTime;
            }
            if ("endTime" in data && data.endTime != undefined) {
                this.endTime = data.endTime;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get workflowId() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set workflowId(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get enabled() {
        return pb_1.Message.getFieldWithDefault(this, 10, false);
    }
    set enabled(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get workflowTasks() {
        return pb_1.Message.getRepeatedWrapperField(this, WorkflowTask, 12);
    }
    set workflowTasks(value) {
        pb_1.Message.setRepeatedWrapperField(this, 12, value);
    }
    get dependent() {
        return pb_1.Message.getFieldWithDefault(this, 13, false);
    }
    set dependent(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get overallStatus() {
        return pb_1.Message.getFieldWithDefault(this, 14, RunStatus.UNSPECIFIED);
    }
    set overallStatus(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get systemRunId() {
        return pb_1.Message.getFieldWithDefault(this, 15, "");
    }
    set systemRunId(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get teamBlobStorage() {
        return pb_1.Message.getWrapperField(this, BlobStorage, 16);
    }
    set teamBlobStorage(value) {
        pb_1.Message.setWrapperField(this, 16, value);
    }
    get has_teamBlobStorage() {
        return pb_1.Message.getField(this, 16) != null;
    }
    get masterGeometry() {
        return pb_1.Message.getWrapperField(this, Geometry, 17);
    }
    set masterGeometry(value) {
        pb_1.Message.setWrapperField(this, 17, value);
    }
    get has_masterGeometry() {
        return pb_1.Message.getField(this, 17) != null;
    }
    get configJSON() {
        return pb_1.Message.getFieldWithDefault(this, 18, "");
    }
    set configJSON(value) {
        pb_1.Message.setField(this, 18, value);
    }
    get methodSet() {
        return pb_1.Message.getWrapperField(this, MethodologySet, 20);
    }
    set methodSet(value) {
        pb_1.Message.setWrapperField(this, 20, value);
    }
    get has_methodSet() {
        return pb_1.Message.getField(this, 20) != null;
    }
    get baselineRunName() {
        return pb_1.Message.getFieldWithDefault(this, 21, "");
    }
    set baselineRunName(value) {
        pb_1.Message.setField(this, 21, value);
    }
    get createdFromTemplate() {
        return pb_1.Message.getFieldWithDefault(this, 22, "");
    }
    set createdFromTemplate(value) {
        pb_1.Message.setField(this, 22, value);
    }
    get startTime() {
        return pb_1.Message.getFieldWithDefault(this, 23, 0);
    }
    set startTime(value) {
        pb_1.Message.setField(this, 23, value);
    }
    get endTime() {
        return pb_1.Message.getFieldWithDefault(this, 24, 0);
    }
    set endTime(value) {
        pb_1.Message.setField(this, 24, value);
    }
    static fromObject(data) {
        const message = new Workflow({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.workflowId != null) {
            message.workflowId = data.workflowId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.enabled != null) {
            message.enabled = data.enabled;
        }
        if (data.workflowTasks != null) {
            message.workflowTasks = data.workflowTasks.map(item => WorkflowTask.fromObject(item));
        }
        if (data.dependent != null) {
            message.dependent = data.dependent;
        }
        if (data.overallStatus != null) {
            message.overallStatus = data.overallStatus;
        }
        if (data.systemRunId != null) {
            message.systemRunId = data.systemRunId;
        }
        if (data.teamBlobStorage != null) {
            message.teamBlobStorage = BlobStorage.fromObject(data.teamBlobStorage);
        }
        if (data.masterGeometry != null) {
            message.masterGeometry = Geometry.fromObject(data.masterGeometry);
        }
        if (data.configJSON != null) {
            message.configJSON = data.configJSON;
        }
        if (data.methodSet != null) {
            message.methodSet = MethodologySet.fromObject(data.methodSet);
        }
        if (data.baselineRunName != null) {
            message.baselineRunName = data.baselineRunName;
        }
        if (data.createdFromTemplate != null) {
            message.createdFromTemplate = data.createdFromTemplate;
        }
        if (data.startTime != null) {
            message.startTime = data.startTime;
        }
        if (data.endTime != null) {
            message.endTime = data.endTime;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.workflowId != null) {
            data.workflowId = this.workflowId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.enabled != null) {
            data.enabled = this.enabled;
        }
        if (this.workflowTasks != null) {
            data.workflowTasks = this.workflowTasks.map((item) => item.toObject());
        }
        if (this.dependent != null) {
            data.dependent = this.dependent;
        }
        if (this.overallStatus != null) {
            data.overallStatus = this.overallStatus;
        }
        if (this.systemRunId != null) {
            data.systemRunId = this.systemRunId;
        }
        if (this.teamBlobStorage != null) {
            data.teamBlobStorage = this.teamBlobStorage.toObject();
        }
        if (this.masterGeometry != null) {
            data.masterGeometry = this.masterGeometry.toObject();
        }
        if (this.configJSON != null) {
            data.configJSON = this.configJSON;
        }
        if (this.methodSet != null) {
            data.methodSet = this.methodSet.toObject();
        }
        if (this.baselineRunName != null) {
            data.baselineRunName = this.baselineRunName;
        }
        if (this.createdFromTemplate != null) {
            data.createdFromTemplate = this.createdFromTemplate;
        }
        if (this.startTime != null) {
            data.startTime = this.startTime;
        }
        if (this.endTime != null) {
            data.endTime = this.endTime;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.workflowId.length)
            writer.writeString(7, this.workflowId);
        if (this.name.length)
            writer.writeString(8, this.name);
        if (this.description.length)
            writer.writeString(9, this.description);
        if (this.enabled != false)
            writer.writeBool(10, this.enabled);
        if (this.workflowTasks.length)
            writer.writeRepeatedMessage(12, this.workflowTasks, (item) => item.serialize(writer));
        if (this.dependent != false)
            writer.writeBool(13, this.dependent);
        if (this.overallStatus != RunStatus.UNSPECIFIED)
            writer.writeEnum(14, this.overallStatus);
        if (this.systemRunId.length)
            writer.writeString(15, this.systemRunId);
        if (this.has_teamBlobStorage)
            writer.writeMessage(16, this.teamBlobStorage, () => this.teamBlobStorage.serialize(writer));
        if (this.has_masterGeometry)
            writer.writeMessage(17, this.masterGeometry, () => this.masterGeometry.serialize(writer));
        if (this.configJSON.length)
            writer.writeString(18, this.configJSON);
        if (this.has_methodSet)
            writer.writeMessage(20, this.methodSet, () => this.methodSet.serialize(writer));
        if (this.baselineRunName.length)
            writer.writeString(21, this.baselineRunName);
        if (this.createdFromTemplate.length)
            writer.writeString(22, this.createdFromTemplate);
        if (this.startTime != 0)
            writer.writeInt64(23, this.startTime);
        if (this.endTime != 0)
            writer.writeInt64(24, this.endTime);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Workflow();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.workflowId = reader.readString();
                    break;
                case 8:
                    message.name = reader.readString();
                    break;
                case 9:
                    message.description = reader.readString();
                    break;
                case 10:
                    message.enabled = reader.readBool();
                    break;
                case 12:
                    reader.readMessage(message.workflowTasks, () => pb_1.Message.addToRepeatedWrapperField(message, 12, WorkflowTask.deserialize(reader), WorkflowTask));
                    break;
                case 13:
                    message.dependent = reader.readBool();
                    break;
                case 14:
                    message.overallStatus = reader.readEnum();
                    break;
                case 15:
                    message.systemRunId = reader.readString();
                    break;
                case 16:
                    reader.readMessage(message.teamBlobStorage, () => message.teamBlobStorage = BlobStorage.deserialize(reader));
                    break;
                case 17:
                    reader.readMessage(message.masterGeometry, () => message.masterGeometry = Geometry.deserialize(reader));
                    break;
                case 18:
                    message.configJSON = reader.readString();
                    break;
                case 20:
                    reader.readMessage(message.methodSet, () => message.methodSet = MethodologySet.deserialize(reader));
                    break;
                case 21:
                    message.baselineRunName = reader.readString();
                    break;
                case 22:
                    message.createdFromTemplate = reader.readString();
                    break;
                case 23:
                    message.startTime = reader.readInt64();
                    break;
                case 24:
                    message.endTime = reader.readInt64();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Workflow.deserialize(bytes);
    }
}
exports.Workflow = Workflow;
_Workflow_one_of_decls = new WeakMap();
class WorkflowTask extends pb_1.Message {
    constructor(data) {
        super();
        _WorkflowTask_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _WorkflowTask_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("enabled" in data && data.enabled != undefined) {
                this.enabled = data.enabled;
            }
            if ("dependent" in data && data.dependent != undefined) {
                this.dependent = data.dependent;
            }
            if ("runConfig" in data && data.runConfig != undefined) {
                this.runConfig = data.runConfig;
            }
            if ("rescaleJob" in data && data.rescaleJob != undefined) {
                this.rescaleJob = data.rescaleJob;
            }
            if ("platformJob" in data && data.platformJob != undefined) {
                this.platformJob = data.platformJob;
            }
            if ("status" in data && data.status != undefined) {
                this.status = data.status;
            }
            if ("systemRunId" in data && data.systemRunId != undefined) {
                this.systemRunId = data.systemRunId;
            }
            if ("systemGenerated" in data && data.systemGenerated != undefined) {
                this.systemGenerated = data.systemGenerated;
            }
            if ("configJSON" in data && data.configJSON != undefined) {
                this.configJSON = data.configJSON;
            }
            if ("taskId" in data && data.taskId != undefined) {
                this.taskId = data.taskId;
            }
            if ("warnOnException" in data && data.warnOnException != undefined) {
                this.warnOnException = data.warnOnException;
            }
            if ("startTime" in data && data.startTime != undefined) {
                this.startTime = data.startTime;
            }
            if ("endTime" in data && data.endTime != undefined) {
                this.endTime = data.endTime;
            }
            if ("queueTime" in data && data.queueTime != undefined) {
                this.queueTime = data.queueTime;
            }
            if ("notifyOnCompletion" in data && data.notifyOnCompletion != undefined) {
                this.notifyOnCompletion = data.notifyOnCompletion;
            }
            if ("reportingCategory" in data && data.reportingCategory != undefined) {
                this.reportingCategory = data.reportingCategory;
            }
            if ("priority" in data && data.priority != undefined) {
                this.priority = data.priority;
            }
            if ("autoRetriesAllowed" in data && data.autoRetriesAllowed != undefined) {
                this.autoRetriesAllowed = data.autoRetriesAllowed;
            }
            if ("gmRefString" in data && data.gmRefString != undefined) {
                this.gmRefString = data.gmRefString;
            }
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
            if ("message" in data && data.message != undefined) {
                this.message = data.message;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get enabled() {
        return pb_1.Message.getFieldWithDefault(this, 9, false);
    }
    set enabled(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get dependent() {
        return pb_1.Message.getFieldWithDefault(this, 10, false);
    }
    set dependent(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get runConfig() {
        return pb_1.Message.getWrapperField(this, RunConfig, 11);
    }
    set runConfig(value) {
        pb_1.Message.setWrapperField(this, 11, value);
    }
    get has_runConfig() {
        return pb_1.Message.getField(this, 11) != null;
    }
    get rescaleJob() {
        return pb_1.Message.getWrapperField(this, dependency_1.RescaleJob, 12);
    }
    set rescaleJob(value) {
        pb_1.Message.setWrapperField(this, 12, value);
    }
    get has_rescaleJob() {
        return pb_1.Message.getField(this, 12) != null;
    }
    get platformJob() {
        return pb_1.Message.getWrapperField(this, PlatformJob, 13);
    }
    set platformJob(value) {
        pb_1.Message.setWrapperField(this, 13, value);
    }
    get has_platformJob() {
        return pb_1.Message.getField(this, 13) != null;
    }
    get status() {
        return pb_1.Message.getWrapperField(this, WorkflowTaskStatus, 14);
    }
    set status(value) {
        pb_1.Message.setWrapperField(this, 14, value);
    }
    get has_status() {
        return pb_1.Message.getField(this, 14) != null;
    }
    get systemRunId() {
        return pb_1.Message.getFieldWithDefault(this, 16, "");
    }
    set systemRunId(value) {
        pb_1.Message.setField(this, 16, value);
    }
    get systemGenerated() {
        return pb_1.Message.getFieldWithDefault(this, 17, false);
    }
    set systemGenerated(value) {
        pb_1.Message.setField(this, 17, value);
    }
    get configJSON() {
        return pb_1.Message.getFieldWithDefault(this, 18, "");
    }
    set configJSON(value) {
        pb_1.Message.setField(this, 18, value);
    }
    get taskId() {
        return pb_1.Message.getFieldWithDefault(this, 19, "");
    }
    set taskId(value) {
        pb_1.Message.setField(this, 19, value);
    }
    get warnOnException() {
        return pb_1.Message.getFieldWithDefault(this, 20, false);
    }
    set warnOnException(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get startTime() {
        return pb_1.Message.getFieldWithDefault(this, 22, 0);
    }
    set startTime(value) {
        pb_1.Message.setField(this, 22, value);
    }
    get endTime() {
        return pb_1.Message.getFieldWithDefault(this, 23, 0);
    }
    set endTime(value) {
        pb_1.Message.setField(this, 23, value);
    }
    get queueTime() {
        return pb_1.Message.getFieldWithDefault(this, 24, 0);
    }
    set queueTime(value) {
        pb_1.Message.setField(this, 24, value);
    }
    get notifyOnCompletion() {
        return pb_1.Message.getFieldWithDefault(this, 25, false);
    }
    set notifyOnCompletion(value) {
        pb_1.Message.setField(this, 25, value);
    }
    get reportingCategory() {
        return pb_1.Message.getFieldWithDefault(this, 26, "");
    }
    set reportingCategory(value) {
        pb_1.Message.setField(this, 26, value);
    }
    get priority() {
        return pb_1.Message.getFieldWithDefault(this, 27, 0);
    }
    set priority(value) {
        pb_1.Message.setField(this, 27, value);
    }
    get autoRetriesAllowed() {
        return pb_1.Message.getFieldWithDefault(this, 29, 0);
    }
    set autoRetriesAllowed(value) {
        pb_1.Message.setField(this, 29, value);
    }
    get gmRefString() {
        return pb_1.Message.getFieldWithDefault(this, 30, "");
    }
    set gmRefString(value) {
        pb_1.Message.setField(this, 30, value);
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 31, "");
    }
    set type(value) {
        pb_1.Message.setField(this, 31, value);
    }
    get message() {
        return pb_1.Message.getFieldWithDefault(this, 36, "");
    }
    set message(value) {
        pb_1.Message.setField(this, 36, value);
    }
    static fromObject(data) {
        const message = new WorkflowTask({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.enabled != null) {
            message.enabled = data.enabled;
        }
        if (data.dependent != null) {
            message.dependent = data.dependent;
        }
        if (data.runConfig != null) {
            message.runConfig = RunConfig.fromObject(data.runConfig);
        }
        if (data.rescaleJob != null) {
            message.rescaleJob = dependency_1.RescaleJob.fromObject(data.rescaleJob);
        }
        if (data.platformJob != null) {
            message.platformJob = PlatformJob.fromObject(data.platformJob);
        }
        if (data.status != null) {
            message.status = WorkflowTaskStatus.fromObject(data.status);
        }
        if (data.systemRunId != null) {
            message.systemRunId = data.systemRunId;
        }
        if (data.systemGenerated != null) {
            message.systemGenerated = data.systemGenerated;
        }
        if (data.configJSON != null) {
            message.configJSON = data.configJSON;
        }
        if (data.taskId != null) {
            message.taskId = data.taskId;
        }
        if (data.warnOnException != null) {
            message.warnOnException = data.warnOnException;
        }
        if (data.startTime != null) {
            message.startTime = data.startTime;
        }
        if (data.endTime != null) {
            message.endTime = data.endTime;
        }
        if (data.queueTime != null) {
            message.queueTime = data.queueTime;
        }
        if (data.notifyOnCompletion != null) {
            message.notifyOnCompletion = data.notifyOnCompletion;
        }
        if (data.reportingCategory != null) {
            message.reportingCategory = data.reportingCategory;
        }
        if (data.priority != null) {
            message.priority = data.priority;
        }
        if (data.autoRetriesAllowed != null) {
            message.autoRetriesAllowed = data.autoRetriesAllowed;
        }
        if (data.gmRefString != null) {
            message.gmRefString = data.gmRefString;
        }
        if (data.type != null) {
            message.type = data.type;
        }
        if (data.message != null) {
            message.message = data.message;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.enabled != null) {
            data.enabled = this.enabled;
        }
        if (this.dependent != null) {
            data.dependent = this.dependent;
        }
        if (this.runConfig != null) {
            data.runConfig = this.runConfig.toObject();
        }
        if (this.rescaleJob != null) {
            data.rescaleJob = this.rescaleJob.toObject();
        }
        if (this.platformJob != null) {
            data.platformJob = this.platformJob.toObject();
        }
        if (this.status != null) {
            data.status = this.status.toObject();
        }
        if (this.systemRunId != null) {
            data.systemRunId = this.systemRunId;
        }
        if (this.systemGenerated != null) {
            data.systemGenerated = this.systemGenerated;
        }
        if (this.configJSON != null) {
            data.configJSON = this.configJSON;
        }
        if (this.taskId != null) {
            data.taskId = this.taskId;
        }
        if (this.warnOnException != null) {
            data.warnOnException = this.warnOnException;
        }
        if (this.startTime != null) {
            data.startTime = this.startTime;
        }
        if (this.endTime != null) {
            data.endTime = this.endTime;
        }
        if (this.queueTime != null) {
            data.queueTime = this.queueTime;
        }
        if (this.notifyOnCompletion != null) {
            data.notifyOnCompletion = this.notifyOnCompletion;
        }
        if (this.reportingCategory != null) {
            data.reportingCategory = this.reportingCategory;
        }
        if (this.priority != null) {
            data.priority = this.priority;
        }
        if (this.autoRetriesAllowed != null) {
            data.autoRetriesAllowed = this.autoRetriesAllowed;
        }
        if (this.gmRefString != null) {
            data.gmRefString = this.gmRefString;
        }
        if (this.type != null) {
            data.type = this.type;
        }
        if (this.message != null) {
            data.message = this.message;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.name.length)
            writer.writeString(7, this.name);
        if (this.description.length)
            writer.writeString(8, this.description);
        if (this.enabled != false)
            writer.writeBool(9, this.enabled);
        if (this.dependent != false)
            writer.writeBool(10, this.dependent);
        if (this.has_runConfig)
            writer.writeMessage(11, this.runConfig, () => this.runConfig.serialize(writer));
        if (this.has_rescaleJob)
            writer.writeMessage(12, this.rescaleJob, () => this.rescaleJob.serialize(writer));
        if (this.has_platformJob)
            writer.writeMessage(13, this.platformJob, () => this.platformJob.serialize(writer));
        if (this.has_status)
            writer.writeMessage(14, this.status, () => this.status.serialize(writer));
        if (this.systemRunId.length)
            writer.writeString(16, this.systemRunId);
        if (this.systemGenerated != false)
            writer.writeBool(17, this.systemGenerated);
        if (this.configJSON.length)
            writer.writeString(18, this.configJSON);
        if (this.taskId.length)
            writer.writeString(19, this.taskId);
        if (this.warnOnException != false)
            writer.writeBool(20, this.warnOnException);
        if (this.startTime != 0)
            writer.writeInt64(22, this.startTime);
        if (this.endTime != 0)
            writer.writeInt64(23, this.endTime);
        if (this.queueTime != 0)
            writer.writeInt64(24, this.queueTime);
        if (this.notifyOnCompletion != false)
            writer.writeBool(25, this.notifyOnCompletion);
        if (this.reportingCategory.length)
            writer.writeString(26, this.reportingCategory);
        if (this.priority != 0)
            writer.writeInt32(27, this.priority);
        if (this.autoRetriesAllowed != 0)
            writer.writeInt32(29, this.autoRetriesAllowed);
        if (this.gmRefString.length)
            writer.writeString(30, this.gmRefString);
        if (this.type.length)
            writer.writeString(31, this.type);
        if (this.message.length)
            writer.writeString(36, this.message);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WorkflowTask();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.name = reader.readString();
                    break;
                case 8:
                    message.description = reader.readString();
                    break;
                case 9:
                    message.enabled = reader.readBool();
                    break;
                case 10:
                    message.dependent = reader.readBool();
                    break;
                case 11:
                    reader.readMessage(message.runConfig, () => message.runConfig = RunConfig.deserialize(reader));
                    break;
                case 12:
                    reader.readMessage(message.rescaleJob, () => message.rescaleJob = dependency_1.RescaleJob.deserialize(reader));
                    break;
                case 13:
                    reader.readMessage(message.platformJob, () => message.platformJob = PlatformJob.deserialize(reader));
                    break;
                case 14:
                    reader.readMessage(message.status, () => message.status = WorkflowTaskStatus.deserialize(reader));
                    break;
                case 16:
                    message.systemRunId = reader.readString();
                    break;
                case 17:
                    message.systemGenerated = reader.readBool();
                    break;
                case 18:
                    message.configJSON = reader.readString();
                    break;
                case 19:
                    message.taskId = reader.readString();
                    break;
                case 20:
                    message.warnOnException = reader.readBool();
                    break;
                case 22:
                    message.startTime = reader.readInt64();
                    break;
                case 23:
                    message.endTime = reader.readInt64();
                    break;
                case 24:
                    message.queueTime = reader.readInt64();
                    break;
                case 25:
                    message.notifyOnCompletion = reader.readBool();
                    break;
                case 26:
                    message.reportingCategory = reader.readString();
                    break;
                case 27:
                    message.priority = reader.readInt32();
                    break;
                case 29:
                    message.autoRetriesAllowed = reader.readInt32();
                    break;
                case 30:
                    message.gmRefString = reader.readString();
                    break;
                case 31:
                    message.type = reader.readString();
                    break;
                case 36:
                    message.message = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return WorkflowTask.deserialize(bytes);
    }
}
exports.WorkflowTask = WorkflowTask;
_WorkflowTask_one_of_decls = new WeakMap();
class PlatformJob extends pb_1.Message {
    constructor(data) {
        super();
        _PlatformJob_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4, 5], __classPrivateFieldGet(this, _PlatformJob_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
            if ("inputFiles" in data && data.inputFiles != undefined) {
                this.inputFiles = data.inputFiles;
            }
            if ("outputFiles" in data && data.outputFiles != undefined) {
                this.outputFiles = data.outputFiles;
            }
            if ("executeAPIEndpoint" in data && data.executeAPIEndpoint != undefined) {
                this.executeAPIEndpoint = data.executeAPIEndpoint;
            }
            if ("httpMethod" in data && data.httpMethod != undefined) {
                this.httpMethod = data.httpMethod;
            }
            if ("payload" in data && data.payload != undefined) {
                this.payload = data.payload;
            }
            if ("active" in data && data.active != undefined) {
                this.active = data.active;
            }
            if ("platformCopyConfig" in data && data.platformCopyConfig != undefined) {
                this.platformCopyConfig = data.platformCopyConfig;
            }
            if ("waitIntervalms" in data && data.waitIntervalms != undefined) {
                this.waitIntervalms = data.waitIntervalms;
            }
            if ("platformRemoteCommand" in data && data.platformRemoteCommand != undefined) {
                this.platformRemoteCommand = data.platformRemoteCommand;
            }
            if ("platformBatchCommand" in data && data.platformBatchCommand != undefined) {
                this.platformBatchCommand = data.platformBatchCommand;
            }
            if ("async" in data && data.async != undefined) {
                this.async = data.async;
            }
            if ("licenseQueue" in data && data.licenseQueue != undefined) {
                this.licenseQueue = data.licenseQueue;
            }
            if ("params" in data && data.params != undefined) {
                this.params = data.params;
            }
        }
        if (!this.params)
            this.params = new Map();
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set type(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get inputFiles() {
        return pb_1.Message.getRepeatedWrapperField(this, JobFile, 4);
    }
    set inputFiles(value) {
        pb_1.Message.setRepeatedWrapperField(this, 4, value);
    }
    get outputFiles() {
        return pb_1.Message.getRepeatedWrapperField(this, JobFile, 5);
    }
    set outputFiles(value) {
        pb_1.Message.setRepeatedWrapperField(this, 5, value);
    }
    get executeAPIEndpoint() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set executeAPIEndpoint(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get httpMethod() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set httpMethod(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get payload() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set payload(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get active() {
        return pb_1.Message.getFieldWithDefault(this, 9, false);
    }
    set active(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get platformCopyConfig() {
        return pb_1.Message.getWrapperField(this, PlatformCopyConfig, 10);
    }
    set platformCopyConfig(value) {
        pb_1.Message.setWrapperField(this, 10, value);
    }
    get has_platformCopyConfig() {
        return pb_1.Message.getField(this, 10) != null;
    }
    get waitIntervalms() {
        return pb_1.Message.getFieldWithDefault(this, 11, 0);
    }
    set waitIntervalms(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get platformRemoteCommand() {
        return pb_1.Message.getWrapperField(this, PlatformRemoteCommand, 13);
    }
    set platformRemoteCommand(value) {
        pb_1.Message.setWrapperField(this, 13, value);
    }
    get has_platformRemoteCommand() {
        return pb_1.Message.getField(this, 13) != null;
    }
    get platformBatchCommand() {
        return pb_1.Message.getWrapperField(this, PlatformBatch, 14);
    }
    set platformBatchCommand(value) {
        pb_1.Message.setWrapperField(this, 14, value);
    }
    get has_platformBatchCommand() {
        return pb_1.Message.getField(this, 14) != null;
    }
    get async() {
        return pb_1.Message.getFieldWithDefault(this, 15, false);
    }
    set async(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get licenseQueue() {
        return pb_1.Message.getWrapperField(this, LicenseQueue, 16);
    }
    set licenseQueue(value) {
        pb_1.Message.setWrapperField(this, 16, value);
    }
    get has_licenseQueue() {
        return pb_1.Message.getField(this, 16) != null;
    }
    get params() {
        return pb_1.Message.getField(this, 17);
    }
    set params(value) {
        pb_1.Message.setField(this, 17, value);
    }
    static fromObject(data) {
        const message = new PlatformJob({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.type != null) {
            message.type = data.type;
        }
        if (data.inputFiles != null) {
            message.inputFiles = data.inputFiles.map(item => JobFile.fromObject(item));
        }
        if (data.outputFiles != null) {
            message.outputFiles = data.outputFiles.map(item => JobFile.fromObject(item));
        }
        if (data.executeAPIEndpoint != null) {
            message.executeAPIEndpoint = data.executeAPIEndpoint;
        }
        if (data.httpMethod != null) {
            message.httpMethod = data.httpMethod;
        }
        if (data.payload != null) {
            message.payload = data.payload;
        }
        if (data.active != null) {
            message.active = data.active;
        }
        if (data.platformCopyConfig != null) {
            message.platformCopyConfig = PlatformCopyConfig.fromObject(data.platformCopyConfig);
        }
        if (data.waitIntervalms != null) {
            message.waitIntervalms = data.waitIntervalms;
        }
        if (data.platformRemoteCommand != null) {
            message.platformRemoteCommand = PlatformRemoteCommand.fromObject(data.platformRemoteCommand);
        }
        if (data.platformBatchCommand != null) {
            message.platformBatchCommand = PlatformBatch.fromObject(data.platformBatchCommand);
        }
        if (data.async != null) {
            message.async = data.async;
        }
        if (data.licenseQueue != null) {
            message.licenseQueue = LicenseQueue.fromObject(data.licenseQueue);
        }
        if (typeof data.params == "object") {
            message.params = new Map(Object.entries(data.params));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.type != null) {
            data.type = this.type;
        }
        if (this.inputFiles != null) {
            data.inputFiles = this.inputFiles.map((item) => item.toObject());
        }
        if (this.outputFiles != null) {
            data.outputFiles = this.outputFiles.map((item) => item.toObject());
        }
        if (this.executeAPIEndpoint != null) {
            data.executeAPIEndpoint = this.executeAPIEndpoint;
        }
        if (this.httpMethod != null) {
            data.httpMethod = this.httpMethod;
        }
        if (this.payload != null) {
            data.payload = this.payload;
        }
        if (this.active != null) {
            data.active = this.active;
        }
        if (this.platformCopyConfig != null) {
            data.platformCopyConfig = this.platformCopyConfig.toObject();
        }
        if (this.waitIntervalms != null) {
            data.waitIntervalms = this.waitIntervalms;
        }
        if (this.platformRemoteCommand != null) {
            data.platformRemoteCommand = this.platformRemoteCommand.toObject();
        }
        if (this.platformBatchCommand != null) {
            data.platformBatchCommand = this.platformBatchCommand.toObject();
        }
        if (this.async != null) {
            data.async = this.async;
        }
        if (this.licenseQueue != null) {
            data.licenseQueue = this.licenseQueue.toObject();
        }
        if (this.params != null) {
            data.params = (Object.fromEntries)(this.params);
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.description.length)
            writer.writeString(2, this.description);
        if (this.type.length)
            writer.writeString(3, this.type);
        if (this.inputFiles.length)
            writer.writeRepeatedMessage(4, this.inputFiles, (item) => item.serialize(writer));
        if (this.outputFiles.length)
            writer.writeRepeatedMessage(5, this.outputFiles, (item) => item.serialize(writer));
        if (this.executeAPIEndpoint.length)
            writer.writeString(6, this.executeAPIEndpoint);
        if (this.httpMethod.length)
            writer.writeString(7, this.httpMethod);
        if (this.payload.length)
            writer.writeString(8, this.payload);
        if (this.active != false)
            writer.writeBool(9, this.active);
        if (this.has_platformCopyConfig)
            writer.writeMessage(10, this.platformCopyConfig, () => this.platformCopyConfig.serialize(writer));
        if (this.waitIntervalms != 0)
            writer.writeInt32(11, this.waitIntervalms);
        if (this.has_platformRemoteCommand)
            writer.writeMessage(13, this.platformRemoteCommand, () => this.platformRemoteCommand.serialize(writer));
        if (this.has_platformBatchCommand)
            writer.writeMessage(14, this.platformBatchCommand, () => this.platformBatchCommand.serialize(writer));
        if (this.async != false)
            writer.writeBool(15, this.async);
        if (this.has_licenseQueue)
            writer.writeMessage(16, this.licenseQueue, () => this.licenseQueue.serialize(writer));
        for (const [key, value] of this.params) {
            writer.writeMessage(17, this.params, () => {
                writer.writeString(1, key);
                writer.writeString(2, value);
            });
        }
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlatformJob();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.description = reader.readString();
                    break;
                case 3:
                    message.type = reader.readString();
                    break;
                case 4:
                    reader.readMessage(message.inputFiles, () => pb_1.Message.addToRepeatedWrapperField(message, 4, JobFile.deserialize(reader), JobFile));
                    break;
                case 5:
                    reader.readMessage(message.outputFiles, () => pb_1.Message.addToRepeatedWrapperField(message, 5, JobFile.deserialize(reader), JobFile));
                    break;
                case 6:
                    message.executeAPIEndpoint = reader.readString();
                    break;
                case 7:
                    message.httpMethod = reader.readString();
                    break;
                case 8:
                    message.payload = reader.readString();
                    break;
                case 9:
                    message.active = reader.readBool();
                    break;
                case 10:
                    reader.readMessage(message.platformCopyConfig, () => message.platformCopyConfig = PlatformCopyConfig.deserialize(reader));
                    break;
                case 11:
                    message.waitIntervalms = reader.readInt32();
                    break;
                case 13:
                    reader.readMessage(message.platformRemoteCommand, () => message.platformRemoteCommand = PlatformRemoteCommand.deserialize(reader));
                    break;
                case 14:
                    reader.readMessage(message.platformBatchCommand, () => message.platformBatchCommand = PlatformBatch.deserialize(reader));
                    break;
                case 15:
                    message.async = reader.readBool();
                    break;
                case 16:
                    reader.readMessage(message.licenseQueue, () => message.licenseQueue = LicenseQueue.deserialize(reader));
                    break;
                case 17:
                    reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.params, reader, reader.readString, reader.readString));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return PlatformJob.deserialize(bytes);
    }
}
exports.PlatformJob = PlatformJob;
_PlatformJob_one_of_decls = new WeakMap();
class LicenseQueue extends pb_1.Message {
    constructor(data) {
        super();
        _LicenseQueue_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _LicenseQueue_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("queueName" in data && data.queueName != undefined) {
                this.queueName = data.queueName;
            }
        }
    }
    get queueName() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set queueName(value) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data) {
        const message = new LicenseQueue({});
        if (data.queueName != null) {
            message.queueName = data.queueName;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.queueName != null) {
            data.queueName = this.queueName;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.queueName.length)
            writer.writeString(1, this.queueName);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LicenseQueue();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.queueName = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return LicenseQueue.deserialize(bytes);
    }
}
exports.LicenseQueue = LicenseQueue;
_LicenseQueue_one_of_decls = new WeakMap();
class PlatformRemoteCommand extends pb_1.Message {
    constructor(data) {
        super();
        _PlatformRemoteCommand_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _PlatformRemoteCommand_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("localScriptPath" in data && data.localScriptPath != undefined) {
                this.localScriptPath = data.localScriptPath;
            }
            if ("localScriptCommand" in data && data.localScriptCommand != undefined) {
                this.localScriptCommand = data.localScriptCommand;
            }
            if ("gmRef" in data && data.gmRef != undefined) {
                this.gmRef = data.gmRef;
            }
            if ("receiverTarget" in data && data.receiverTarget != undefined) {
                this.receiverTarget = data.receiverTarget;
            }
        }
    }
    get localScriptPath() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set localScriptPath(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get localScriptCommand() {
        return pb_1.Message.getFieldWithDefault(this, 20, "");
    }
    set localScriptCommand(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get gmRef() {
        return pb_1.Message.getWrapperField(this, GMRef, 30);
    }
    set gmRef(value) {
        pb_1.Message.setWrapperField(this, 30, value);
    }
    get has_gmRef() {
        return pb_1.Message.getField(this, 30) != null;
    }
    get receiverTarget() {
        return pb_1.Message.getFieldWithDefault(this, 40, "");
    }
    set receiverTarget(value) {
        pb_1.Message.setField(this, 40, value);
    }
    static fromObject(data) {
        const message = new PlatformRemoteCommand({});
        if (data.localScriptPath != null) {
            message.localScriptPath = data.localScriptPath;
        }
        if (data.localScriptCommand != null) {
            message.localScriptCommand = data.localScriptCommand;
        }
        if (data.gmRef != null) {
            message.gmRef = GMRef.fromObject(data.gmRef);
        }
        if (data.receiverTarget != null) {
            message.receiverTarget = data.receiverTarget;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.localScriptPath != null) {
            data.localScriptPath = this.localScriptPath;
        }
        if (this.localScriptCommand != null) {
            data.localScriptCommand = this.localScriptCommand;
        }
        if (this.gmRef != null) {
            data.gmRef = this.gmRef.toObject();
        }
        if (this.receiverTarget != null) {
            data.receiverTarget = this.receiverTarget;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.localScriptPath.length)
            writer.writeString(10, this.localScriptPath);
        if (this.localScriptCommand.length)
            writer.writeString(20, this.localScriptCommand);
        if (this.has_gmRef)
            writer.writeMessage(30, this.gmRef, () => this.gmRef.serialize(writer));
        if (this.receiverTarget.length)
            writer.writeString(40, this.receiverTarget);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlatformRemoteCommand();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 10:
                    message.localScriptPath = reader.readString();
                    break;
                case 20:
                    message.localScriptCommand = reader.readString();
                    break;
                case 30:
                    reader.readMessage(message.gmRef, () => message.gmRef = GMRef.deserialize(reader));
                    break;
                case 40:
                    message.receiverTarget = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return PlatformRemoteCommand.deserialize(bytes);
    }
}
exports.PlatformRemoteCommand = PlatformRemoteCommand;
_PlatformRemoteCommand_one_of_decls = new WeakMap();
class GMRef extends pb_1.Message {
    constructor(data) {
        super();
        _GMRef_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _GMRef_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("workflowSubmissionId" in data && data.workflowSubmissionId != undefined) {
                this.workflowSubmissionId = data.workflowSubmissionId;
            }
            if ("runGroupId" in data && data.runGroupId != undefined) {
                this.runGroupId = data.runGroupId;
            }
            if ("workflowSysRunId" in data && data.workflowSysRunId != undefined) {
                this.workflowSysRunId = data.workflowSysRunId;
            }
            if ("workflowTaskSysRunId" in data && data.workflowTaskSysRunId != undefined) {
                this.workflowTaskSysRunId = data.workflowTaskSysRunId;
            }
            if ("dbId" in data && data.dbId != undefined) {
                this.dbId = data.dbId;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
        }
    }
    get workflowSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set workflowSubmissionId(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get runGroupId() {
        return pb_1.Message.getFieldWithDefault(this, 20, "");
    }
    set runGroupId(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get workflowSysRunId() {
        return pb_1.Message.getFieldWithDefault(this, 30, "");
    }
    set workflowSysRunId(value) {
        pb_1.Message.setField(this, 30, value);
    }
    get workflowTaskSysRunId() {
        return pb_1.Message.getFieldWithDefault(this, 40, "");
    }
    set workflowTaskSysRunId(value) {
        pb_1.Message.setField(this, 40, value);
    }
    get dbId() {
        return pb_1.Message.getFieldWithDefault(this, 50, "");
    }
    set dbId(value) {
        pb_1.Message.setField(this, 50, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 60, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 60, value);
    }
    static fromObject(data) {
        const message = new GMRef({});
        if (data.workflowSubmissionId != null) {
            message.workflowSubmissionId = data.workflowSubmissionId;
        }
        if (data.runGroupId != null) {
            message.runGroupId = data.runGroupId;
        }
        if (data.workflowSysRunId != null) {
            message.workflowSysRunId = data.workflowSysRunId;
        }
        if (data.workflowTaskSysRunId != null) {
            message.workflowTaskSysRunId = data.workflowTaskSysRunId;
        }
        if (data.dbId != null) {
            message.dbId = data.dbId;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.workflowSubmissionId != null) {
            data.workflowSubmissionId = this.workflowSubmissionId;
        }
        if (this.runGroupId != null) {
            data.runGroupId = this.runGroupId;
        }
        if (this.workflowSysRunId != null) {
            data.workflowSysRunId = this.workflowSysRunId;
        }
        if (this.workflowTaskSysRunId != null) {
            data.workflowTaskSysRunId = this.workflowTaskSysRunId;
        }
        if (this.dbId != null) {
            data.dbId = this.dbId;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.workflowSubmissionId.length)
            writer.writeString(10, this.workflowSubmissionId);
        if (this.runGroupId.length)
            writer.writeString(20, this.runGroupId);
        if (this.workflowSysRunId.length)
            writer.writeString(30, this.workflowSysRunId);
        if (this.workflowTaskSysRunId.length)
            writer.writeString(40, this.workflowTaskSysRunId);
        if (this.dbId.length)
            writer.writeString(50, this.dbId);
        if (this.raceTeamId.length)
            writer.writeString(60, this.raceTeamId);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GMRef();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 10:
                    message.workflowSubmissionId = reader.readString();
                    break;
                case 20:
                    message.runGroupId = reader.readString();
                    break;
                case 30:
                    message.workflowSysRunId = reader.readString();
                    break;
                case 40:
                    message.workflowTaskSysRunId = reader.readString();
                    break;
                case 50:
                    message.dbId = reader.readString();
                    break;
                case 60:
                    message.raceTeamId = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return GMRef.deserialize(bytes);
    }
}
exports.GMRef = GMRef;
_GMRef_one_of_decls = new WeakMap();
class PlatformCopyConfig extends pb_1.Message {
    constructor(data) {
        super();
        _PlatformCopyConfig_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _PlatformCopyConfig_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("sourceAccount" in data && data.sourceAccount != undefined) {
                this.sourceAccount = data.sourceAccount;
            }
            if ("sourceBlobAddr" in data && data.sourceBlobAddr != undefined) {
                this.sourceBlobAddr = data.sourceBlobAddr;
            }
            if ("sourceContainerName" in data && data.sourceContainerName != undefined) {
                this.sourceContainerName = data.sourceContainerName;
            }
            if ("destinationAccount" in data && data.destinationAccount != undefined) {
                this.destinationAccount = data.destinationAccount;
            }
            if ("destinationBlobAddr" in data && data.destinationBlobAddr != undefined) {
                this.destinationBlobAddr = data.destinationBlobAddr;
            }
            if ("destinationContainerName" in data && data.destinationContainerName != undefined) {
                this.destinationContainerName = data.destinationContainerName;
            }
            if ("sourceFileType" in data && data.sourceFileType != undefined) {
                this.sourceFileType = data.sourceFileType;
            }
            if ("destinationFileType" in data && data.destinationFileType != undefined) {
                this.destinationFileType = data.destinationFileType;
            }
            if ("rawFileAsString" in data && data.rawFileAsString != undefined) {
                this.rawFileAsString = data.rawFileAsString;
            }
            if ("recursive" in data && data.recursive != undefined) {
                this.recursive = data.recursive;
            }
            if ("includeFileExtension" in data && data.includeFileExtension != undefined) {
                this.includeFileExtension = data.includeFileExtension;
            }
            if ("removeF1PartDups" in data && data.removeF1PartDups != undefined) {
                this.removeF1PartDups = data.removeF1PartDups;
            }
            if ("recurseSubDirs" in data && data.recurseSubDirs != undefined) {
                this.recurseSubDirs = data.recurseSubDirs;
            }
            if ("findFileString" in data && data.findFileString != undefined) {
                this.findFileString = data.findFileString;
            }
            if ("replaceFileString" in data && data.replaceFileString != undefined) {
                this.replaceFileString = data.replaceFileString;
            }
        }
    }
    get sourceAccount() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set sourceAccount(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get sourceBlobAddr() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set sourceBlobAddr(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get sourceContainerName() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set sourceContainerName(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get destinationAccount() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set destinationAccount(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get destinationBlobAddr() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set destinationBlobAddr(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get destinationContainerName() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set destinationContainerName(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get sourceFileType() {
        return pb_1.Message.getFieldWithDefault(this, 7, CopyFileType.NOT_USED_VAL_File);
    }
    set sourceFileType(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get destinationFileType() {
        return pb_1.Message.getFieldWithDefault(this, 8, CopyFileType.NOT_USED_VAL_File);
    }
    set destinationFileType(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get rawFileAsString() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set rawFileAsString(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get recursive() {
        return pb_1.Message.getFieldWithDefault(this, 10, false);
    }
    set recursive(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get includeFileExtension() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set includeFileExtension(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get removeF1PartDups() {
        return pb_1.Message.getFieldWithDefault(this, 12, false);
    }
    set removeF1PartDups(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get recurseSubDirs() {
        return pb_1.Message.getFieldWithDefault(this, 13, false);
    }
    set recurseSubDirs(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get findFileString() {
        return pb_1.Message.getFieldWithDefault(this, 14, "");
    }
    set findFileString(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get replaceFileString() {
        return pb_1.Message.getFieldWithDefault(this, 15, "");
    }
    set replaceFileString(value) {
        pb_1.Message.setField(this, 15, value);
    }
    static fromObject(data) {
        const message = new PlatformCopyConfig({});
        if (data.sourceAccount != null) {
            message.sourceAccount = data.sourceAccount;
        }
        if (data.sourceBlobAddr != null) {
            message.sourceBlobAddr = data.sourceBlobAddr;
        }
        if (data.sourceContainerName != null) {
            message.sourceContainerName = data.sourceContainerName;
        }
        if (data.destinationAccount != null) {
            message.destinationAccount = data.destinationAccount;
        }
        if (data.destinationBlobAddr != null) {
            message.destinationBlobAddr = data.destinationBlobAddr;
        }
        if (data.destinationContainerName != null) {
            message.destinationContainerName = data.destinationContainerName;
        }
        if (data.sourceFileType != null) {
            message.sourceFileType = data.sourceFileType;
        }
        if (data.destinationFileType != null) {
            message.destinationFileType = data.destinationFileType;
        }
        if (data.rawFileAsString != null) {
            message.rawFileAsString = data.rawFileAsString;
        }
        if (data.recursive != null) {
            message.recursive = data.recursive;
        }
        if (data.includeFileExtension != null) {
            message.includeFileExtension = data.includeFileExtension;
        }
        if (data.removeF1PartDups != null) {
            message.removeF1PartDups = data.removeF1PartDups;
        }
        if (data.recurseSubDirs != null) {
            message.recurseSubDirs = data.recurseSubDirs;
        }
        if (data.findFileString != null) {
            message.findFileString = data.findFileString;
        }
        if (data.replaceFileString != null) {
            message.replaceFileString = data.replaceFileString;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.sourceAccount != null) {
            data.sourceAccount = this.sourceAccount;
        }
        if (this.sourceBlobAddr != null) {
            data.sourceBlobAddr = this.sourceBlobAddr;
        }
        if (this.sourceContainerName != null) {
            data.sourceContainerName = this.sourceContainerName;
        }
        if (this.destinationAccount != null) {
            data.destinationAccount = this.destinationAccount;
        }
        if (this.destinationBlobAddr != null) {
            data.destinationBlobAddr = this.destinationBlobAddr;
        }
        if (this.destinationContainerName != null) {
            data.destinationContainerName = this.destinationContainerName;
        }
        if (this.sourceFileType != null) {
            data.sourceFileType = this.sourceFileType;
        }
        if (this.destinationFileType != null) {
            data.destinationFileType = this.destinationFileType;
        }
        if (this.rawFileAsString != null) {
            data.rawFileAsString = this.rawFileAsString;
        }
        if (this.recursive != null) {
            data.recursive = this.recursive;
        }
        if (this.includeFileExtension != null) {
            data.includeFileExtension = this.includeFileExtension;
        }
        if (this.removeF1PartDups != null) {
            data.removeF1PartDups = this.removeF1PartDups;
        }
        if (this.recurseSubDirs != null) {
            data.recurseSubDirs = this.recurseSubDirs;
        }
        if (this.findFileString != null) {
            data.findFileString = this.findFileString;
        }
        if (this.replaceFileString != null) {
            data.replaceFileString = this.replaceFileString;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.sourceAccount.length)
            writer.writeString(1, this.sourceAccount);
        if (this.sourceBlobAddr.length)
            writer.writeString(2, this.sourceBlobAddr);
        if (this.sourceContainerName.length)
            writer.writeString(3, this.sourceContainerName);
        if (this.destinationAccount.length)
            writer.writeString(4, this.destinationAccount);
        if (this.destinationBlobAddr.length)
            writer.writeString(5, this.destinationBlobAddr);
        if (this.destinationContainerName.length)
            writer.writeString(6, this.destinationContainerName);
        if (this.sourceFileType != CopyFileType.NOT_USED_VAL_File)
            writer.writeEnum(7, this.sourceFileType);
        if (this.destinationFileType != CopyFileType.NOT_USED_VAL_File)
            writer.writeEnum(8, this.destinationFileType);
        if (this.rawFileAsString.length)
            writer.writeString(9, this.rawFileAsString);
        if (this.recursive != false)
            writer.writeBool(10, this.recursive);
        if (this.includeFileExtension.length)
            writer.writeString(11, this.includeFileExtension);
        if (this.removeF1PartDups != false)
            writer.writeBool(12, this.removeF1PartDups);
        if (this.recurseSubDirs != false)
            writer.writeBool(13, this.recurseSubDirs);
        if (this.findFileString.length)
            writer.writeString(14, this.findFileString);
        if (this.replaceFileString.length)
            writer.writeString(15, this.replaceFileString);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlatformCopyConfig();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.sourceAccount = reader.readString();
                    break;
                case 2:
                    message.sourceBlobAddr = reader.readString();
                    break;
                case 3:
                    message.sourceContainerName = reader.readString();
                    break;
                case 4:
                    message.destinationAccount = reader.readString();
                    break;
                case 5:
                    message.destinationBlobAddr = reader.readString();
                    break;
                case 6:
                    message.destinationContainerName = reader.readString();
                    break;
                case 7:
                    message.sourceFileType = reader.readEnum();
                    break;
                case 8:
                    message.destinationFileType = reader.readEnum();
                    break;
                case 9:
                    message.rawFileAsString = reader.readString();
                    break;
                case 10:
                    message.recursive = reader.readBool();
                    break;
                case 11:
                    message.includeFileExtension = reader.readString();
                    break;
                case 12:
                    message.removeF1PartDups = reader.readBool();
                    break;
                case 13:
                    message.recurseSubDirs = reader.readBool();
                    break;
                case 14:
                    message.findFileString = reader.readString();
                    break;
                case 15:
                    message.replaceFileString = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return PlatformCopyConfig.deserialize(bytes);
    }
}
exports.PlatformCopyConfig = PlatformCopyConfig;
_PlatformCopyConfig_one_of_decls = new WeakMap();
class PlatformBatch extends pb_1.Message {
    constructor(data) {
        super();
        _PlatformBatch_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [11], __classPrivateFieldGet(this, _PlatformBatch_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("createTasksClassname" in data && data.createTasksClassname != undefined) {
                this.createTasksClassname = data.createTasksClassname;
            }
            if ("batchTasks" in data && data.batchTasks != undefined) {
                this.batchTasks = data.batchTasks;
            }
        }
    }
    get createTasksClassname() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set createTasksClassname(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get batchTasks() {
        return pb_1.Message.getRepeatedWrapperField(this, WorkflowTask, 11);
    }
    set batchTasks(value) {
        pb_1.Message.setRepeatedWrapperField(this, 11, value);
    }
    static fromObject(data) {
        const message = new PlatformBatch({});
        if (data.createTasksClassname != null) {
            message.createTasksClassname = data.createTasksClassname;
        }
        if (data.batchTasks != null) {
            message.batchTasks = data.batchTasks.map(item => WorkflowTask.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.createTasksClassname != null) {
            data.createTasksClassname = this.createTasksClassname;
        }
        if (this.batchTasks != null) {
            data.batchTasks = this.batchTasks.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.createTasksClassname.length)
            writer.writeString(10, this.createTasksClassname);
        if (this.batchTasks.length)
            writer.writeRepeatedMessage(11, this.batchTasks, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlatformBatch();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 10:
                    message.createTasksClassname = reader.readString();
                    break;
                case 11:
                    reader.readMessage(message.batchTasks, () => pb_1.Message.addToRepeatedWrapperField(message, 11, WorkflowTask.deserialize(reader), WorkflowTask));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return PlatformBatch.deserialize(bytes);
    }
}
exports.PlatformBatch = PlatformBatch;
_PlatformBatch_one_of_decls = new WeakMap();
class SecConfig extends pb_1.Message {
    constructor(data) {
        super();
        _SecConfig_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [7], __classPrivateFieldGet(this, _SecConfig_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("secToken" in data && data.secToken != undefined) {
                this.secToken = data.secToken;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get secToken() {
        return pb_1.Message.getRepeatedWrapperField(this, SecToken, 7);
    }
    set secToken(value) {
        pb_1.Message.setRepeatedWrapperField(this, 7, value);
    }
    static fromObject(data) {
        const message = new SecConfig({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.secToken != null) {
            message.secToken = data.secToken.map(item => SecToken.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.secToken != null) {
            data.secToken = this.secToken.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.timeCreated != 0)
            writer.writeInt64(3, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.secToken.length)
            writer.writeRepeatedMessage(7, this.secToken, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SecConfig();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.timeCreated = reader.readInt64();
                    break;
                case 4:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    reader.readMessage(message.secToken, () => pb_1.Message.addToRepeatedWrapperField(message, 7, SecToken.deserialize(reader), SecToken));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SecConfig.deserialize(bytes);
    }
}
exports.SecConfig = SecConfig;
_SecConfig_one_of_decls = new WeakMap();
class SecToken extends pb_1.Message {
    constructor(data) {
        super();
        _SecToken_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _SecToken_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("accountName" in data && data.accountName != undefined) {
                this.accountName = data.accountName;
            }
            if ("token" in data && data.token != undefined) {
                this.token = data.token;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get accountName() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set accountName(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get token() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set token(value) {
        pb_1.Message.setField(this, 3, value);
    }
    static fromObject(data) {
        const message = new SecToken({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.accountName != null) {
            message.accountName = data.accountName;
        }
        if (data.token != null) {
            message.token = data.token;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.accountName != null) {
            data.accountName = this.accountName;
        }
        if (this.token != null) {
            data.token = this.token;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.accountName.length)
            writer.writeString(2, this.accountName);
        if (this.token.length)
            writer.writeString(3, this.token);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SecToken();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.accountName = reader.readString();
                    break;
                case 3:
                    message.token = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SecToken.deserialize(bytes);
    }
}
exports.SecToken = SecToken;
_SecToken_one_of_decls = new WeakMap();
class JobFile extends pb_1.Message {
    constructor(data) {
        super();
        _JobFile_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _JobFile_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("fileId" in data && data.fileId != undefined) {
                this.fileId = data.fileId;
            }
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
        }
    }
    get fileId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set fileId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set type(value) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data) {
        const message = new JobFile({});
        if (data.fileId != null) {
            message.fileId = data.fileId;
        }
        if (data.type != null) {
            message.type = data.type;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.fileId != null) {
            data.fileId = this.fileId;
        }
        if (this.type != null) {
            data.type = this.type;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.fileId.length)
            writer.writeString(1, this.fileId);
        if (this.type.length)
            writer.writeString(2, this.type);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new JobFile();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.fileId = reader.readString();
                    break;
                case 2:
                    message.type = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return JobFile.deserialize(bytes);
    }
}
exports.JobFile = JobFile;
_JobFile_one_of_decls = new WeakMap();
class WorkflowTaskStatus extends pb_1.Message {
    constructor(data) {
        super();
        _WorkflowTaskStatus_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [17], __classPrivateFieldGet(this, _WorkflowTaskStatus_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("submitTime" in data && data.submitTime != undefined) {
                this.submitTime = data.submitTime;
            }
            if ("startTime" in data && data.startTime != undefined) {
                this.startTime = data.startTime;
            }
            if ("completeTime" in data && data.completeTime != undefined) {
                this.completeTime = data.completeTime;
            }
            if ("submitRunId" in data && data.submitRunId != undefined) {
                this.submitRunId = data.submitRunId;
            }
            if ("runStatus" in data && data.runStatus != undefined) {
                this.runStatus = data.runStatus;
            }
            if ("httpResultCode" in data && data.httpResultCode != undefined) {
                this.httpResultCode = data.httpResultCode;
            }
            if ("httpResultText" in data && data.httpResultText != undefined) {
                this.httpResultText = data.httpResultText;
            }
            if ("returnedJobId" in data && data.returnedJobId != undefined) {
                this.returnedJobId = data.returnedJobId;
            }
            if ("externaljobQueryURL" in data && data.externaljobQueryURL != undefined) {
                this.externaljobQueryURL = data.externaljobQueryURL;
            }
            if ("failedWithWarning" in data && data.failedWithWarning != undefined) {
                this.failedWithWarning = data.failedWithWarning;
            }
            if ("runLog" in data && data.runLog != undefined) {
                this.runLog = data.runLog;
            }
            if ("runCount" in data && data.runCount != undefined) {
                this.runCount = data.runCount;
            }
        }
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get submitTime() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set submitTime(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get startTime() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set startTime(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get completeTime() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set completeTime(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get submitRunId() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set submitRunId(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get runStatus() {
        return pb_1.Message.getFieldWithDefault(this, 11, RunStatus.UNSPECIFIED);
    }
    set runStatus(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get httpResultCode() {
        return pb_1.Message.getFieldWithDefault(this, 12, 0);
    }
    set httpResultCode(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get httpResultText() {
        return pb_1.Message.getFieldWithDefault(this, 13, "");
    }
    set httpResultText(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get returnedJobId() {
        return pb_1.Message.getFieldWithDefault(this, 14, "");
    }
    set returnedJobId(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get externaljobQueryURL() {
        return pb_1.Message.getFieldWithDefault(this, 15, "");
    }
    set externaljobQueryURL(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get failedWithWarning() {
        return pb_1.Message.getFieldWithDefault(this, 16, false);
    }
    set failedWithWarning(value) {
        pb_1.Message.setField(this, 16, value);
    }
    get runLog() {
        return pb_1.Message.getFieldWithDefault(this, 17, []);
    }
    set runLog(value) {
        pb_1.Message.setField(this, 17, value);
    }
    get runCount() {
        return pb_1.Message.getFieldWithDefault(this, 18, 0);
    }
    set runCount(value) {
        pb_1.Message.setField(this, 18, value);
    }
    static fromObject(data) {
        const message = new WorkflowTaskStatus({});
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.submitTime != null) {
            message.submitTime = data.submitTime;
        }
        if (data.startTime != null) {
            message.startTime = data.startTime;
        }
        if (data.completeTime != null) {
            message.completeTime = data.completeTime;
        }
        if (data.submitRunId != null) {
            message.submitRunId = data.submitRunId;
        }
        if (data.runStatus != null) {
            message.runStatus = data.runStatus;
        }
        if (data.httpResultCode != null) {
            message.httpResultCode = data.httpResultCode;
        }
        if (data.httpResultText != null) {
            message.httpResultText = data.httpResultText;
        }
        if (data.returnedJobId != null) {
            message.returnedJobId = data.returnedJobId;
        }
        if (data.externaljobQueryURL != null) {
            message.externaljobQueryURL = data.externaljobQueryURL;
        }
        if (data.failedWithWarning != null) {
            message.failedWithWarning = data.failedWithWarning;
        }
        if (data.runLog != null) {
            message.runLog = data.runLog;
        }
        if (data.runCount != null) {
            message.runCount = data.runCount;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.submitTime != null) {
            data.submitTime = this.submitTime;
        }
        if (this.startTime != null) {
            data.startTime = this.startTime;
        }
        if (this.completeTime != null) {
            data.completeTime = this.completeTime;
        }
        if (this.submitRunId != null) {
            data.submitRunId = this.submitRunId;
        }
        if (this.runStatus != null) {
            data.runStatus = this.runStatus;
        }
        if (this.httpResultCode != null) {
            data.httpResultCode = this.httpResultCode;
        }
        if (this.httpResultText != null) {
            data.httpResultText = this.httpResultText;
        }
        if (this.returnedJobId != null) {
            data.returnedJobId = this.returnedJobId;
        }
        if (this.externaljobQueryURL != null) {
            data.externaljobQueryURL = this.externaljobQueryURL;
        }
        if (this.failedWithWarning != null) {
            data.failedWithWarning = this.failedWithWarning;
        }
        if (this.runLog != null) {
            data.runLog = this.runLog;
        }
        if (this.runCount != null) {
            data.runCount = this.runCount;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.timeCreated.length)
            writer.writeString(3, this.timeCreated);
        if (this.timeUpdated.length)
            writer.writeString(4, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(6, this.updateByUser);
        if (this.submitTime.length)
            writer.writeString(7, this.submitTime);
        if (this.startTime.length)
            writer.writeString(8, this.startTime);
        if (this.completeTime.length)
            writer.writeString(9, this.completeTime);
        if (this.submitRunId.length)
            writer.writeString(10, this.submitRunId);
        if (this.runStatus != RunStatus.UNSPECIFIED)
            writer.writeEnum(11, this.runStatus);
        if (this.httpResultCode != 0)
            writer.writeInt32(12, this.httpResultCode);
        if (this.httpResultText.length)
            writer.writeString(13, this.httpResultText);
        if (this.returnedJobId.length)
            writer.writeString(14, this.returnedJobId);
        if (this.externaljobQueryURL.length)
            writer.writeString(15, this.externaljobQueryURL);
        if (this.failedWithWarning != false)
            writer.writeBool(16, this.failedWithWarning);
        if (this.runLog.length)
            writer.writeRepeatedString(17, this.runLog);
        if (this.runCount != 0)
            writer.writeInt32(18, this.runCount);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WorkflowTaskStatus();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 3:
                    message.timeCreated = reader.readString();
                    break;
                case 4:
                    message.timeUpdated = reader.readString();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    message.updateByUser = reader.readString();
                    break;
                case 7:
                    message.submitTime = reader.readString();
                    break;
                case 8:
                    message.startTime = reader.readString();
                    break;
                case 9:
                    message.completeTime = reader.readString();
                    break;
                case 10:
                    message.submitRunId = reader.readString();
                    break;
                case 11:
                    message.runStatus = reader.readEnum();
                    break;
                case 12:
                    message.httpResultCode = reader.readInt32();
                    break;
                case 13:
                    message.httpResultText = reader.readString();
                    break;
                case 14:
                    message.returnedJobId = reader.readString();
                    break;
                case 15:
                    message.externaljobQueryURL = reader.readString();
                    break;
                case 16:
                    message.failedWithWarning = reader.readBool();
                    break;
                case 17:
                    pb_1.Message.addToRepeatedField(message, 17, reader.readString());
                    break;
                case 18:
                    message.runCount = reader.readInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return WorkflowTaskStatus.deserialize(bytes);
    }
}
exports.WorkflowTaskStatus = WorkflowTaskStatus;
_WorkflowTaskStatus_one_of_decls = new WeakMap();
class WorkflowJSONResult extends pb_1.Message {
    constructor(data) {
        super();
        _WorkflowJSONResult_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _WorkflowJSONResult_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("workflowResultAsJSON" in data && data.workflowResultAsJSON != undefined) {
                this.workflowResultAsJSON = data.workflowResultAsJSON;
            }
            if ("queryString" in data && data.queryString != undefined) {
                this.queryString = data.queryString;
            }
            if ("resultMsgText" in data && data.resultMsgText != undefined) {
                this.resultMsgText = data.resultMsgText;
            }
        }
    }
    get workflowResultAsJSON() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set workflowResultAsJSON(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get queryString() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set queryString(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get resultMsgText() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set resultMsgText(value) {
        pb_1.Message.setField(this, 3, value);
    }
    static fromObject(data) {
        const message = new WorkflowJSONResult({});
        if (data.workflowResultAsJSON != null) {
            message.workflowResultAsJSON = data.workflowResultAsJSON;
        }
        if (data.queryString != null) {
            message.queryString = data.queryString;
        }
        if (data.resultMsgText != null) {
            message.resultMsgText = data.resultMsgText;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.workflowResultAsJSON != null) {
            data.workflowResultAsJSON = this.workflowResultAsJSON;
        }
        if (this.queryString != null) {
            data.queryString = this.queryString;
        }
        if (this.resultMsgText != null) {
            data.resultMsgText = this.resultMsgText;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.workflowResultAsJSON.length)
            writer.writeString(1, this.workflowResultAsJSON);
        if (this.queryString.length)
            writer.writeString(2, this.queryString);
        if (this.resultMsgText.length)
            writer.writeString(3, this.resultMsgText);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WorkflowJSONResult();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.workflowResultAsJSON = reader.readString();
                    break;
                case 2:
                    message.queryString = reader.readString();
                    break;
                case 3:
                    message.resultMsgText = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return WorkflowJSONResult.deserialize(bytes);
    }
}
exports.WorkflowJSONResult = WorkflowJSONResult;
_WorkflowJSONResult_one_of_decls = new WeakMap();
class RunConfig extends pb_1.Message {
    constructor(data) {
        super();
        _RunConfig_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [40, 46, 49, 50], __classPrivateFieldGet(this, _RunConfig_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("runId" in data && data.runId != undefined) {
                this.runId = data.runId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("stats" in data && data.stats != undefined) {
                this.stats = data.stats;
            }
            if ("RATGstatus" in data && data.RATGstatus != undefined) {
                this.RATGstatus = data.RATGstatus;
            }
            if ("MAUhUsage" in data && data.MAUhUsage != undefined) {
                this.MAUhUsage = data.MAUhUsage;
            }
            if ("selectedMethodSet" in data && data.selectedMethodSet != undefined) {
                this.selectedMethodSet = data.selectedMethodSet;
            }
            if ("baselineRunName" in data && data.baselineRunName != undefined) {
                this.baselineRunName = data.baselineRunName;
            }
            if ("referenceRunName" in data && data.referenceRunName != undefined) {
                this.referenceRunName = data.referenceRunName;
            }
            if ("selectedMasterGeometry" in data && data.selectedMasterGeometry != undefined) {
                this.selectedMasterGeometry = data.selectedMasterGeometry;
            }
            if ("expandForVehicleStates" in data && data.expandForVehicleStates != undefined) {
                this.expandForVehicleStates = data.expandForVehicleStates;
            }
            if ("projectConfig" in data && data.projectConfig != undefined) {
                this.projectConfig = data.projectConfig;
            }
            if ("workflowSubmissionTemplate" in data && data.workflowSubmissionTemplate != undefined) {
                this.workflowSubmissionTemplate = data.workflowSubmissionTemplate;
            }
            if ("submittedByUser" in data && data.submittedByUser != undefined) {
                this.submittedByUser = data.submittedByUser;
            }
            if ("baselineRunId" in data && data.baselineRunId != undefined) {
                this.baselineRunId = data.baselineRunId;
            }
            if ("referenceRunId" in data && data.referenceRunId != undefined) {
                this.referenceRunId = data.referenceRunId;
            }
            if ("selectedTyreSet" in data && data.selectedTyreSet != undefined) {
                this.selectedTyreSet = data.selectedTyreSet;
            }
            if ("selectedAttitudeSet" in data && data.selectedAttitudeSet != undefined) {
                this.selectedAttitudeSet = data.selectedAttitudeSet;
            }
            if ("selectedDomainSet" in data && data.selectedDomainSet != undefined) {
                this.selectedDomainSet = data.selectedDomainSet;
            }
            if ("selectedSimulationSet" in data && data.selectedSimulationSet != undefined) {
                this.selectedSimulationSet = data.selectedSimulationSet;
            }
            if ("selectedTrajectory" in data && data.selectedTrajectory != undefined) {
                this.selectedTrajectory = data.selectedTrajectory;
            }
            if ("selectedCases" in data && data.selectedCases != undefined) {
                this.selectedCases = data.selectedCases;
            }
            if ("geoStagingDir" in data && data.geoStagingDir != undefined) {
                this.geoStagingDir = data.geoStagingDir;
            }
            if ("selectedPtapLocationSet" in data && data.selectedPtapLocationSet != undefined) {
                this.selectedPtapLocationSet = data.selectedPtapLocationSet;
            }
            if ("selectedRHRepoSet" in data && data.selectedRHRepoSet != undefined) {
                this.selectedRHRepoSet = data.selectedRHRepoSet;
            }
            if ("complianceTeam" in data && data.complianceTeam != undefined) {
                this.complianceTeam = data.complianceTeam;
            }
            if ("complianceDesc" in data && data.complianceDesc != undefined) {
                this.complianceDesc = data.complianceDesc;
            }
            if ("geoStagingFiles" in data && data.geoStagingFiles != undefined) {
                this.geoStagingFiles = data.geoStagingFiles;
            }
            if ("overrideSelectedSimFile" in data && data.overrideSelectedSimFile != undefined) {
                this.overrideSelectedSimFile = data.overrideSelectedSimFile;
            }
            if ("simOverrideDir" in data && data.simOverrideDir != undefined) {
                this.simOverrideDir = data.simOverrideDir;
            }
            if ("followingCars" in data && data.followingCars != undefined) {
                this.followingCars = data.followingCars;
            }
            if ("geometryChangeImage" in data && data.geometryChangeImage != undefined) {
                this.geometryChangeImage = data.geometryChangeImage;
            }
            if ("length_m" in data && data.length_m != undefined) {
                this.length_m = data.length_m;
            }
            if ("width_m" in data && data.width_m != undefined) {
                this.width_m = data.width_m;
            }
            if ("coresCount" in data && data.coresCount != undefined) {
                this.coresCount = data.coresCount;
            }
            if ("walltimeOverride" in data && data.walltimeOverride != undefined) {
                this.walltimeOverride = data.walltimeOverride;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get runId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set runId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get stats() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set stats(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get RATGstatus() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set RATGstatus(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get MAUhUsage() {
        return pb_1.Message.getFieldWithDefault(this, 13, "");
    }
    set MAUhUsage(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get selectedMethodSet() {
        return pb_1.Message.getWrapperField(this, MethodologySet, 16);
    }
    set selectedMethodSet(value) {
        pb_1.Message.setWrapperField(this, 16, value);
    }
    get has_selectedMethodSet() {
        return pb_1.Message.getField(this, 16) != null;
    }
    get baselineRunName() {
        return pb_1.Message.getFieldWithDefault(this, 19, "");
    }
    set baselineRunName(value) {
        pb_1.Message.setField(this, 19, value);
    }
    get referenceRunName() {
        return pb_1.Message.getFieldWithDefault(this, 20, "");
    }
    set referenceRunName(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get selectedMasterGeometry() {
        return pb_1.Message.getWrapperField(this, Geometry, 21);
    }
    set selectedMasterGeometry(value) {
        pb_1.Message.setWrapperField(this, 21, value);
    }
    get has_selectedMasterGeometry() {
        return pb_1.Message.getField(this, 21) != null;
    }
    get expandForVehicleStates() {
        return pb_1.Message.getFieldWithDefault(this, 22, false);
    }
    set expandForVehicleStates(value) {
        pb_1.Message.setField(this, 22, value);
    }
    get projectConfig() {
        return pb_1.Message.getWrapperField(this, ProjectConfig, 23);
    }
    set projectConfig(value) {
        pb_1.Message.setWrapperField(this, 23, value);
    }
    get has_projectConfig() {
        return pb_1.Message.getField(this, 23) != null;
    }
    get workflowSubmissionTemplate() {
        return pb_1.Message.getWrapperField(this, WorkflowSubmissionTemplate, 26);
    }
    set workflowSubmissionTemplate(value) {
        pb_1.Message.setWrapperField(this, 26, value);
    }
    get has_workflowSubmissionTemplate() {
        return pb_1.Message.getField(this, 26) != null;
    }
    get submittedByUser() {
        return pb_1.Message.getFieldWithDefault(this, 30, "");
    }
    set submittedByUser(value) {
        pb_1.Message.setField(this, 30, value);
    }
    get baselineRunId() {
        return pb_1.Message.getFieldWithDefault(this, 31, "");
    }
    set baselineRunId(value) {
        pb_1.Message.setField(this, 31, value);
    }
    get referenceRunId() {
        return pb_1.Message.getFieldWithDefault(this, 32, "");
    }
    set referenceRunId(value) {
        pb_1.Message.setField(this, 32, value);
    }
    get selectedTyreSet() {
        return pb_1.Message.getWrapperField(this, TyreSet, 34);
    }
    set selectedTyreSet(value) {
        pb_1.Message.setWrapperField(this, 34, value);
    }
    get has_selectedTyreSet() {
        return pb_1.Message.getField(this, 34) != null;
    }
    get selectedAttitudeSet() {
        return pb_1.Message.getWrapperField(this, AttitudeSet, 35);
    }
    set selectedAttitudeSet(value) {
        pb_1.Message.setWrapperField(this, 35, value);
    }
    get has_selectedAttitudeSet() {
        return pb_1.Message.getField(this, 35) != null;
    }
    get selectedDomainSet() {
        return pb_1.Message.getWrapperField(this, DomainSet, 36);
    }
    set selectedDomainSet(value) {
        pb_1.Message.setWrapperField(this, 36, value);
    }
    get has_selectedDomainSet() {
        return pb_1.Message.getField(this, 36) != null;
    }
    get selectedSimulationSet() {
        return pb_1.Message.getWrapperField(this, SimulationSet, 37);
    }
    set selectedSimulationSet(value) {
        pb_1.Message.setWrapperField(this, 37, value);
    }
    get has_selectedSimulationSet() {
        return pb_1.Message.getField(this, 37) != null;
    }
    get selectedTrajectory() {
        return pb_1.Message.getWrapperField(this, Trajectory, 39);
    }
    set selectedTrajectory(value) {
        pb_1.Message.setWrapperField(this, 39, value);
    }
    get has_selectedTrajectory() {
        return pb_1.Message.getField(this, 39) != null;
    }
    get selectedCases() {
        return pb_1.Message.getRepeatedWrapperField(this, RunConfigCase, 40);
    }
    set selectedCases(value) {
        pb_1.Message.setRepeatedWrapperField(this, 40, value);
    }
    get geoStagingDir() {
        return pb_1.Message.getFieldWithDefault(this, 41, "");
    }
    set geoStagingDir(value) {
        pb_1.Message.setField(this, 41, value);
    }
    get selectedPtapLocationSet() {
        return pb_1.Message.getWrapperField(this, PtapLocationSet, 42);
    }
    set selectedPtapLocationSet(value) {
        pb_1.Message.setWrapperField(this, 42, value);
    }
    get has_selectedPtapLocationSet() {
        return pb_1.Message.getField(this, 42) != null;
    }
    get selectedRHRepoSet() {
        return pb_1.Message.getWrapperField(this, RHRepoSet, 43);
    }
    set selectedRHRepoSet(value) {
        pb_1.Message.setWrapperField(this, 43, value);
    }
    get has_selectedRHRepoSet() {
        return pb_1.Message.getField(this, 43) != null;
    }
    get complianceTeam() {
        return pb_1.Message.getFieldWithDefault(this, 44, "");
    }
    set complianceTeam(value) {
        pb_1.Message.setField(this, 44, value);
    }
    get complianceDesc() {
        return pb_1.Message.getFieldWithDefault(this, 45, "");
    }
    set complianceDesc(value) {
        pb_1.Message.setField(this, 45, value);
    }
    get geoStagingFiles() {
        return pb_1.Message.getFieldWithDefault(this, 46, []);
    }
    set geoStagingFiles(value) {
        pb_1.Message.setField(this, 46, value);
    }
    get overrideSelectedSimFile() {
        return pb_1.Message.getFieldWithDefault(this, 47, "");
    }
    set overrideSelectedSimFile(value) {
        pb_1.Message.setField(this, 47, value);
    }
    get simOverrideDir() {
        return pb_1.Message.getFieldWithDefault(this, 48, "");
    }
    set simOverrideDir(value) {
        pb_1.Message.setField(this, 48, value);
    }
    get followingCars() {
        return pb_1.Message.getRepeatedWrapperField(this, FollowingCar, 49);
    }
    set followingCars(value) {
        pb_1.Message.setRepeatedWrapperField(this, 49, value);
    }
    get geometryChangeImage() {
        return pb_1.Message.getFieldWithDefault(this, 50, []);
    }
    set geometryChangeImage(value) {
        pb_1.Message.setField(this, 50, value);
    }
    get length_m() {
        return pb_1.Message.getFieldWithDefault(this, 51, 0);
    }
    set length_m(value) {
        pb_1.Message.setField(this, 51, value);
    }
    get width_m() {
        return pb_1.Message.getFieldWithDefault(this, 52, 0);
    }
    set width_m(value) {
        pb_1.Message.setField(this, 52, value);
    }
    get coresCount() {
        return pb_1.Message.getFieldWithDefault(this, 53, 0);
    }
    set coresCount(value) {
        pb_1.Message.setField(this, 53, value);
    }
    get walltimeOverride() {
        return pb_1.Message.getFieldWithDefault(this, 54, 0);
    }
    set walltimeOverride(value) {
        pb_1.Message.setField(this, 54, value);
    }
    static fromObject(data) {
        const message = new RunConfig({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.runId != null) {
            message.runId = data.runId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.stats != null) {
            message.stats = data.stats;
        }
        if (data.RATGstatus != null) {
            message.RATGstatus = data.RATGstatus;
        }
        if (data.MAUhUsage != null) {
            message.MAUhUsage = data.MAUhUsage;
        }
        if (data.selectedMethodSet != null) {
            message.selectedMethodSet = MethodologySet.fromObject(data.selectedMethodSet);
        }
        if (data.baselineRunName != null) {
            message.baselineRunName = data.baselineRunName;
        }
        if (data.referenceRunName != null) {
            message.referenceRunName = data.referenceRunName;
        }
        if (data.selectedMasterGeometry != null) {
            message.selectedMasterGeometry = Geometry.fromObject(data.selectedMasterGeometry);
        }
        if (data.expandForVehicleStates != null) {
            message.expandForVehicleStates = data.expandForVehicleStates;
        }
        if (data.projectConfig != null) {
            message.projectConfig = ProjectConfig.fromObject(data.projectConfig);
        }
        if (data.workflowSubmissionTemplate != null) {
            message.workflowSubmissionTemplate = WorkflowSubmissionTemplate.fromObject(data.workflowSubmissionTemplate);
        }
        if (data.submittedByUser != null) {
            message.submittedByUser = data.submittedByUser;
        }
        if (data.baselineRunId != null) {
            message.baselineRunId = data.baselineRunId;
        }
        if (data.referenceRunId != null) {
            message.referenceRunId = data.referenceRunId;
        }
        if (data.selectedTyreSet != null) {
            message.selectedTyreSet = TyreSet.fromObject(data.selectedTyreSet);
        }
        if (data.selectedAttitudeSet != null) {
            message.selectedAttitudeSet = AttitudeSet.fromObject(data.selectedAttitudeSet);
        }
        if (data.selectedDomainSet != null) {
            message.selectedDomainSet = DomainSet.fromObject(data.selectedDomainSet);
        }
        if (data.selectedSimulationSet != null) {
            message.selectedSimulationSet = SimulationSet.fromObject(data.selectedSimulationSet);
        }
        if (data.selectedTrajectory != null) {
            message.selectedTrajectory = Trajectory.fromObject(data.selectedTrajectory);
        }
        if (data.selectedCases != null) {
            message.selectedCases = data.selectedCases.map(item => RunConfigCase.fromObject(item));
        }
        if (data.geoStagingDir != null) {
            message.geoStagingDir = data.geoStagingDir;
        }
        if (data.selectedPtapLocationSet != null) {
            message.selectedPtapLocationSet = PtapLocationSet.fromObject(data.selectedPtapLocationSet);
        }
        if (data.selectedRHRepoSet != null) {
            message.selectedRHRepoSet = RHRepoSet.fromObject(data.selectedRHRepoSet);
        }
        if (data.complianceTeam != null) {
            message.complianceTeam = data.complianceTeam;
        }
        if (data.complianceDesc != null) {
            message.complianceDesc = data.complianceDesc;
        }
        if (data.geoStagingFiles != null) {
            message.geoStagingFiles = data.geoStagingFiles;
        }
        if (data.overrideSelectedSimFile != null) {
            message.overrideSelectedSimFile = data.overrideSelectedSimFile;
        }
        if (data.simOverrideDir != null) {
            message.simOverrideDir = data.simOverrideDir;
        }
        if (data.followingCars != null) {
            message.followingCars = data.followingCars.map(item => FollowingCar.fromObject(item));
        }
        if (data.geometryChangeImage != null) {
            message.geometryChangeImage = data.geometryChangeImage;
        }
        if (data.length_m != null) {
            message.length_m = data.length_m;
        }
        if (data.width_m != null) {
            message.width_m = data.width_m;
        }
        if (data.coresCount != null) {
            message.coresCount = data.coresCount;
        }
        if (data.walltimeOverride != null) {
            message.walltimeOverride = data.walltimeOverride;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.runId != null) {
            data.runId = this.runId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.stats != null) {
            data.stats = this.stats;
        }
        if (this.RATGstatus != null) {
            data.RATGstatus = this.RATGstatus;
        }
        if (this.MAUhUsage != null) {
            data.MAUhUsage = this.MAUhUsage;
        }
        if (this.selectedMethodSet != null) {
            data.selectedMethodSet = this.selectedMethodSet.toObject();
        }
        if (this.baselineRunName != null) {
            data.baselineRunName = this.baselineRunName;
        }
        if (this.referenceRunName != null) {
            data.referenceRunName = this.referenceRunName;
        }
        if (this.selectedMasterGeometry != null) {
            data.selectedMasterGeometry = this.selectedMasterGeometry.toObject();
        }
        if (this.expandForVehicleStates != null) {
            data.expandForVehicleStates = this.expandForVehicleStates;
        }
        if (this.projectConfig != null) {
            data.projectConfig = this.projectConfig.toObject();
        }
        if (this.workflowSubmissionTemplate != null) {
            data.workflowSubmissionTemplate = this.workflowSubmissionTemplate.toObject();
        }
        if (this.submittedByUser != null) {
            data.submittedByUser = this.submittedByUser;
        }
        if (this.baselineRunId != null) {
            data.baselineRunId = this.baselineRunId;
        }
        if (this.referenceRunId != null) {
            data.referenceRunId = this.referenceRunId;
        }
        if (this.selectedTyreSet != null) {
            data.selectedTyreSet = this.selectedTyreSet.toObject();
        }
        if (this.selectedAttitudeSet != null) {
            data.selectedAttitudeSet = this.selectedAttitudeSet.toObject();
        }
        if (this.selectedDomainSet != null) {
            data.selectedDomainSet = this.selectedDomainSet.toObject();
        }
        if (this.selectedSimulationSet != null) {
            data.selectedSimulationSet = this.selectedSimulationSet.toObject();
        }
        if (this.selectedTrajectory != null) {
            data.selectedTrajectory = this.selectedTrajectory.toObject();
        }
        if (this.selectedCases != null) {
            data.selectedCases = this.selectedCases.map((item) => item.toObject());
        }
        if (this.geoStagingDir != null) {
            data.geoStagingDir = this.geoStagingDir;
        }
        if (this.selectedPtapLocationSet != null) {
            data.selectedPtapLocationSet = this.selectedPtapLocationSet.toObject();
        }
        if (this.selectedRHRepoSet != null) {
            data.selectedRHRepoSet = this.selectedRHRepoSet.toObject();
        }
        if (this.complianceTeam != null) {
            data.complianceTeam = this.complianceTeam;
        }
        if (this.complianceDesc != null) {
            data.complianceDesc = this.complianceDesc;
        }
        if (this.geoStagingFiles != null) {
            data.geoStagingFiles = this.geoStagingFiles;
        }
        if (this.overrideSelectedSimFile != null) {
            data.overrideSelectedSimFile = this.overrideSelectedSimFile;
        }
        if (this.simOverrideDir != null) {
            data.simOverrideDir = this.simOverrideDir;
        }
        if (this.followingCars != null) {
            data.followingCars = this.followingCars.map((item) => item.toObject());
        }
        if (this.geometryChangeImage != null) {
            data.geometryChangeImage = this.geometryChangeImage;
        }
        if (this.length_m != null) {
            data.length_m = this.length_m;
        }
        if (this.width_m != null) {
            data.width_m = this.width_m;
        }
        if (this.coresCount != null) {
            data.coresCount = this.coresCount;
        }
        if (this.walltimeOverride != null) {
            data.walltimeOverride = this.walltimeOverride;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.runId.length)
            writer.writeString(2, this.runId);
        if (this._id.length)
            writer.writeString(3, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.name.length)
            writer.writeString(8, this.name);
        if (this.description.length)
            writer.writeString(9, this.description);
        if (this.stats.length)
            writer.writeString(10, this.stats);
        if (this.RATGstatus.length)
            writer.writeString(11, this.RATGstatus);
        if (this.MAUhUsage.length)
            writer.writeString(13, this.MAUhUsage);
        if (this.has_selectedMethodSet)
            writer.writeMessage(16, this.selectedMethodSet, () => this.selectedMethodSet.serialize(writer));
        if (this.baselineRunName.length)
            writer.writeString(19, this.baselineRunName);
        if (this.referenceRunName.length)
            writer.writeString(20, this.referenceRunName);
        if (this.has_selectedMasterGeometry)
            writer.writeMessage(21, this.selectedMasterGeometry, () => this.selectedMasterGeometry.serialize(writer));
        if (this.expandForVehicleStates != false)
            writer.writeBool(22, this.expandForVehicleStates);
        if (this.has_projectConfig)
            writer.writeMessage(23, this.projectConfig, () => this.projectConfig.serialize(writer));
        if (this.has_workflowSubmissionTemplate)
            writer.writeMessage(26, this.workflowSubmissionTemplate, () => this.workflowSubmissionTemplate.serialize(writer));
        if (this.submittedByUser.length)
            writer.writeString(30, this.submittedByUser);
        if (this.baselineRunId.length)
            writer.writeString(31, this.baselineRunId);
        if (this.referenceRunId.length)
            writer.writeString(32, this.referenceRunId);
        if (this.has_selectedTyreSet)
            writer.writeMessage(34, this.selectedTyreSet, () => this.selectedTyreSet.serialize(writer));
        if (this.has_selectedAttitudeSet)
            writer.writeMessage(35, this.selectedAttitudeSet, () => this.selectedAttitudeSet.serialize(writer));
        if (this.has_selectedDomainSet)
            writer.writeMessage(36, this.selectedDomainSet, () => this.selectedDomainSet.serialize(writer));
        if (this.has_selectedSimulationSet)
            writer.writeMessage(37, this.selectedSimulationSet, () => this.selectedSimulationSet.serialize(writer));
        if (this.has_selectedTrajectory)
            writer.writeMessage(39, this.selectedTrajectory, () => this.selectedTrajectory.serialize(writer));
        if (this.selectedCases.length)
            writer.writeRepeatedMessage(40, this.selectedCases, (item) => item.serialize(writer));
        if (this.geoStagingDir.length)
            writer.writeString(41, this.geoStagingDir);
        if (this.has_selectedPtapLocationSet)
            writer.writeMessage(42, this.selectedPtapLocationSet, () => this.selectedPtapLocationSet.serialize(writer));
        if (this.has_selectedRHRepoSet)
            writer.writeMessage(43, this.selectedRHRepoSet, () => this.selectedRHRepoSet.serialize(writer));
        if (this.complianceTeam.length)
            writer.writeString(44, this.complianceTeam);
        if (this.complianceDesc.length)
            writer.writeString(45, this.complianceDesc);
        if (this.geoStagingFiles.length)
            writer.writeRepeatedString(46, this.geoStagingFiles);
        if (this.overrideSelectedSimFile.length)
            writer.writeString(47, this.overrideSelectedSimFile);
        if (this.simOverrideDir.length)
            writer.writeString(48, this.simOverrideDir);
        if (this.followingCars.length)
            writer.writeRepeatedMessage(49, this.followingCars, (item) => item.serialize(writer));
        if (this.geometryChangeImage.length)
            writer.writeRepeatedString(50, this.geometryChangeImage);
        if (this.length_m != 0)
            writer.writeFloat(51, this.length_m);
        if (this.width_m != 0)
            writer.writeFloat(52, this.width_m);
        if (this.coresCount != 0)
            writer.writeUint32(53, this.coresCount);
        if (this.walltimeOverride != 0)
            writer.writeUint32(54, this.walltimeOverride);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RunConfig();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.runId = reader.readString();
                    break;
                case 3:
                    message._id = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.name = reader.readString();
                    break;
                case 9:
                    message.description = reader.readString();
                    break;
                case 10:
                    message.stats = reader.readString();
                    break;
                case 11:
                    message.RATGstatus = reader.readString();
                    break;
                case 13:
                    message.MAUhUsage = reader.readString();
                    break;
                case 16:
                    reader.readMessage(message.selectedMethodSet, () => message.selectedMethodSet = MethodologySet.deserialize(reader));
                    break;
                case 19:
                    message.baselineRunName = reader.readString();
                    break;
                case 20:
                    message.referenceRunName = reader.readString();
                    break;
                case 21:
                    reader.readMessage(message.selectedMasterGeometry, () => message.selectedMasterGeometry = Geometry.deserialize(reader));
                    break;
                case 22:
                    message.expandForVehicleStates = reader.readBool();
                    break;
                case 23:
                    reader.readMessage(message.projectConfig, () => message.projectConfig = ProjectConfig.deserialize(reader));
                    break;
                case 26:
                    reader.readMessage(message.workflowSubmissionTemplate, () => message.workflowSubmissionTemplate = WorkflowSubmissionTemplate.deserialize(reader));
                    break;
                case 30:
                    message.submittedByUser = reader.readString();
                    break;
                case 31:
                    message.baselineRunId = reader.readString();
                    break;
                case 32:
                    message.referenceRunId = reader.readString();
                    break;
                case 34:
                    reader.readMessage(message.selectedTyreSet, () => message.selectedTyreSet = TyreSet.deserialize(reader));
                    break;
                case 35:
                    reader.readMessage(message.selectedAttitudeSet, () => message.selectedAttitudeSet = AttitudeSet.deserialize(reader));
                    break;
                case 36:
                    reader.readMessage(message.selectedDomainSet, () => message.selectedDomainSet = DomainSet.deserialize(reader));
                    break;
                case 37:
                    reader.readMessage(message.selectedSimulationSet, () => message.selectedSimulationSet = SimulationSet.deserialize(reader));
                    break;
                case 39:
                    reader.readMessage(message.selectedTrajectory, () => message.selectedTrajectory = Trajectory.deserialize(reader));
                    break;
                case 40:
                    reader.readMessage(message.selectedCases, () => pb_1.Message.addToRepeatedWrapperField(message, 40, RunConfigCase.deserialize(reader), RunConfigCase));
                    break;
                case 41:
                    message.geoStagingDir = reader.readString();
                    break;
                case 42:
                    reader.readMessage(message.selectedPtapLocationSet, () => message.selectedPtapLocationSet = PtapLocationSet.deserialize(reader));
                    break;
                case 43:
                    reader.readMessage(message.selectedRHRepoSet, () => message.selectedRHRepoSet = RHRepoSet.deserialize(reader));
                    break;
                case 44:
                    message.complianceTeam = reader.readString();
                    break;
                case 45:
                    message.complianceDesc = reader.readString();
                    break;
                case 46:
                    pb_1.Message.addToRepeatedField(message, 46, reader.readString());
                    break;
                case 47:
                    message.overrideSelectedSimFile = reader.readString();
                    break;
                case 48:
                    message.simOverrideDir = reader.readString();
                    break;
                case 49:
                    reader.readMessage(message.followingCars, () => pb_1.Message.addToRepeatedWrapperField(message, 49, FollowingCar.deserialize(reader), FollowingCar));
                    break;
                case 50:
                    pb_1.Message.addToRepeatedField(message, 50, reader.readString());
                    break;
                case 51:
                    message.length_m = reader.readFloat();
                    break;
                case 52:
                    message.width_m = reader.readFloat();
                    break;
                case 53:
                    message.coresCount = reader.readUint32();
                    break;
                case 54:
                    message.walltimeOverride = reader.readUint32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RunConfig.deserialize(bytes);
    }
}
exports.RunConfig = RunConfig;
_RunConfig_one_of_decls = new WeakMap();
class FollowingCar extends pb_1.Message {
    constructor(data) {
        super();
        _FollowingCar_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _FollowingCar_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("localPosition" in data && data.localPosition != undefined) {
                this.localPosition = data.localPosition;
            }
            if ("localRotation" in data && data.localRotation != undefined) {
                this.localRotation = data.localRotation;
            }
            if ("localOrientation" in data && data.localOrientation != undefined) {
                this.localOrientation = data.localOrientation;
            }
            if ("systemRunId" in data && data.systemRunId != undefined) {
                this.systemRunId = data.systemRunId;
            }
        }
    }
    get localPosition() {
        return pb_1.Message.getWrapperField(this, Coordinate, 1);
    }
    set localPosition(value) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_localPosition() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get localRotation() {
        return pb_1.Message.getWrapperField(this, Coordinate, 2);
    }
    set localRotation(value) {
        pb_1.Message.setWrapperField(this, 2, value);
    }
    get has_localRotation() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get localOrientation() {
        return pb_1.Message.getWrapperField(this, Coordinate, 3);
    }
    set localOrientation(value) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_localOrientation() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get systemRunId() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set systemRunId(value) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data) {
        const message = new FollowingCar({});
        if (data.localPosition != null) {
            message.localPosition = Coordinate.fromObject(data.localPosition);
        }
        if (data.localRotation != null) {
            message.localRotation = Coordinate.fromObject(data.localRotation);
        }
        if (data.localOrientation != null) {
            message.localOrientation = Coordinate.fromObject(data.localOrientation);
        }
        if (data.systemRunId != null) {
            message.systemRunId = data.systemRunId;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.localPosition != null) {
            data.localPosition = this.localPosition.toObject();
        }
        if (this.localRotation != null) {
            data.localRotation = this.localRotation.toObject();
        }
        if (this.localOrientation != null) {
            data.localOrientation = this.localOrientation.toObject();
        }
        if (this.systemRunId != null) {
            data.systemRunId = this.systemRunId;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_localPosition)
            writer.writeMessage(1, this.localPosition, () => this.localPosition.serialize(writer));
        if (this.has_localRotation)
            writer.writeMessage(2, this.localRotation, () => this.localRotation.serialize(writer));
        if (this.has_localOrientation)
            writer.writeMessage(3, this.localOrientation, () => this.localOrientation.serialize(writer));
        if (this.systemRunId.length)
            writer.writeString(4, this.systemRunId);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new FollowingCar();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.localPosition, () => message.localPosition = Coordinate.deserialize(reader));
                    break;
                case 2:
                    reader.readMessage(message.localRotation, () => message.localRotation = Coordinate.deserialize(reader));
                    break;
                case 3:
                    reader.readMessage(message.localOrientation, () => message.localOrientation = Coordinate.deserialize(reader));
                    break;
                case 4:
                    message.systemRunId = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return FollowingCar.deserialize(bytes);
    }
}
exports.FollowingCar = FollowingCar;
_FollowingCar_one_of_decls = new WeakMap();
class Coordinate extends pb_1.Message {
    constructor(data) {
        super();
        _Coordinate_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Coordinate_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("x" in data && data.x != undefined) {
                this.x = data.x;
            }
            if ("y" in data && data.y != undefined) {
                this.y = data.y;
            }
            if ("z" in data && data.z != undefined) {
                this.z = data.z;
            }
            if ("distance_x_m" in data && data.distance_x_m != undefined) {
                this.distance_x_m = data.distance_x_m;
            }
            if ("distance_y_m" in data && data.distance_y_m != undefined) {
                this.distance_y_m = data.distance_y_m;
            }
            if ("distance_z_m" in data && data.distance_z_m != undefined) {
                this.distance_z_m = data.distance_z_m;
            }
        }
    }
    get x() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set x(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get y() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set y(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get z() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set z(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get distance_x_m() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set distance_x_m(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get distance_y_m() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set distance_y_m(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get distance_z_m() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set distance_z_m(value) {
        pb_1.Message.setField(this, 6, value);
    }
    static fromObject(data) {
        const message = new Coordinate({});
        if (data.x != null) {
            message.x = data.x;
        }
        if (data.y != null) {
            message.y = data.y;
        }
        if (data.z != null) {
            message.z = data.z;
        }
        if (data.distance_x_m != null) {
            message.distance_x_m = data.distance_x_m;
        }
        if (data.distance_y_m != null) {
            message.distance_y_m = data.distance_y_m;
        }
        if (data.distance_z_m != null) {
            message.distance_z_m = data.distance_z_m;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.x != null) {
            data.x = this.x;
        }
        if (this.y != null) {
            data.y = this.y;
        }
        if (this.z != null) {
            data.z = this.z;
        }
        if (this.distance_x_m != null) {
            data.distance_x_m = this.distance_x_m;
        }
        if (this.distance_y_m != null) {
            data.distance_y_m = this.distance_y_m;
        }
        if (this.distance_z_m != null) {
            data.distance_z_m = this.distance_z_m;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.x != 0)
            writer.writeFloat(1, this.x);
        if (this.y != 0)
            writer.writeFloat(2, this.y);
        if (this.z != 0)
            writer.writeFloat(3, this.z);
        if (this.distance_x_m != 0)
            writer.writeFloat(4, this.distance_x_m);
        if (this.distance_y_m != 0)
            writer.writeFloat(5, this.distance_y_m);
        if (this.distance_z_m != 0)
            writer.writeFloat(6, this.distance_z_m);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Coordinate();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.x = reader.readFloat();
                    break;
                case 2:
                    message.y = reader.readFloat();
                    break;
                case 3:
                    message.z = reader.readFloat();
                    break;
                case 4:
                    message.distance_x_m = reader.readFloat();
                    break;
                case 5:
                    message.distance_y_m = reader.readFloat();
                    break;
                case 6:
                    message.distance_z_m = reader.readFloat();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Coordinate.deserialize(bytes);
    }
}
exports.Coordinate = Coordinate;
_Coordinate_one_of_decls = new WeakMap();
class RunConfigCase extends pb_1.Message {
    constructor(data) {
        super();
        _RunConfigCase_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [10, 46], __classPrivateFieldGet(this, _RunConfigCase_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("key" in data && data.key != undefined) {
                this.key = data.key;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("selectedAttitudeState" in data && data.selectedAttitudeState != undefined) {
                this.selectedAttitudeState = data.selectedAttitudeState;
            }
            if ("selectedTyreState" in data && data.selectedTyreState != undefined) {
                this.selectedTyreState = data.selectedTyreState;
            }
            if ("selectedDomainState" in data && data.selectedDomainState != undefined) {
                this.selectedDomainState = data.selectedDomainState;
            }
            if ("selectedSimulationState" in data && data.selectedSimulationState != undefined) {
                this.selectedSimulationState = data.selectedSimulationState;
            }
            if ("selectedWingState" in data && data.selectedWingState != undefined) {
                this.selectedWingState = data.selectedWingState;
            }
            if ("selectedPtapLocation" in data && data.selectedPtapLocation != undefined) {
                this.selectedPtapLocation = data.selectedPtapLocation;
            }
            if ("selectedRHRepo" in data && data.selectedRHRepo != undefined) {
                this.selectedRHRepo = data.selectedRHRepo;
            }
            if ("selectedSystems" in data && data.selectedSystems != undefined) {
                this.selectedSystems = data.selectedSystems;
            }
            if ("useDeformableTires" in data && data.useDeformableTires != undefined) {
                this.useDeformableTires = data.useDeformableTires;
            }
            if ("selectedFollowingCar" in data && data.selectedFollowingCar != undefined) {
                this.selectedFollowingCar = data.selectedFollowingCar;
            }
            if ("simTemplate" in data && data.simTemplate != undefined) {
                this.simTemplate = data.simTemplate;
            }
            if ("followingCarCase" in data && data.followingCarCase != undefined) {
                this.followingCarCase = data.followingCarCase;
            }
            if ("templateOverride" in data && data.templateOverride != undefined) {
                this.templateOverride = data.templateOverride;
            }
            if ("referenceRuns" in data && data.referenceRuns != undefined) {
                this.referenceRuns = data.referenceRuns;
            }
        }
    }
    get key() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set key(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get selectedAttitudeState() {
        return pb_1.Message.getWrapperField(this, AttitudeState, 3);
    }
    set selectedAttitudeState(value) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_selectedAttitudeState() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get selectedTyreState() {
        return pb_1.Message.getWrapperField(this, TyreState, 4);
    }
    set selectedTyreState(value) {
        pb_1.Message.setWrapperField(this, 4, value);
    }
    get has_selectedTyreState() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get selectedDomainState() {
        return pb_1.Message.getWrapperField(this, DomainState, 5);
    }
    set selectedDomainState(value) {
        pb_1.Message.setWrapperField(this, 5, value);
    }
    get has_selectedDomainState() {
        return pb_1.Message.getField(this, 5) != null;
    }
    get selectedSimulationState() {
        return pb_1.Message.getWrapperField(this, SimulationState, 6);
    }
    set selectedSimulationState(value) {
        pb_1.Message.setWrapperField(this, 6, value);
    }
    get has_selectedSimulationState() {
        return pb_1.Message.getField(this, 6) != null;
    }
    get selectedWingState() {
        return pb_1.Message.getWrapperField(this, WingState, 7);
    }
    set selectedWingState(value) {
        pb_1.Message.setWrapperField(this, 7, value);
    }
    get has_selectedWingState() {
        return pb_1.Message.getField(this, 7) != null;
    }
    get selectedPtapLocation() {
        return pb_1.Message.getWrapperField(this, PtapLocation, 8);
    }
    set selectedPtapLocation(value) {
        pb_1.Message.setWrapperField(this, 8, value);
    }
    get has_selectedPtapLocation() {
        return pb_1.Message.getField(this, 8) != null;
    }
    get selectedRHRepo() {
        return pb_1.Message.getWrapperField(this, RHRepo, 9);
    }
    set selectedRHRepo(value) {
        pb_1.Message.setWrapperField(this, 9, value);
    }
    get has_selectedRHRepo() {
        return pb_1.Message.getField(this, 9) != null;
    }
    get selectedSystems() {
        return pb_1.Message.getRepeatedWrapperField(this, SelectedSystem, 10);
    }
    set selectedSystems(value) {
        pb_1.Message.setRepeatedWrapperField(this, 10, value);
    }
    get useDeformableTires() {
        return pb_1.Message.getFieldWithDefault(this, 41, false);
    }
    set useDeformableTires(value) {
        pb_1.Message.setField(this, 41, value);
    }
    get selectedFollowingCar() {
        return pb_1.Message.getWrapperField(this, FollowingCar, 42);
    }
    set selectedFollowingCar(value) {
        pb_1.Message.setWrapperField(this, 42, value);
    }
    get has_selectedFollowingCar() {
        return pb_1.Message.getField(this, 42) != null;
    }
    get simTemplate() {
        return pb_1.Message.getWrapperField(this, CFDFile, 43);
    }
    set simTemplate(value) {
        pb_1.Message.setWrapperField(this, 43, value);
    }
    get has_simTemplate() {
        return pb_1.Message.getField(this, 43) != null;
    }
    get followingCarCase() {
        return pb_1.Message.getFieldWithDefault(this, 44, false);
    }
    set followingCarCase(value) {
        pb_1.Message.setField(this, 44, value);
    }
    get templateOverride() {
        return pb_1.Message.getWrapperField(this, WorkflowSubmissionTemplate, 45);
    }
    set templateOverride(value) {
        pb_1.Message.setWrapperField(this, 45, value);
    }
    get has_templateOverride() {
        return pb_1.Message.getField(this, 45) != null;
    }
    get referenceRuns() {
        return pb_1.Message.getFieldWithDefault(this, 46, []);
    }
    set referenceRuns(value) {
        pb_1.Message.setField(this, 46, value);
    }
    static fromObject(data) {
        const message = new RunConfigCase({});
        if (data.key != null) {
            message.key = data.key;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.selectedAttitudeState != null) {
            message.selectedAttitudeState = AttitudeState.fromObject(data.selectedAttitudeState);
        }
        if (data.selectedTyreState != null) {
            message.selectedTyreState = TyreState.fromObject(data.selectedTyreState);
        }
        if (data.selectedDomainState != null) {
            message.selectedDomainState = DomainState.fromObject(data.selectedDomainState);
        }
        if (data.selectedSimulationState != null) {
            message.selectedSimulationState = SimulationState.fromObject(data.selectedSimulationState);
        }
        if (data.selectedWingState != null) {
            message.selectedWingState = WingState.fromObject(data.selectedWingState);
        }
        if (data.selectedPtapLocation != null) {
            message.selectedPtapLocation = PtapLocation.fromObject(data.selectedPtapLocation);
        }
        if (data.selectedRHRepo != null) {
            message.selectedRHRepo = RHRepo.fromObject(data.selectedRHRepo);
        }
        if (data.selectedSystems != null) {
            message.selectedSystems = data.selectedSystems.map(item => SelectedSystem.fromObject(item));
        }
        if (data.useDeformableTires != null) {
            message.useDeformableTires = data.useDeformableTires;
        }
        if (data.selectedFollowingCar != null) {
            message.selectedFollowingCar = FollowingCar.fromObject(data.selectedFollowingCar);
        }
        if (data.simTemplate != null) {
            message.simTemplate = CFDFile.fromObject(data.simTemplate);
        }
        if (data.followingCarCase != null) {
            message.followingCarCase = data.followingCarCase;
        }
        if (data.templateOverride != null) {
            message.templateOverride = WorkflowSubmissionTemplate.fromObject(data.templateOverride);
        }
        if (data.referenceRuns != null) {
            message.referenceRuns = data.referenceRuns;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.key != null) {
            data.key = this.key;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.selectedAttitudeState != null) {
            data.selectedAttitudeState = this.selectedAttitudeState.toObject();
        }
        if (this.selectedTyreState != null) {
            data.selectedTyreState = this.selectedTyreState.toObject();
        }
        if (this.selectedDomainState != null) {
            data.selectedDomainState = this.selectedDomainState.toObject();
        }
        if (this.selectedSimulationState != null) {
            data.selectedSimulationState = this.selectedSimulationState.toObject();
        }
        if (this.selectedWingState != null) {
            data.selectedWingState = this.selectedWingState.toObject();
        }
        if (this.selectedPtapLocation != null) {
            data.selectedPtapLocation = this.selectedPtapLocation.toObject();
        }
        if (this.selectedRHRepo != null) {
            data.selectedRHRepo = this.selectedRHRepo.toObject();
        }
        if (this.selectedSystems != null) {
            data.selectedSystems = this.selectedSystems.map((item) => item.toObject());
        }
        if (this.useDeformableTires != null) {
            data.useDeformableTires = this.useDeformableTires;
        }
        if (this.selectedFollowingCar != null) {
            data.selectedFollowingCar = this.selectedFollowingCar.toObject();
        }
        if (this.simTemplate != null) {
            data.simTemplate = this.simTemplate.toObject();
        }
        if (this.followingCarCase != null) {
            data.followingCarCase = this.followingCarCase;
        }
        if (this.templateOverride != null) {
            data.templateOverride = this.templateOverride.toObject();
        }
        if (this.referenceRuns != null) {
            data.referenceRuns = this.referenceRuns;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.key.length)
            writer.writeString(1, this.key);
        if (this.name.length)
            writer.writeString(2, this.name);
        if (this.has_selectedAttitudeState)
            writer.writeMessage(3, this.selectedAttitudeState, () => this.selectedAttitudeState.serialize(writer));
        if (this.has_selectedTyreState)
            writer.writeMessage(4, this.selectedTyreState, () => this.selectedTyreState.serialize(writer));
        if (this.has_selectedDomainState)
            writer.writeMessage(5, this.selectedDomainState, () => this.selectedDomainState.serialize(writer));
        if (this.has_selectedSimulationState)
            writer.writeMessage(6, this.selectedSimulationState, () => this.selectedSimulationState.serialize(writer));
        if (this.has_selectedWingState)
            writer.writeMessage(7, this.selectedWingState, () => this.selectedWingState.serialize(writer));
        if (this.has_selectedPtapLocation)
            writer.writeMessage(8, this.selectedPtapLocation, () => this.selectedPtapLocation.serialize(writer));
        if (this.has_selectedRHRepo)
            writer.writeMessage(9, this.selectedRHRepo, () => this.selectedRHRepo.serialize(writer));
        if (this.selectedSystems.length)
            writer.writeRepeatedMessage(10, this.selectedSystems, (item) => item.serialize(writer));
        if (this.useDeformableTires != false)
            writer.writeBool(41, this.useDeformableTires);
        if (this.has_selectedFollowingCar)
            writer.writeMessage(42, this.selectedFollowingCar, () => this.selectedFollowingCar.serialize(writer));
        if (this.has_simTemplate)
            writer.writeMessage(43, this.simTemplate, () => this.simTemplate.serialize(writer));
        if (this.followingCarCase != false)
            writer.writeBool(44, this.followingCarCase);
        if (this.has_templateOverride)
            writer.writeMessage(45, this.templateOverride, () => this.templateOverride.serialize(writer));
        if (this.referenceRuns.length)
            writer.writeRepeatedString(46, this.referenceRuns);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RunConfigCase();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.key = reader.readString();
                    break;
                case 2:
                    message.name = reader.readString();
                    break;
                case 3:
                    reader.readMessage(message.selectedAttitudeState, () => message.selectedAttitudeState = AttitudeState.deserialize(reader));
                    break;
                case 4:
                    reader.readMessage(message.selectedTyreState, () => message.selectedTyreState = TyreState.deserialize(reader));
                    break;
                case 5:
                    reader.readMessage(message.selectedDomainState, () => message.selectedDomainState = DomainState.deserialize(reader));
                    break;
                case 6:
                    reader.readMessage(message.selectedSimulationState, () => message.selectedSimulationState = SimulationState.deserialize(reader));
                    break;
                case 7:
                    reader.readMessage(message.selectedWingState, () => message.selectedWingState = WingState.deserialize(reader));
                    break;
                case 8:
                    reader.readMessage(message.selectedPtapLocation, () => message.selectedPtapLocation = PtapLocation.deserialize(reader));
                    break;
                case 9:
                    reader.readMessage(message.selectedRHRepo, () => message.selectedRHRepo = RHRepo.deserialize(reader));
                    break;
                case 10:
                    reader.readMessage(message.selectedSystems, () => pb_1.Message.addToRepeatedWrapperField(message, 10, SelectedSystem.deserialize(reader), SelectedSystem));
                    break;
                case 41:
                    message.useDeformableTires = reader.readBool();
                    break;
                case 42:
                    reader.readMessage(message.selectedFollowingCar, () => message.selectedFollowingCar = FollowingCar.deserialize(reader));
                    break;
                case 43:
                    reader.readMessage(message.simTemplate, () => message.simTemplate = CFDFile.deserialize(reader));
                    break;
                case 44:
                    message.followingCarCase = reader.readBool();
                    break;
                case 45:
                    reader.readMessage(message.templateOverride, () => message.templateOverride = WorkflowSubmissionTemplate.deserialize(reader));
                    break;
                case 46:
                    pb_1.Message.addToRepeatedField(message, 46, reader.readString());
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RunConfigCase.deserialize(bytes);
    }
}
exports.RunConfigCase = RunConfigCase;
_RunConfigCase_one_of_decls = new WeakMap();
class SelectedSystem extends pb_1.Message {
    constructor(data) {
        super();
        _SelectedSystem_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _SelectedSystem_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("vendorVersion" in data && data.vendorVersion != undefined) {
                this.vendorVersion = data.vendorVersion;
            }
            if ("branchName" in data && data.branchName != undefined) {
                this.branchName = data.branchName;
            }
            if ("entryScriptId" in data && data.entryScriptId != undefined) {
                this.entryScriptId = data.entryScriptId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("notes" in data && data.notes != undefined) {
                this.notes = data.notes;
            }
            if ("commitId" in data && data.commitId != undefined) {
                this.commitId = data.commitId;
            }
            if ("deploySet" in data && data.deploySet != undefined) {
                this.deploySet = data.deploySet;
            }
            if ("isHardwareOverride" in data && data.isHardwareOverride != undefined) {
                this.isHardwareOverride = data.isHardwareOverride;
            }
            if ("hardwareOverrides" in data && data.hardwareOverrides != undefined) {
                this.hardwareOverrides = data.hardwareOverrides;
            }
            if ("nodes" in data && data.nodes != undefined) {
                this.nodes = data.nodes;
            }
            if ("coresPerNode" in data && data.coresPerNode != undefined) {
                this.coresPerNode = data.coresPerNode;
            }
            if ("maxCoresCount" in data && data.maxCoresCount != undefined) {
                this.maxCoresCount = data.maxCoresCount;
            }
        }
    }
    get vendorVersion() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set vendorVersion(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get branchName() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set branchName(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get entryScriptId() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set entryScriptId(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get notes() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set notes(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get commitId() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set commitId(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get deploySet() {
        return pb_1.Message.getWrapperField(this, DeploySet, 7);
    }
    set deploySet(value) {
        pb_1.Message.setWrapperField(this, 7, value);
    }
    get has_deploySet() {
        return pb_1.Message.getField(this, 7) != null;
    }
    get isHardwareOverride() {
        return pb_1.Message.getFieldWithDefault(this, 8, false);
    }
    set isHardwareOverride(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get hardwareOverrides() {
        return pb_1.Message.getWrapperField(this, dependency_1.Hardware, 9);
    }
    set hardwareOverrides(value) {
        pb_1.Message.setWrapperField(this, 9, value);
    }
    get has_hardwareOverrides() {
        return pb_1.Message.getField(this, 9) != null;
    }
    get nodes() {
        return pb_1.Message.getFieldWithDefault(this, 10, 0);
    }
    set nodes(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get coresPerNode() {
        return pb_1.Message.getFieldWithDefault(this, 11, 0);
    }
    set coresPerNode(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get maxCoresCount() {
        return pb_1.Message.getFieldWithDefault(this, 12, 0);
    }
    set maxCoresCount(value) {
        pb_1.Message.setField(this, 12, value);
    }
    static fromObject(data) {
        const message = new SelectedSystem({});
        if (data.vendorVersion != null) {
            message.vendorVersion = data.vendorVersion;
        }
        if (data.branchName != null) {
            message.branchName = data.branchName;
        }
        if (data.entryScriptId != null) {
            message.entryScriptId = data.entryScriptId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.notes != null) {
            message.notes = data.notes;
        }
        if (data.commitId != null) {
            message.commitId = data.commitId;
        }
        if (data.deploySet != null) {
            message.deploySet = DeploySet.fromObject(data.deploySet);
        }
        if (data.isHardwareOverride != null) {
            message.isHardwareOverride = data.isHardwareOverride;
        }
        if (data.hardwareOverrides != null) {
            message.hardwareOverrides = dependency_1.Hardware.fromObject(data.hardwareOverrides);
        }
        if (data.nodes != null) {
            message.nodes = data.nodes;
        }
        if (data.coresPerNode != null) {
            message.coresPerNode = data.coresPerNode;
        }
        if (data.maxCoresCount != null) {
            message.maxCoresCount = data.maxCoresCount;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.vendorVersion != null) {
            data.vendorVersion = this.vendorVersion;
        }
        if (this.branchName != null) {
            data.branchName = this.branchName;
        }
        if (this.entryScriptId != null) {
            data.entryScriptId = this.entryScriptId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.notes != null) {
            data.notes = this.notes;
        }
        if (this.commitId != null) {
            data.commitId = this.commitId;
        }
        if (this.deploySet != null) {
            data.deploySet = this.deploySet.toObject();
        }
        if (this.isHardwareOverride != null) {
            data.isHardwareOverride = this.isHardwareOverride;
        }
        if (this.hardwareOverrides != null) {
            data.hardwareOverrides = this.hardwareOverrides.toObject();
        }
        if (this.nodes != null) {
            data.nodes = this.nodes;
        }
        if (this.coresPerNode != null) {
            data.coresPerNode = this.coresPerNode;
        }
        if (this.maxCoresCount != null) {
            data.maxCoresCount = this.maxCoresCount;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.vendorVersion.length)
            writer.writeString(1, this.vendorVersion);
        if (this.branchName.length)
            writer.writeString(2, this.branchName);
        if (this.entryScriptId.length)
            writer.writeString(3, this.entryScriptId);
        if (this.name.length)
            writer.writeString(4, this.name);
        if (this.notes.length)
            writer.writeString(5, this.notes);
        if (this.commitId.length)
            writer.writeString(6, this.commitId);
        if (this.has_deploySet)
            writer.writeMessage(7, this.deploySet, () => this.deploySet.serialize(writer));
        if (this.isHardwareOverride != false)
            writer.writeBool(8, this.isHardwareOverride);
        if (this.has_hardwareOverrides)
            writer.writeMessage(9, this.hardwareOverrides, () => this.hardwareOverrides.serialize(writer));
        if (this.nodes != 0)
            writer.writeUint32(10, this.nodes);
        if (this.coresPerNode != 0)
            writer.writeUint32(11, this.coresPerNode);
        if (this.maxCoresCount != 0)
            writer.writeUint32(12, this.maxCoresCount);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SelectedSystem();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.vendorVersion = reader.readString();
                    break;
                case 2:
                    message.branchName = reader.readString();
                    break;
                case 3:
                    message.entryScriptId = reader.readString();
                    break;
                case 4:
                    message.name = reader.readString();
                    break;
                case 5:
                    message.notes = reader.readString();
                    break;
                case 6:
                    message.commitId = reader.readString();
                    break;
                case 7:
                    reader.readMessage(message.deploySet, () => message.deploySet = DeploySet.deserialize(reader));
                    break;
                case 8:
                    message.isHardwareOverride = reader.readBool();
                    break;
                case 9:
                    reader.readMessage(message.hardwareOverrides, () => message.hardwareOverrides = dependency_1.Hardware.deserialize(reader));
                    break;
                case 10:
                    message.nodes = reader.readUint32();
                    break;
                case 11:
                    message.coresPerNode = reader.readUint32();
                    break;
                case 12:
                    message.maxCoresCount = reader.readUint32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SelectedSystem.deserialize(bytes);
    }
}
exports.SelectedSystem = SelectedSystem;
_SelectedSystem_one_of_decls = new WeakMap();
class AttitudeState extends pb_1.Message {
    constructor(data) {
        super();
        _AttitudeState_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _AttitudeState_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("exhaust" in data && data.exhaust != undefined) {
                this.exhaust = data.exhaust;
            }
            if ("roll" in data && data.roll != undefined) {
                this.roll = data.roll;
            }
            if ("yaw" in data && data.yaw != undefined) {
                this.yaw = data.yaw;
            }
            if ("frh" in data && data.frh != undefined) {
                this.frh = data.frh;
            }
            if ("rrh" in data && data.rrh != undefined) {
                this.rrh = data.rrh;
            }
            if ("steer" in data && data.steer != undefined) {
                this.steer = data.steer;
            }
            if ("radius" in data && data.radius != undefined) {
                this.radius = data.radius;
            }
            if ("speed" in data && data.speed != undefined) {
                this.speed = data.speed;
            }
            if ("frontFlap" in data && data.frontFlap != undefined) {
                this.frontFlap = data.frontFlap;
            }
            if ("rearFlap" in data && data.rearFlap != undefined) {
                this.rearFlap = data.rearFlap;
            }
            if ("ccaId" in data && data.ccaId != undefined) {
                this.ccaId = data.ccaId;
            }
            if ("spec" in data && data.spec != undefined) {
                this.spec = data.spec;
            }
            if ("radBlocker" in data && data.radBlocker != undefined) {
                this.radBlocker = data.radBlocker;
            }
            if ("domain" in data && data.domain != undefined) {
                this.domain = data.domain;
            }
            if ("simScope" in data && data.simScope != undefined) {
                this.simScope = data.simScope;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get exhaust() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set exhaust(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get roll() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set roll(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get yaw() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set yaw(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get frh() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set frh(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get rrh() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set rrh(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get steer() {
        return pb_1.Message.getFieldWithDefault(this, 7, 0);
    }
    set steer(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get radius() {
        return pb_1.Message.getFieldWithDefault(this, 8, 0);
    }
    set radius(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get speed() {
        return pb_1.Message.getFieldWithDefault(this, 9, 0);
    }
    set speed(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get frontFlap() {
        return pb_1.Message.getFieldWithDefault(this, 10, 0);
    }
    set frontFlap(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get rearFlap() {
        return pb_1.Message.getFieldWithDefault(this, 11, 0);
    }
    set rearFlap(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get ccaId() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set ccaId(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get spec() {
        return pb_1.Message.getFieldWithDefault(this, 13, 0);
    }
    set spec(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get radBlocker() {
        return pb_1.Message.getFieldWithDefault(this, 14, 0);
    }
    set radBlocker(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get domain() {
        return pb_1.Message.getFieldWithDefault(this, 15, "");
    }
    set domain(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get simScope() {
        return pb_1.Message.getFieldWithDefault(this, 40, SimScope.NOT_USED_SIMSCOPE);
    }
    set simScope(value) {
        pb_1.Message.setField(this, 40, value);
    }
    static fromObject(data) {
        const message = new AttitudeState({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.exhaust != null) {
            message.exhaust = data.exhaust;
        }
        if (data.roll != null) {
            message.roll = data.roll;
        }
        if (data.yaw != null) {
            message.yaw = data.yaw;
        }
        if (data.frh != null) {
            message.frh = data.frh;
        }
        if (data.rrh != null) {
            message.rrh = data.rrh;
        }
        if (data.steer != null) {
            message.steer = data.steer;
        }
        if (data.radius != null) {
            message.radius = data.radius;
        }
        if (data.speed != null) {
            message.speed = data.speed;
        }
        if (data.frontFlap != null) {
            message.frontFlap = data.frontFlap;
        }
        if (data.rearFlap != null) {
            message.rearFlap = data.rearFlap;
        }
        if (data.ccaId != null) {
            message.ccaId = data.ccaId;
        }
        if (data.spec != null) {
            message.spec = data.spec;
        }
        if (data.radBlocker != null) {
            message.radBlocker = data.radBlocker;
        }
        if (data.domain != null) {
            message.domain = data.domain;
        }
        if (data.simScope != null) {
            message.simScope = data.simScope;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.exhaust != null) {
            data.exhaust = this.exhaust;
        }
        if (this.roll != null) {
            data.roll = this.roll;
        }
        if (this.yaw != null) {
            data.yaw = this.yaw;
        }
        if (this.frh != null) {
            data.frh = this.frh;
        }
        if (this.rrh != null) {
            data.rrh = this.rrh;
        }
        if (this.steer != null) {
            data.steer = this.steer;
        }
        if (this.radius != null) {
            data.radius = this.radius;
        }
        if (this.speed != null) {
            data.speed = this.speed;
        }
        if (this.frontFlap != null) {
            data.frontFlap = this.frontFlap;
        }
        if (this.rearFlap != null) {
            data.rearFlap = this.rearFlap;
        }
        if (this.ccaId != null) {
            data.ccaId = this.ccaId;
        }
        if (this.spec != null) {
            data.spec = this.spec;
        }
        if (this.radBlocker != null) {
            data.radBlocker = this.radBlocker;
        }
        if (this.domain != null) {
            data.domain = this.domain;
        }
        if (this.simScope != null) {
            data.simScope = this.simScope;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.exhaust != 0)
            writer.writeFloat(2, this.exhaust);
        if (this.roll != 0)
            writer.writeFloat(3, this.roll);
        if (this.yaw != 0)
            writer.writeFloat(4, this.yaw);
        if (this.frh != 0)
            writer.writeFloat(5, this.frh);
        if (this.rrh != 0)
            writer.writeFloat(6, this.rrh);
        if (this.steer != 0)
            writer.writeFloat(7, this.steer);
        if (this.radius != 0)
            writer.writeFloat(8, this.radius);
        if (this.speed != 0)
            writer.writeFloat(9, this.speed);
        if (this.frontFlap != 0)
            writer.writeFloat(10, this.frontFlap);
        if (this.rearFlap != 0)
            writer.writeFloat(11, this.rearFlap);
        if (this.ccaId.length)
            writer.writeString(12, this.ccaId);
        if (this.spec != 0)
            writer.writeDouble(13, this.spec);
        if (this.radBlocker != 0)
            writer.writeDouble(14, this.radBlocker);
        if (this.domain.length)
            writer.writeString(15, this.domain);
        if (this.simScope != SimScope.NOT_USED_SIMSCOPE)
            writer.writeEnum(40, this.simScope);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AttitudeState();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.exhaust = reader.readFloat();
                    break;
                case 3:
                    message.roll = reader.readFloat();
                    break;
                case 4:
                    message.yaw = reader.readFloat();
                    break;
                case 5:
                    message.frh = reader.readFloat();
                    break;
                case 6:
                    message.rrh = reader.readFloat();
                    break;
                case 7:
                    message.steer = reader.readFloat();
                    break;
                case 8:
                    message.radius = reader.readFloat();
                    break;
                case 9:
                    message.speed = reader.readFloat();
                    break;
                case 10:
                    message.frontFlap = reader.readFloat();
                    break;
                case 11:
                    message.rearFlap = reader.readFloat();
                    break;
                case 12:
                    message.ccaId = reader.readString();
                    break;
                case 13:
                    message.spec = reader.readDouble();
                    break;
                case 14:
                    message.radBlocker = reader.readDouble();
                    break;
                case 15:
                    message.domain = reader.readString();
                    break;
                case 40:
                    message.simScope = reader.readEnum();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return AttitudeState.deserialize(bytes);
    }
}
exports.AttitudeState = AttitudeState;
_AttitudeState_one_of_decls = new WeakMap();
class Trajectory extends pb_1.Message {
    constructor(data) {
        super();
        _Trajectory_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], __classPrivateFieldGet(this, _Trajectory_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("attitudeStates" in data && data.attitudeStates != undefined) {
                this.attitudeStates = data.attitudeStates;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get attitudeStates() {
        return pb_1.Message.getFieldWithDefault(this, 3, []);
    }
    set attitudeStates(value) {
        pb_1.Message.setField(this, 3, value);
    }
    static fromObject(data) {
        const message = new Trajectory({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.attitudeStates != null) {
            message.attitudeStates = data.attitudeStates;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.attitudeStates != null) {
            data.attitudeStates = this.attitudeStates;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.description.length)
            writer.writeString(2, this.description);
        if (this.attitudeStates.length)
            writer.writeRepeatedString(3, this.attitudeStates);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Trajectory();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.description = reader.readString();
                    break;
                case 3:
                    pb_1.Message.addToRepeatedField(message, 3, reader.readString());
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Trajectory.deserialize(bytes);
    }
}
exports.Trajectory = Trajectory;
_Trajectory_one_of_decls = new WeakMap();
class AttitudeSet extends pb_1.Message {
    constructor(data) {
        super();
        _AttitudeSet_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5, 6], __classPrivateFieldGet(this, _AttitudeSet_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("attitudeStates" in data && data.attitudeStates != undefined) {
                this.attitudeStates = data.attitudeStates;
            }
            if ("trajectories" in data && data.trajectories != undefined) {
                this.trajectories = data.trajectories;
            }
            if ("sequencerId" in data && data.sequencerId != undefined) {
                this.sequencerId = data.sequencerId;
            }
            if ("speedType" in data && data.speedType != undefined) {
                this.speedType = data.speedType;
            }
            if ("documentMeta" in data && data.documentMeta != undefined) {
                this.documentMeta = data.documentMeta;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get attitudeStates() {
        return pb_1.Message.getRepeatedWrapperField(this, AttitudeState, 5);
    }
    set attitudeStates(value) {
        pb_1.Message.setRepeatedWrapperField(this, 5, value);
    }
    get trajectories() {
        return pb_1.Message.getRepeatedWrapperField(this, Trajectory, 6);
    }
    set trajectories(value) {
        pb_1.Message.setRepeatedWrapperField(this, 6, value);
    }
    get sequencerId() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set sequencerId(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get speedType() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set speedType(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get documentMeta() {
        return pb_1.Message.getWrapperField(this, DocumentMeta, 100);
    }
    set documentMeta(value) {
        pb_1.Message.setWrapperField(this, 100, value);
    }
    get has_documentMeta() {
        return pb_1.Message.getField(this, 100) != null;
    }
    static fromObject(data) {
        const message = new AttitudeSet({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.attitudeStates != null) {
            message.attitudeStates = data.attitudeStates.map(item => AttitudeState.fromObject(item));
        }
        if (data.trajectories != null) {
            message.trajectories = data.trajectories.map(item => Trajectory.fromObject(item));
        }
        if (data.sequencerId != null) {
            message.sequencerId = data.sequencerId;
        }
        if (data.speedType != null) {
            message.speedType = data.speedType;
        }
        if (data.documentMeta != null) {
            message.documentMeta = DocumentMeta.fromObject(data.documentMeta);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.attitudeStates != null) {
            data.attitudeStates = this.attitudeStates.map((item) => item.toObject());
        }
        if (this.trajectories != null) {
            data.trajectories = this.trajectories.map((item) => item.toObject());
        }
        if (this.sequencerId != null) {
            data.sequencerId = this.sequencerId;
        }
        if (this.speedType != null) {
            data.speedType = this.speedType;
        }
        if (this.documentMeta != null) {
            data.documentMeta = this.documentMeta.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.name.length)
            writer.writeString(3, this.name);
        if (this.description.length)
            writer.writeString(4, this.description);
        if (this.attitudeStates.length)
            writer.writeRepeatedMessage(5, this.attitudeStates, (item) => item.serialize(writer));
        if (this.trajectories.length)
            writer.writeRepeatedMessage(6, this.trajectories, (item) => item.serialize(writer));
        if (this.sequencerId.length)
            writer.writeString(7, this.sequencerId);
        if (this.speedType.length)
            writer.writeString(8, this.speedType);
        if (this.has_documentMeta)
            writer.writeMessage(100, this.documentMeta, () => this.documentMeta.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AttitudeSet();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.name = reader.readString();
                    break;
                case 4:
                    message.description = reader.readString();
                    break;
                case 5:
                    reader.readMessage(message.attitudeStates, () => pb_1.Message.addToRepeatedWrapperField(message, 5, AttitudeState.deserialize(reader), AttitudeState));
                    break;
                case 6:
                    reader.readMessage(message.trajectories, () => pb_1.Message.addToRepeatedWrapperField(message, 6, Trajectory.deserialize(reader), Trajectory));
                    break;
                case 7:
                    message.sequencerId = reader.readString();
                    break;
                case 8:
                    message.speedType = reader.readString();
                    break;
                case 100:
                    reader.readMessage(message.documentMeta, () => message.documentMeta = DocumentMeta.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return AttitudeSet.deserialize(bytes);
    }
}
exports.AttitudeSet = AttitudeSet;
_AttitudeSet_one_of_decls = new WeakMap();
class DomainState extends pb_1.Message {
    constructor(data) {
        super();
        _DomainState_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], __classPrivateFieldGet(this, _DomainState_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("fileRef" in data && data.fileRef != undefined) {
                this.fileRef = data.fileRef;
            }
            if ("WTDomain" in data && data.WTDomain != undefined) {
                this.WTDomain = data.WTDomain;
            }
            if ("MMSLocation" in data && data.MMSLocation != undefined) {
                this.MMSLocation = data.MMSLocation;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get fileRef() {
        return pb_1.Message.getWrapperField(this, CFDFile, 3);
    }
    set fileRef(value) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_fileRef() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get WTDomain() {
        return pb_1.Message.getFieldWithDefault(this, 4, false);
    }
    set WTDomain(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get MMSLocation() {
        return pb_1.Message.getFieldWithDefault(this, 5, []);
    }
    set MMSLocation(value) {
        pb_1.Message.setField(this, 5, value);
    }
    static fromObject(data) {
        const message = new DomainState({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.fileRef != null) {
            message.fileRef = CFDFile.fromObject(data.fileRef);
        }
        if (data.WTDomain != null) {
            message.WTDomain = data.WTDomain;
        }
        if (data.MMSLocation != null) {
            message.MMSLocation = data.MMSLocation;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.fileRef != null) {
            data.fileRef = this.fileRef.toObject();
        }
        if (this.WTDomain != null) {
            data.WTDomain = this.WTDomain;
        }
        if (this.MMSLocation != null) {
            data.MMSLocation = this.MMSLocation;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.description.length)
            writer.writeString(2, this.description);
        if (this.has_fileRef)
            writer.writeMessage(3, this.fileRef, () => this.fileRef.serialize(writer));
        if (this.WTDomain != false)
            writer.writeBool(4, this.WTDomain);
        if (this.MMSLocation.length)
            writer.writePackedFloat(5, this.MMSLocation);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DomainState();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.description = reader.readString();
                    break;
                case 3:
                    reader.readMessage(message.fileRef, () => message.fileRef = CFDFile.deserialize(reader));
                    break;
                case 4:
                    message.WTDomain = reader.readBool();
                    break;
                case 5:
                    message.MMSLocation = reader.readPackedFloat();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return DomainState.deserialize(bytes);
    }
}
exports.DomainState = DomainState;
_DomainState_one_of_decls = new WeakMap();
class DomainSet extends pb_1.Message {
    constructor(data) {
        super();
        _DomainSet_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], __classPrivateFieldGet(this, _DomainSet_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("domainStates" in data && data.domainStates != undefined) {
                this.domainStates = data.domainStates;
            }
            if ("documentMeta" in data && data.documentMeta != undefined) {
                this.documentMeta = data.documentMeta;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get domainStates() {
        return pb_1.Message.getRepeatedWrapperField(this, DomainState, 5);
    }
    set domainStates(value) {
        pb_1.Message.setRepeatedWrapperField(this, 5, value);
    }
    get documentMeta() {
        return pb_1.Message.getWrapperField(this, DocumentMeta, 100);
    }
    set documentMeta(value) {
        pb_1.Message.setWrapperField(this, 100, value);
    }
    get has_documentMeta() {
        return pb_1.Message.getField(this, 100) != null;
    }
    static fromObject(data) {
        const message = new DomainSet({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.domainStates != null) {
            message.domainStates = data.domainStates.map(item => DomainState.fromObject(item));
        }
        if (data.documentMeta != null) {
            message.documentMeta = DocumentMeta.fromObject(data.documentMeta);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.domainStates != null) {
            data.domainStates = this.domainStates.map((item) => item.toObject());
        }
        if (this.documentMeta != null) {
            data.documentMeta = this.documentMeta.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.name.length)
            writer.writeString(3, this.name);
        if (this.description.length)
            writer.writeString(4, this.description);
        if (this.domainStates.length)
            writer.writeRepeatedMessage(5, this.domainStates, (item) => item.serialize(writer));
        if (this.has_documentMeta)
            writer.writeMessage(100, this.documentMeta, () => this.documentMeta.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DomainSet();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.name = reader.readString();
                    break;
                case 4:
                    message.description = reader.readString();
                    break;
                case 5:
                    reader.readMessage(message.domainStates, () => pb_1.Message.addToRepeatedWrapperField(message, 5, DomainState.deserialize(reader), DomainState));
                    break;
                case 100:
                    reader.readMessage(message.documentMeta, () => message.documentMeta = DocumentMeta.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return DomainSet.deserialize(bytes);
    }
}
exports.DomainSet = DomainSet;
_DomainSet_one_of_decls = new WeakMap();
class SimulationState extends pb_1.Message {
    constructor(data) {
        super();
        _SimulationState_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _SimulationState_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 3, SimulationStateType.FCRANS);
    }
    set type(value) {
        pb_1.Message.setField(this, 3, value);
    }
    static fromObject(data) {
        const message = new SimulationState({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.type != null) {
            message.type = data.type;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.type != null) {
            data.type = this.type;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.description.length)
            writer.writeString(2, this.description);
        if (this.type != SimulationStateType.FCRANS)
            writer.writeEnum(3, this.type);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SimulationState();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.description = reader.readString();
                    break;
                case 3:
                    message.type = reader.readEnum();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SimulationState.deserialize(bytes);
    }
}
exports.SimulationState = SimulationState;
_SimulationState_one_of_decls = new WeakMap();
class SimulationSet extends pb_1.Message {
    constructor(data) {
        super();
        _SimulationSet_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], __classPrivateFieldGet(this, _SimulationSet_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("simulationStates" in data && data.simulationStates != undefined) {
                this.simulationStates = data.simulationStates;
            }
            if ("documentMeta" in data && data.documentMeta != undefined) {
                this.documentMeta = data.documentMeta;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get simulationStates() {
        return pb_1.Message.getRepeatedWrapperField(this, SimulationState, 5);
    }
    set simulationStates(value) {
        pb_1.Message.setRepeatedWrapperField(this, 5, value);
    }
    get documentMeta() {
        return pb_1.Message.getWrapperField(this, DocumentMeta, 100);
    }
    set documentMeta(value) {
        pb_1.Message.setWrapperField(this, 100, value);
    }
    get has_documentMeta() {
        return pb_1.Message.getField(this, 100) != null;
    }
    static fromObject(data) {
        const message = new SimulationSet({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.simulationStates != null) {
            message.simulationStates = data.simulationStates.map(item => SimulationState.fromObject(item));
        }
        if (data.documentMeta != null) {
            message.documentMeta = DocumentMeta.fromObject(data.documentMeta);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.simulationStates != null) {
            data.simulationStates = this.simulationStates.map((item) => item.toObject());
        }
        if (this.documentMeta != null) {
            data.documentMeta = this.documentMeta.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.name.length)
            writer.writeString(3, this.name);
        if (this.description.length)
            writer.writeString(4, this.description);
        if (this.simulationStates.length)
            writer.writeRepeatedMessage(5, this.simulationStates, (item) => item.serialize(writer));
        if (this.has_documentMeta)
            writer.writeMessage(100, this.documentMeta, () => this.documentMeta.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SimulationSet();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.name = reader.readString();
                    break;
                case 4:
                    message.description = reader.readString();
                    break;
                case 5:
                    reader.readMessage(message.simulationStates, () => pb_1.Message.addToRepeatedWrapperField(message, 5, SimulationState.deserialize(reader), SimulationState));
                    break;
                case 100:
                    reader.readMessage(message.documentMeta, () => message.documentMeta = DocumentMeta.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SimulationSet.deserialize(bytes);
    }
}
exports.SimulationSet = SimulationSet;
_SimulationSet_one_of_decls = new WeakMap();
class PtapLocationSet extends pb_1.Message {
    constructor(data) {
        super();
        _PtapLocationSet_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], __classPrivateFieldGet(this, _PtapLocationSet_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("ptaplocationStates" in data && data.ptaplocationStates != undefined) {
                this.ptaplocationStates = data.ptaplocationStates;
            }
            if ("version" in data && data.version != undefined) {
                this.version = data.version;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get ptaplocationStates() {
        return pb_1.Message.getRepeatedWrapperField(this, PtapLocation, 5);
    }
    set ptaplocationStates(value) {
        pb_1.Message.setRepeatedWrapperField(this, 5, value);
    }
    get version() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set version(value) {
        pb_1.Message.setField(this, 6, value);
    }
    static fromObject(data) {
        const message = new PtapLocationSet({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.ptaplocationStates != null) {
            message.ptaplocationStates = data.ptaplocationStates.map(item => PtapLocation.fromObject(item));
        }
        if (data.version != null) {
            message.version = data.version;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.ptaplocationStates != null) {
            data.ptaplocationStates = this.ptaplocationStates.map((item) => item.toObject());
        }
        if (this.version != null) {
            data.version = this.version;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.name.length)
            writer.writeString(3, this.name);
        if (this.description.length)
            writer.writeString(4, this.description);
        if (this.ptaplocationStates.length)
            writer.writeRepeatedMessage(5, this.ptaplocationStates, (item) => item.serialize(writer));
        if (this.version.length)
            writer.writeString(6, this.version);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PtapLocationSet();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.name = reader.readString();
                    break;
                case 4:
                    message.description = reader.readString();
                    break;
                case 5:
                    reader.readMessage(message.ptaplocationStates, () => pb_1.Message.addToRepeatedWrapperField(message, 5, PtapLocation.deserialize(reader), PtapLocation));
                    break;
                case 6:
                    message.version = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return PtapLocationSet.deserialize(bytes);
    }
}
exports.PtapLocationSet = PtapLocationSet;
_PtapLocationSet_one_of_decls = new WeakMap();
class PtapLocation extends pb_1.Message {
    constructor(data) {
        super();
        _PtapLocation_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _PtapLocation_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("fileRef" in data && data.fileRef != undefined) {
                this.fileRef = data.fileRef;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get fileRef() {
        return pb_1.Message.getWrapperField(this, CFDFile, 3);
    }
    set fileRef(value) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_fileRef() {
        return pb_1.Message.getField(this, 3) != null;
    }
    static fromObject(data) {
        const message = new PtapLocation({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.fileRef != null) {
            message.fileRef = CFDFile.fromObject(data.fileRef);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.fileRef != null) {
            data.fileRef = this.fileRef.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.description.length)
            writer.writeString(2, this.description);
        if (this.has_fileRef)
            writer.writeMessage(3, this.fileRef, () => this.fileRef.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PtapLocation();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.description = reader.readString();
                    break;
                case 3:
                    reader.readMessage(message.fileRef, () => message.fileRef = CFDFile.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return PtapLocation.deserialize(bytes);
    }
}
exports.PtapLocation = PtapLocation;
_PtapLocation_one_of_decls = new WeakMap();
class RHRepoSet extends pb_1.Message {
    constructor(data) {
        super();
        _RHRepoSet_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [7], __classPrivateFieldGet(this, _RHRepoSet_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("version" in data && data.version != undefined) {
                this.version = data.version;
            }
            if ("suspensionTypeEncoding" in data && data.suspensionTypeEncoding != undefined) {
                this.suspensionTypeEncoding = data.suspensionTypeEncoding;
            }
            if ("rhrepoStates" in data && data.rhrepoStates != undefined) {
                this.rhrepoStates = data.rhrepoStates;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get version() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set version(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get suspensionTypeEncoding() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set suspensionTypeEncoding(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get rhrepoStates() {
        return pb_1.Message.getRepeatedWrapperField(this, RHRepo, 7);
    }
    set rhrepoStates(value) {
        pb_1.Message.setRepeatedWrapperField(this, 7, value);
    }
    static fromObject(data) {
        const message = new RHRepoSet({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.version != null) {
            message.version = data.version;
        }
        if (data.suspensionTypeEncoding != null) {
            message.suspensionTypeEncoding = data.suspensionTypeEncoding;
        }
        if (data.rhrepoStates != null) {
            message.rhrepoStates = data.rhrepoStates.map(item => RHRepo.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.version != null) {
            data.version = this.version;
        }
        if (this.suspensionTypeEncoding != null) {
            data.suspensionTypeEncoding = this.suspensionTypeEncoding;
        }
        if (this.rhrepoStates != null) {
            data.rhrepoStates = this.rhrepoStates.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.name.length)
            writer.writeString(3, this.name);
        if (this.description.length)
            writer.writeString(4, this.description);
        if (this.version.length)
            writer.writeString(5, this.version);
        if (this.suspensionTypeEncoding.length)
            writer.writeString(6, this.suspensionTypeEncoding);
        if (this.rhrepoStates.length)
            writer.writeRepeatedMessage(7, this.rhrepoStates, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RHRepoSet();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.name = reader.readString();
                    break;
                case 4:
                    message.description = reader.readString();
                    break;
                case 5:
                    message.version = reader.readString();
                    break;
                case 6:
                    message.suspensionTypeEncoding = reader.readString();
                    break;
                case 7:
                    reader.readMessage(message.rhrepoStates, () => pb_1.Message.addToRepeatedWrapperField(message, 7, RHRepo.deserialize(reader), RHRepo));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RHRepoSet.deserialize(bytes);
    }
}
exports.RHRepoSet = RHRepoSet;
_RHRepoSet_one_of_decls = new WeakMap();
class RHRepo extends pb_1.Message {
    constructor(data) {
        super();
        _RHRepo_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], __classPrivateFieldGet(this, _RHRepo_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("path" in data && data.path != undefined) {
                this.path = data.path;
            }
            if ("suspensionTypeEncoding" in data && data.suspensionTypeEncoding != undefined) {
                this.suspensionTypeEncoding = data.suspensionTypeEncoding;
            }
            if ("fileRef" in data && data.fileRef != undefined) {
                this.fileRef = data.fileRef;
            }
            if ("domain" in data && data.domain != undefined) {
                this.domain = data.domain;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get path() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set path(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get suspensionTypeEncoding() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set suspensionTypeEncoding(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get fileRef() {
        return pb_1.Message.getRepeatedWrapperField(this, CFDFile, 5);
    }
    set fileRef(value) {
        pb_1.Message.setRepeatedWrapperField(this, 5, value);
    }
    get domain() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set domain(value) {
        pb_1.Message.setField(this, 6, value);
    }
    static fromObject(data) {
        const message = new RHRepo({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.path != null) {
            message.path = data.path;
        }
        if (data.suspensionTypeEncoding != null) {
            message.suspensionTypeEncoding = data.suspensionTypeEncoding;
        }
        if (data.fileRef != null) {
            message.fileRef = data.fileRef.map(item => CFDFile.fromObject(item));
        }
        if (data.domain != null) {
            message.domain = data.domain;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.path != null) {
            data.path = this.path;
        }
        if (this.suspensionTypeEncoding != null) {
            data.suspensionTypeEncoding = this.suspensionTypeEncoding;
        }
        if (this.fileRef != null) {
            data.fileRef = this.fileRef.map((item) => item.toObject());
        }
        if (this.domain != null) {
            data.domain = this.domain;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.description.length)
            writer.writeString(2, this.description);
        if (this.path.length)
            writer.writeString(3, this.path);
        if (this.suspensionTypeEncoding.length)
            writer.writeString(4, this.suspensionTypeEncoding);
        if (this.fileRef.length)
            writer.writeRepeatedMessage(5, this.fileRef, (item) => item.serialize(writer));
        if (this.domain.length)
            writer.writeString(6, this.domain);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RHRepo();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.description = reader.readString();
                    break;
                case 3:
                    message.path = reader.readString();
                    break;
                case 4:
                    message.suspensionTypeEncoding = reader.readString();
                    break;
                case 5:
                    reader.readMessage(message.fileRef, () => pb_1.Message.addToRepeatedWrapperField(message, 5, CFDFile.deserialize(reader), CFDFile));
                    break;
                case 6:
                    message.domain = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RHRepo.deserialize(bytes);
    }
}
exports.RHRepo = RHRepo;
_RHRepo_one_of_decls = new WeakMap();
class DeploySet extends pb_1.Message {
    constructor(data) {
        super();
        _DeploySet_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [10], __classPrivateFieldGet(this, _DeploySet_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("system" in data && data.system != undefined) {
                this.system = data.system;
            }
            if ("version" in data && data.version != undefined) {
                this.version = data.version;
            }
            if ("path" in data && data.path != undefined) {
                this.path = data.path;
            }
            if ("releaseType" in data && data.releaseType != undefined) {
                this.releaseType = data.releaseType;
            }
            if ("vendorCompatibilityVersion" in data && data.vendorCompatibilityVersion != undefined) {
                this.vendorCompatibilityVersion = data.vendorCompatibilityVersion;
            }
            if ("branchName" in data && data.branchName != undefined) {
                this.branchName = data.branchName;
            }
            if ("commitId" in data && data.commitId != undefined) {
                this.commitId = data.commitId;
            }
            if ("deployStates" in data && data.deployStates != undefined) {
                this.deployStates = data.deployStates;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get system() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set system(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get version() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set version(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get path() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set path(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get releaseType() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set releaseType(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get vendorCompatibilityVersion() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set vendorCompatibilityVersion(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get branchName() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set branchName(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get commitId() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set commitId(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get deployStates() {
        return pb_1.Message.getRepeatedWrapperField(this, DeployState, 10);
    }
    set deployStates(value) {
        pb_1.Message.setRepeatedWrapperField(this, 10, value);
    }
    static fromObject(data) {
        const message = new DeploySet({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.system != null) {
            message.system = data.system;
        }
        if (data.version != null) {
            message.version = data.version;
        }
        if (data.path != null) {
            message.path = data.path;
        }
        if (data.releaseType != null) {
            message.releaseType = data.releaseType;
        }
        if (data.vendorCompatibilityVersion != null) {
            message.vendorCompatibilityVersion = data.vendorCompatibilityVersion;
        }
        if (data.branchName != null) {
            message.branchName = data.branchName;
        }
        if (data.commitId != null) {
            message.commitId = data.commitId;
        }
        if (data.deployStates != null) {
            message.deployStates = data.deployStates.map(item => DeployState.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.system != null) {
            data.system = this.system;
        }
        if (this.version != null) {
            data.version = this.version;
        }
        if (this.path != null) {
            data.path = this.path;
        }
        if (this.releaseType != null) {
            data.releaseType = this.releaseType;
        }
        if (this.vendorCompatibilityVersion != null) {
            data.vendorCompatibilityVersion = this.vendorCompatibilityVersion;
        }
        if (this.branchName != null) {
            data.branchName = this.branchName;
        }
        if (this.commitId != null) {
            data.commitId = this.commitId;
        }
        if (this.deployStates != null) {
            data.deployStates = this.deployStates.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.system.length)
            writer.writeString(3, this.system);
        if (this.version.length)
            writer.writeString(4, this.version);
        if (this.path.length)
            writer.writeString(5, this.path);
        if (this.releaseType.length)
            writer.writeString(6, this.releaseType);
        if (this.vendorCompatibilityVersion.length)
            writer.writeString(7, this.vendorCompatibilityVersion);
        if (this.branchName.length)
            writer.writeString(8, this.branchName);
        if (this.commitId.length)
            writer.writeString(9, this.commitId);
        if (this.deployStates.length)
            writer.writeRepeatedMessage(10, this.deployStates, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeploySet();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.system = reader.readString();
                    break;
                case 4:
                    message.version = reader.readString();
                    break;
                case 5:
                    message.path = reader.readString();
                    break;
                case 6:
                    message.releaseType = reader.readString();
                    break;
                case 7:
                    message.vendorCompatibilityVersion = reader.readString();
                    break;
                case 8:
                    message.branchName = reader.readString();
                    break;
                case 9:
                    message.commitId = reader.readString();
                    break;
                case 10:
                    reader.readMessage(message.deployStates, () => pb_1.Message.addToRepeatedWrapperField(message, 10, DeployState.deserialize(reader), DeployState));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return DeploySet.deserialize(bytes);
    }
}
exports.DeploySet = DeploySet;
_DeploySet_one_of_decls = new WeakMap();
class DeployState extends pb_1.Message {
    constructor(data) {
        super();
        _DeployState_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _DeployState_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("fileRef" in data && data.fileRef != undefined) {
                this.fileRef = data.fileRef;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get fileRef() {
        return pb_1.Message.getWrapperField(this, CFDFile, 3);
    }
    set fileRef(value) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_fileRef() {
        return pb_1.Message.getField(this, 3) != null;
    }
    static fromObject(data) {
        const message = new DeployState({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.fileRef != null) {
            message.fileRef = CFDFile.fromObject(data.fileRef);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.fileRef != null) {
            data.fileRef = this.fileRef.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.description.length)
            writer.writeString(2, this.description);
        if (this.has_fileRef)
            writer.writeMessage(3, this.fileRef, () => this.fileRef.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeployState();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.description = reader.readString();
                    break;
                case 3:
                    reader.readMessage(message.fileRef, () => message.fileRef = CFDFile.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return DeployState.deserialize(bytes);
    }
}
exports.DeployState = DeployState;
_DeployState_one_of_decls = new WeakMap();
class MethodologyState extends pb_1.Message {
    constructor(data) {
        super();
        _MethodologyState_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _MethodologyState_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("fileRef" in data && data.fileRef != undefined) {
                this.fileRef = data.fileRef;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get fileRef() {
        return pb_1.Message.getWrapperField(this, CFDFile, 3);
    }
    set fileRef(value) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_fileRef() {
        return pb_1.Message.getField(this, 3) != null;
    }
    static fromObject(data) {
        const message = new MethodologyState({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.fileRef != null) {
            message.fileRef = CFDFile.fromObject(data.fileRef);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.fileRef != null) {
            data.fileRef = this.fileRef.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.description.length)
            writer.writeString(2, this.description);
        if (this.has_fileRef)
            writer.writeMessage(3, this.fileRef, () => this.fileRef.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MethodologyState();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.description = reader.readString();
                    break;
                case 3:
                    reader.readMessage(message.fileRef, () => message.fileRef = CFDFile.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return MethodologyState.deserialize(bytes);
    }
}
exports.MethodologyState = MethodologyState;
_MethodologyState_one_of_decls = new WeakMap();
class User extends pb_1.Message {
    constructor(data) {
        super();
        _User_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [13, 18], __classPrivateFieldGet(this, _User_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("userId" in data && data.userId != undefined) {
                this.userId = data.userId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("firstName" in data && data.firstName != undefined) {
                this.firstName = data.firstName;
            }
            if ("lastName" in data && data.lastName != undefined) {
                this.lastName = data.lastName;
            }
            if ("email" in data && data.email != undefined) {
                this.email = data.email;
            }
            if ("role" in data && data.role != undefined) {
                this.role = data.role;
            }
            if ("cloudProviderLDAPRef" in data && data.cloudProviderLDAPRef != undefined) {
                this.cloudProviderLDAPRef = data.cloudProviderLDAPRef;
            }
            if ("rescaleTokens" in data && data.rescaleTokens != undefined) {
                this.rescaleTokens = data.rescaleTokens;
            }
            if ("receiveEmails" in data && data.receiveEmails != undefined) {
                this.receiveEmails = data.receiveEmails;
            }
            if ("receiveTexts" in data && data.receiveTexts != undefined) {
                this.receiveTexts = data.receiveTexts;
            }
            if ("locale" in data && data.locale != undefined) {
                this.locale = data.locale;
            }
            if ("webUserId" in data && data.webUserId != undefined) {
                this.webUserId = data.webUserId;
            }
            if ("externalUserCreds" in data && data.externalUserCreds != undefined) {
                this.externalUserCreds = data.externalUserCreds;
            }
            if ("documentMeta" in data && data.documentMeta != undefined) {
                this.documentMeta = data.documentMeta;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get userId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set userId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get firstName() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set firstName(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get lastName() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set lastName(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get email() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set email(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get role() {
        return pb_1.Message.getWrapperField(this, RaceTeamRole, 11);
    }
    set role(value) {
        pb_1.Message.setWrapperField(this, 11, value);
    }
    get has_role() {
        return pb_1.Message.getField(this, 11) != null;
    }
    get cloudProviderLDAPRef() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set cloudProviderLDAPRef(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get rescaleTokens() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleToken, 13);
    }
    set rescaleTokens(value) {
        pb_1.Message.setRepeatedWrapperField(this, 13, value);
    }
    get receiveEmails() {
        return pb_1.Message.getFieldWithDefault(this, 14, false);
    }
    set receiveEmails(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get receiveTexts() {
        return pb_1.Message.getFieldWithDefault(this, 15, false);
    }
    set receiveTexts(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get locale() {
        return pb_1.Message.getWrapperField(this, Locale, 16);
    }
    set locale(value) {
        pb_1.Message.setWrapperField(this, 16, value);
    }
    get has_locale() {
        return pb_1.Message.getField(this, 16) != null;
    }
    get webUserId() {
        return pb_1.Message.getFieldWithDefault(this, 17, "");
    }
    set webUserId(value) {
        pb_1.Message.setField(this, 17, value);
    }
    get externalUserCreds() {
        return pb_1.Message.getRepeatedWrapperField(this, ExternalUser, 18);
    }
    set externalUserCreds(value) {
        pb_1.Message.setRepeatedWrapperField(this, 18, value);
    }
    get documentMeta() {
        return pb_1.Message.getWrapperField(this, DocumentMeta, 100);
    }
    set documentMeta(value) {
        pb_1.Message.setWrapperField(this, 100, value);
    }
    get has_documentMeta() {
        return pb_1.Message.getField(this, 100) != null;
    }
    static fromObject(data) {
        const message = new User({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.userId != null) {
            message.userId = data.userId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.firstName != null) {
            message.firstName = data.firstName;
        }
        if (data.lastName != null) {
            message.lastName = data.lastName;
        }
        if (data.email != null) {
            message.email = data.email;
        }
        if (data.role != null) {
            message.role = RaceTeamRole.fromObject(data.role);
        }
        if (data.cloudProviderLDAPRef != null) {
            message.cloudProviderLDAPRef = data.cloudProviderLDAPRef;
        }
        if (data.rescaleTokens != null) {
            message.rescaleTokens = data.rescaleTokens.map(item => RescaleToken.fromObject(item));
        }
        if (data.receiveEmails != null) {
            message.receiveEmails = data.receiveEmails;
        }
        if (data.receiveTexts != null) {
            message.receiveTexts = data.receiveTexts;
        }
        if (data.locale != null) {
            message.locale = Locale.fromObject(data.locale);
        }
        if (data.webUserId != null) {
            message.webUserId = data.webUserId;
        }
        if (data.externalUserCreds != null) {
            message.externalUserCreds = data.externalUserCreds.map(item => ExternalUser.fromObject(item));
        }
        if (data.documentMeta != null) {
            message.documentMeta = DocumentMeta.fromObject(data.documentMeta);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.userId != null) {
            data.userId = this.userId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.firstName != null) {
            data.firstName = this.firstName;
        }
        if (this.lastName != null) {
            data.lastName = this.lastName;
        }
        if (this.email != null) {
            data.email = this.email;
        }
        if (this.role != null) {
            data.role = this.role.toObject();
        }
        if (this.cloudProviderLDAPRef != null) {
            data.cloudProviderLDAPRef = this.cloudProviderLDAPRef;
        }
        if (this.rescaleTokens != null) {
            data.rescaleTokens = this.rescaleTokens.map((item) => item.toObject());
        }
        if (this.receiveEmails != null) {
            data.receiveEmails = this.receiveEmails;
        }
        if (this.receiveTexts != null) {
            data.receiveTexts = this.receiveTexts;
        }
        if (this.locale != null) {
            data.locale = this.locale.toObject();
        }
        if (this.webUserId != null) {
            data.webUserId = this.webUserId;
        }
        if (this.externalUserCreds != null) {
            data.externalUserCreds = this.externalUserCreds.map((item) => item.toObject());
        }
        if (this.documentMeta != null) {
            data.documentMeta = this.documentMeta.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.userId.length)
            writer.writeString(2, this.userId);
        if (this._id.length)
            writer.writeString(3, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.firstName.length)
            writer.writeString(8, this.firstName);
        if (this.lastName.length)
            writer.writeString(9, this.lastName);
        if (this.email.length)
            writer.writeString(10, this.email);
        if (this.has_role)
            writer.writeMessage(11, this.role, () => this.role.serialize(writer));
        if (this.cloudProviderLDAPRef.length)
            writer.writeString(12, this.cloudProviderLDAPRef);
        if (this.rescaleTokens.length)
            writer.writeRepeatedMessage(13, this.rescaleTokens, (item) => item.serialize(writer));
        if (this.receiveEmails != false)
            writer.writeBool(14, this.receiveEmails);
        if (this.receiveTexts != false)
            writer.writeBool(15, this.receiveTexts);
        if (this.has_locale)
            writer.writeMessage(16, this.locale, () => this.locale.serialize(writer));
        if (this.webUserId.length)
            writer.writeString(17, this.webUserId);
        if (this.externalUserCreds.length)
            writer.writeRepeatedMessage(18, this.externalUserCreds, (item) => item.serialize(writer));
        if (this.has_documentMeta)
            writer.writeMessage(100, this.documentMeta, () => this.documentMeta.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new User();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.userId = reader.readString();
                    break;
                case 3:
                    message._id = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.firstName = reader.readString();
                    break;
                case 9:
                    message.lastName = reader.readString();
                    break;
                case 10:
                    message.email = reader.readString();
                    break;
                case 11:
                    reader.readMessage(message.role, () => message.role = RaceTeamRole.deserialize(reader));
                    break;
                case 12:
                    message.cloudProviderLDAPRef = reader.readString();
                    break;
                case 13:
                    reader.readMessage(message.rescaleTokens, () => pb_1.Message.addToRepeatedWrapperField(message, 13, RescaleToken.deserialize(reader), RescaleToken));
                    break;
                case 14:
                    message.receiveEmails = reader.readBool();
                    break;
                case 15:
                    message.receiveTexts = reader.readBool();
                    break;
                case 16:
                    reader.readMessage(message.locale, () => message.locale = Locale.deserialize(reader));
                    break;
                case 17:
                    message.webUserId = reader.readString();
                    break;
                case 18:
                    reader.readMessage(message.externalUserCreds, () => pb_1.Message.addToRepeatedWrapperField(message, 18, ExternalUser.deserialize(reader), ExternalUser));
                    break;
                case 100:
                    reader.readMessage(message.documentMeta, () => message.documentMeta = DocumentMeta.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return User.deserialize(bytes);
    }
}
exports.User = User;
_User_one_of_decls = new WeakMap();
class ExternalUser extends pb_1.Message {
    constructor(data) {
        super();
        _ExternalUser_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _ExternalUser_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("externalSystemId" in data && data.externalSystemId != undefined) {
                this.externalSystemId = data.externalSystemId;
            }
            if ("userId" in data && data.userId != undefined) {
                this.userId = data.userId;
            }
            if ("token" in data && data.token != undefined) {
                this.token = data.token;
            }
            if ("externalUserType" in data && data.externalUserType != undefined) {
                this.externalUserType = data.externalUserType;
            }
        }
    }
    get externalSystemId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set externalSystemId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get userId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set userId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get token() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set token(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get externalUserType() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set externalUserType(value) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data) {
        const message = new ExternalUser({});
        if (data.externalSystemId != null) {
            message.externalSystemId = data.externalSystemId;
        }
        if (data.userId != null) {
            message.userId = data.userId;
        }
        if (data.token != null) {
            message.token = data.token;
        }
        if (data.externalUserType != null) {
            message.externalUserType = data.externalUserType;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.externalSystemId != null) {
            data.externalSystemId = this.externalSystemId;
        }
        if (this.userId != null) {
            data.userId = this.userId;
        }
        if (this.token != null) {
            data.token = this.token;
        }
        if (this.externalUserType != null) {
            data.externalUserType = this.externalUserType;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.externalSystemId.length)
            writer.writeString(1, this.externalSystemId);
        if (this.userId.length)
            writer.writeString(2, this.userId);
        if (this.token.length)
            writer.writeString(3, this.token);
        if (this.externalUserType.length)
            writer.writeString(4, this.externalUserType);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ExternalUser();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.externalSystemId = reader.readString();
                    break;
                case 2:
                    message.userId = reader.readString();
                    break;
                case 3:
                    message.token = reader.readString();
                    break;
                case 4:
                    message.externalUserType = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return ExternalUser.deserialize(bytes);
    }
}
exports.ExternalUser = ExternalUser;
_ExternalUser_one_of_decls = new WeakMap();
class ExternalSystem extends pb_1.Message {
    constructor(data) {
        super();
        _ExternalSystem_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _ExternalSystem_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("externalSystemType" in data && data.externalSystemType != undefined) {
                this.externalSystemType = data.externalSystemType;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get externalSystemType() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set externalSystemType(value) {
        pb_1.Message.setField(this, 3, value);
    }
    static fromObject(data) {
        const message = new ExternalSystem({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.externalSystemType != null) {
            message.externalSystemType = data.externalSystemType;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.externalSystemType != null) {
            data.externalSystemType = this.externalSystemType;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.name.length)
            writer.writeString(2, this.name);
        if (this.externalSystemType.length)
            writer.writeString(3, this.externalSystemType);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ExternalSystem();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.name = reader.readString();
                    break;
                case 3:
                    message.externalSystemType = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return ExternalSystem.deserialize(bytes);
    }
}
exports.ExternalSystem = ExternalSystem;
_ExternalSystem_one_of_decls = new WeakMap();
class AccessRolePermissions extends pb_1.Message {
    constructor(data) {
        super();
        _AccessRolePermissions_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4], __classPrivateFieldGet(this, _AccessRolePermissions_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("roleType" in data && data.roleType != undefined) {
                this.roleType = data.roleType;
            }
            if ("permissions" in data && data.permissions != undefined) {
                this.permissions = data.permissions;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get roleType() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set roleType(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get permissions() {
        return pb_1.Message.getFieldWithDefault(this, 4, []);
    }
    set permissions(value) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data) {
        const message = new AccessRolePermissions({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.roleType != null) {
            message.roleType = data.roleType;
        }
        if (data.permissions != null) {
            message.permissions = data.permissions;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.roleType != null) {
            data.roleType = this.roleType;
        }
        if (this.permissions != null) {
            data.permissions = this.permissions;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.roleType.length)
            writer.writeString(3, this.roleType);
        if (this.permissions.length)
            writer.writeRepeatedString(4, this.permissions);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AccessRolePermissions();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.roleType = reader.readString();
                    break;
                case 4:
                    pb_1.Message.addToRepeatedField(message, 4, reader.readString());
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return AccessRolePermissions.deserialize(bytes);
    }
}
exports.AccessRolePermissions = AccessRolePermissions;
_AccessRolePermissions_one_of_decls = new WeakMap();
class Locale extends pb_1.Message {
    constructor(data) {
        super();
        _Locale_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Locale_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("language" in data && data.language != undefined) {
                this.language = data.language;
            }
            if ("country" in data && data.country != undefined) {
                this.country = data.country;
            }
            if ("region" in data && data.region != undefined) {
                this.region = data.region;
            }
            if ("timeZone" in data && data.timeZone != undefined) {
                this.timeZone = data.timeZone;
            }
        }
    }
    get language() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set language(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get country() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set country(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get region() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set region(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeZone() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set timeZone(value) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data) {
        const message = new Locale({});
        if (data.language != null) {
            message.language = data.language;
        }
        if (data.country != null) {
            message.country = data.country;
        }
        if (data.region != null) {
            message.region = data.region;
        }
        if (data.timeZone != null) {
            message.timeZone = data.timeZone;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.language != null) {
            data.language = this.language;
        }
        if (this.country != null) {
            data.country = this.country;
        }
        if (this.region != null) {
            data.region = this.region;
        }
        if (this.timeZone != null) {
            data.timeZone = this.timeZone;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.language.length)
            writer.writeString(1, this.language);
        if (this.country.length)
            writer.writeString(2, this.country);
        if (this.region.length)
            writer.writeString(3, this.region);
        if (this.timeZone.length)
            writer.writeString(4, this.timeZone);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Locale();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.language = reader.readString();
                    break;
                case 2:
                    message.country = reader.readString();
                    break;
                case 3:
                    message.region = reader.readString();
                    break;
                case 4:
                    message.timeZone = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Locale.deserialize(bytes);
    }
}
exports.Locale = Locale;
_Locale_one_of_decls = new WeakMap();
class UserWorkflowMgmt extends pb_1.Message {
    constructor(data) {
        super();
        _UserWorkflowMgmt_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _UserWorkflowMgmt_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("lastRunTS" in data && data.lastRunTS != undefined) {
                this.lastRunTS = data.lastRunTS;
            }
            if ("lastPriority" in data && data.lastPriority != undefined) {
                this.lastPriority = data.lastPriority;
            }
        }
    }
    get lastRunTS() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set lastRunTS(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get lastPriority() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set lastPriority(value) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data) {
        const message = new UserWorkflowMgmt({});
        if (data.lastRunTS != null) {
            message.lastRunTS = data.lastRunTS;
        }
        if (data.lastPriority != null) {
            message.lastPriority = data.lastPriority;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.lastRunTS != null) {
            data.lastRunTS = this.lastRunTS;
        }
        if (this.lastPriority != null) {
            data.lastPriority = this.lastPriority;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.lastRunTS != 0)
            writer.writeInt64(1, this.lastRunTS);
        if (this.lastPriority != 0)
            writer.writeInt32(2, this.lastPriority);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UserWorkflowMgmt();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.lastRunTS = reader.readInt64();
                    break;
                case 2:
                    message.lastPriority = reader.readInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return UserWorkflowMgmt.deserialize(bytes);
    }
}
exports.UserWorkflowMgmt = UserWorkflowMgmt;
_UserWorkflowMgmt_one_of_decls = new WeakMap();
class RescaleToken extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleToken_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RescaleToken_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("token" in data && data.token != undefined) {
                this.token = data.token;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("tokenExpiration" in data && data.tokenExpiration != undefined) {
                this.tokenExpiration = data.tokenExpiration;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("workspaceName" in data && data.workspaceName != undefined) {
                this.workspaceName = data.workspaceName;
            }
            if ("active" in data && data.active != undefined) {
                this.active = data.active;
            }
        }
    }
    get token() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set token(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get tokenExpiration() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set tokenExpiration(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get workspaceName() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set workspaceName(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get active() {
        return pb_1.Message.getFieldWithDefault(this, 9, false);
    }
    set active(value) {
        pb_1.Message.setField(this, 9, value);
    }
    static fromObject(data) {
        const message = new RescaleToken({});
        if (data.token != null) {
            message.token = data.token;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.tokenExpiration != null) {
            message.tokenExpiration = data.tokenExpiration;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.workspaceName != null) {
            message.workspaceName = data.workspaceName;
        }
        if (data.active != null) {
            message.active = data.active;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.token != null) {
            data.token = this.token;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.tokenExpiration != null) {
            data.tokenExpiration = this.tokenExpiration;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.workspaceName != null) {
            data.workspaceName = this.workspaceName;
        }
        if (this.active != null) {
            data.active = this.active;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.token.length)
            writer.writeString(1, this.token);
        if (this.name.length)
            writer.writeString(2, this.name);
        if (this.tokenExpiration != 0)
            writer.writeInt64(3, this.tokenExpiration);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.workspaceName.length)
            writer.writeString(8, this.workspaceName);
        if (this.active != false)
            writer.writeBool(9, this.active);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleToken();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.token = reader.readString();
                    break;
                case 2:
                    message.name = reader.readString();
                    break;
                case 3:
                    message.tokenExpiration = reader.readInt64();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.workspaceName = reader.readString();
                    break;
                case 9:
                    message.active = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleToken.deserialize(bytes);
    }
}
exports.RescaleToken = RescaleToken;
_RescaleToken_one_of_decls = new WeakMap();
class Geometry extends pb_1.Message {
    constructor(data) {
        super();
        _Geometry_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Geometry_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("geoId" in data && data.geoId != undefined) {
                this.geoId = data.geoId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("cadFileName" in data && data.cadFileName != undefined) {
                this.cadFileName = data.cadFileName;
            }
            if ("archive" in data && data.archive != undefined) {
                this.archive = data.archive;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get geoId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set geoId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get cadFileName() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set cadFileName(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get archive() {
        return pb_1.Message.getFieldWithDefault(this, 11, false);
    }
    set archive(value) {
        pb_1.Message.setField(this, 11, value);
    }
    static fromObject(data) {
        const message = new Geometry({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.geoId != null) {
            message.geoId = data.geoId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.cadFileName != null) {
            message.cadFileName = data.cadFileName;
        }
        if (data.archive != null) {
            message.archive = data.archive;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.geoId != null) {
            data.geoId = this.geoId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.cadFileName != null) {
            data.cadFileName = this.cadFileName;
        }
        if (this.archive != null) {
            data.archive = this.archive;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.geoId.length)
            writer.writeString(2, this.geoId);
        if (this._id.length)
            writer.writeString(3, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.name.length)
            writer.writeString(8, this.name);
        if (this.description.length)
            writer.writeString(9, this.description);
        if (this.cadFileName.length)
            writer.writeString(10, this.cadFileName);
        if (this.archive != false)
            writer.writeBool(11, this.archive);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Geometry();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.geoId = reader.readString();
                    break;
                case 3:
                    message._id = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.name = reader.readString();
                    break;
                case 9:
                    message.description = reader.readString();
                    break;
                case 10:
                    message.cadFileName = reader.readString();
                    break;
                case 11:
                    message.archive = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Geometry.deserialize(bytes);
    }
}
exports.Geometry = Geometry;
_Geometry_one_of_decls = new WeakMap();
class RaceTeamRole extends pb_1.Message {
    constructor(data) {
        super();
        _RaceTeamRole_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RaceTeamRole_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("roleId" in data && data.roleId != undefined) {
                this.roleId = data.roleId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get roleId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set roleId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 9, value);
    }
    static fromObject(data) {
        const message = new RaceTeamRole({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.roleId != null) {
            message.roleId = data.roleId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.roleId != null) {
            data.roleId = this.roleId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.roleId.length)
            writer.writeString(2, this.roleId);
        if (this._id.length)
            writer.writeString(3, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.name.length)
            writer.writeString(8, this.name);
        if (this.description.length)
            writer.writeString(9, this.description);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RaceTeamRole();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.roleId = reader.readString();
                    break;
                case 3:
                    message._id = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.name = reader.readString();
                    break;
                case 9:
                    message.description = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RaceTeamRole.deserialize(bytes);
    }
}
exports.RaceTeamRole = RaceTeamRole;
_RaceTeamRole_one_of_decls = new WeakMap();
class MethodologySet extends pb_1.Message {
    constructor(data) {
        super();
        _MethodologySet_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [23, 24, 25], __classPrivateFieldGet(this, _MethodologySet_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("methodId" in data && data.methodId != undefined) {
                this.methodId = data.methodId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("version" in data && data.version != undefined) {
                this.version = data.version;
            }
            if ("archive" in data && data.archive != undefined) {
                this.archive = data.archive;
            }
            if ("starccmConfig" in data && data.starccmConfig != undefined) {
                this.starccmConfig = data.starccmConfig;
            }
            if ("ansa" in data && data.ansa != undefined) {
                this.ansa = data.ansa;
            }
            if ("starccm" in data && data.starccm != undefined) {
                this.starccm = data.starccm;
            }
            if ("periscope" in data && data.periscope != undefined) {
                this.periscope = data.periscope;
            }
            if ("selectedSystems" in data && data.selectedSystems != undefined) {
                this.selectedSystems = data.selectedSystems;
            }
            if ("methodologyStates" in data && data.methodologyStates != undefined) {
                this.methodologyStates = data.methodologyStates;
            }
            if ("systemCodeFiles" in data && data.systemCodeFiles != undefined) {
                this.systemCodeFiles = data.systemCodeFiles;
            }
            if ("isHardwareOverride" in data && data.isHardwareOverride != undefined) {
                this.isHardwareOverride = data.isHardwareOverride;
            }
            if ("hardwareOverrides" in data && data.hardwareOverrides != undefined) {
                this.hardwareOverrides = data.hardwareOverrides;
            }
            if ("jobRunParams" in data && data.jobRunParams != undefined) {
                this.jobRunParams = data.jobRunParams;
            }
            if ("status" in data && data.status != undefined) {
                this.status = data.status;
            }
            if ("documentMeta" in data && data.documentMeta != undefined) {
                this.documentMeta = data.documentMeta;
            }
        }
        if (!this.jobRunParams)
            this.jobRunParams = new Map();
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get methodId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set methodId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 7, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get version() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set version(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get archive() {
        return pb_1.Message.getFieldWithDefault(this, 11, false);
    }
    set archive(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get starccmConfig() {
        return pb_1.Message.getWrapperField(this, StarCCMConfig, 19);
    }
    set starccmConfig(value) {
        pb_1.Message.setWrapperField(this, 19, value);
    }
    get has_starccmConfig() {
        return pb_1.Message.getField(this, 19) != null;
    }
    get ansa() {
        return pb_1.Message.getWrapperField(this, AnsaDir, 20);
    }
    set ansa(value) {
        pb_1.Message.setWrapperField(this, 20, value);
    }
    get has_ansa() {
        return pb_1.Message.getField(this, 20) != null;
    }
    get starccm() {
        return pb_1.Message.getWrapperField(this, StarCCMDir, 21);
    }
    set starccm(value) {
        pb_1.Message.setWrapperField(this, 21, value);
    }
    get has_starccm() {
        return pb_1.Message.getField(this, 21) != null;
    }
    get periscope() {
        return pb_1.Message.getWrapperField(this, PeriscopeDir, 22);
    }
    set periscope(value) {
        pb_1.Message.setWrapperField(this, 22, value);
    }
    get has_periscope() {
        return pb_1.Message.getField(this, 22) != null;
    }
    get selectedSystems() {
        return pb_1.Message.getRepeatedWrapperField(this, SelectedSystem, 23);
    }
    set selectedSystems(value) {
        pb_1.Message.setRepeatedWrapperField(this, 23, value);
    }
    get methodologyStates() {
        return pb_1.Message.getRepeatedWrapperField(this, MethodologyState, 24);
    }
    set methodologyStates(value) {
        pb_1.Message.setRepeatedWrapperField(this, 24, value);
    }
    get systemCodeFiles() {
        return pb_1.Message.getRepeatedWrapperField(this, SystemCode, 25);
    }
    set systemCodeFiles(value) {
        pb_1.Message.setRepeatedWrapperField(this, 25, value);
    }
    get isHardwareOverride() {
        return pb_1.Message.getFieldWithDefault(this, 26, false);
    }
    set isHardwareOverride(value) {
        pb_1.Message.setField(this, 26, value);
    }
    get hardwareOverrides() {
        return pb_1.Message.getWrapperField(this, dependency_1.Hardware, 27);
    }
    set hardwareOverrides(value) {
        pb_1.Message.setWrapperField(this, 27, value);
    }
    get has_hardwareOverrides() {
        return pb_1.Message.getField(this, 27) != null;
    }
    get jobRunParams() {
        return pb_1.Message.getField(this, 28);
    }
    set jobRunParams(value) {
        pb_1.Message.setField(this, 28, value);
    }
    get status() {
        return pb_1.Message.getFieldWithDefault(this, 29, "");
    }
    set status(value) {
        pb_1.Message.setField(this, 29, value);
    }
    get documentMeta() {
        return pb_1.Message.getWrapperField(this, DocumentMeta, 100);
    }
    set documentMeta(value) {
        pb_1.Message.setWrapperField(this, 100, value);
    }
    get has_documentMeta() {
        return pb_1.Message.getField(this, 100) != null;
    }
    static fromObject(data) {
        const message = new MethodologySet({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.methodId != null) {
            message.methodId = data.methodId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.version != null) {
            message.version = data.version;
        }
        if (data.archive != null) {
            message.archive = data.archive;
        }
        if (data.starccmConfig != null) {
            message.starccmConfig = StarCCMConfig.fromObject(data.starccmConfig);
        }
        if (data.ansa != null) {
            message.ansa = AnsaDir.fromObject(data.ansa);
        }
        if (data.starccm != null) {
            message.starccm = StarCCMDir.fromObject(data.starccm);
        }
        if (data.periscope != null) {
            message.periscope = PeriscopeDir.fromObject(data.periscope);
        }
        if (data.selectedSystems != null) {
            message.selectedSystems = data.selectedSystems.map(item => SelectedSystem.fromObject(item));
        }
        if (data.methodologyStates != null) {
            message.methodologyStates = data.methodologyStates.map(item => MethodologyState.fromObject(item));
        }
        if (data.systemCodeFiles != null) {
            message.systemCodeFiles = data.systemCodeFiles.map(item => SystemCode.fromObject(item));
        }
        if (data.isHardwareOverride != null) {
            message.isHardwareOverride = data.isHardwareOverride;
        }
        if (data.hardwareOverrides != null) {
            message.hardwareOverrides = dependency_1.Hardware.fromObject(data.hardwareOverrides);
        }
        if (typeof data.jobRunParams == "object") {
            message.jobRunParams = new Map(Object.entries(data.jobRunParams));
        }
        if (data.status != null) {
            message.status = data.status;
        }
        if (data.documentMeta != null) {
            message.documentMeta = DocumentMeta.fromObject(data.documentMeta);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.methodId != null) {
            data.methodId = this.methodId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.version != null) {
            data.version = this.version;
        }
        if (this.archive != null) {
            data.archive = this.archive;
        }
        if (this.starccmConfig != null) {
            data.starccmConfig = this.starccmConfig.toObject();
        }
        if (this.ansa != null) {
            data.ansa = this.ansa.toObject();
        }
        if (this.starccm != null) {
            data.starccm = this.starccm.toObject();
        }
        if (this.periscope != null) {
            data.periscope = this.periscope.toObject();
        }
        if (this.selectedSystems != null) {
            data.selectedSystems = this.selectedSystems.map((item) => item.toObject());
        }
        if (this.methodologyStates != null) {
            data.methodologyStates = this.methodologyStates.map((item) => item.toObject());
        }
        if (this.systemCodeFiles != null) {
            data.systemCodeFiles = this.systemCodeFiles.map((item) => item.toObject());
        }
        if (this.isHardwareOverride != null) {
            data.isHardwareOverride = this.isHardwareOverride;
        }
        if (this.hardwareOverrides != null) {
            data.hardwareOverrides = this.hardwareOverrides.toObject();
        }
        if (this.jobRunParams != null) {
            data.jobRunParams = (Object.fromEntries)(this.jobRunParams);
        }
        if (this.status != null) {
            data.status = this.status;
        }
        if (this.documentMeta != null) {
            data.documentMeta = this.documentMeta.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.methodId.length)
            writer.writeString(2, this.methodId);
        if (this.name.length)
            writer.writeString(3, this.name);
        if (this.description.length)
            writer.writeString(4, this.description);
        if (this._id.length)
            writer.writeString(5, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(6, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(7, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(8, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(9, this.updateByUser);
        if (this.version.length)
            writer.writeString(10, this.version);
        if (this.archive != false)
            writer.writeBool(11, this.archive);
        if (this.has_starccmConfig)
            writer.writeMessage(19, this.starccmConfig, () => this.starccmConfig.serialize(writer));
        if (this.has_ansa)
            writer.writeMessage(20, this.ansa, () => this.ansa.serialize(writer));
        if (this.has_starccm)
            writer.writeMessage(21, this.starccm, () => this.starccm.serialize(writer));
        if (this.has_periscope)
            writer.writeMessage(22, this.periscope, () => this.periscope.serialize(writer));
        if (this.selectedSystems.length)
            writer.writeRepeatedMessage(23, this.selectedSystems, (item) => item.serialize(writer));
        if (this.methodologyStates.length)
            writer.writeRepeatedMessage(24, this.methodologyStates, (item) => item.serialize(writer));
        if (this.systemCodeFiles.length)
            writer.writeRepeatedMessage(25, this.systemCodeFiles, (item) => item.serialize(writer));
        if (this.isHardwareOverride != false)
            writer.writeBool(26, this.isHardwareOverride);
        if (this.has_hardwareOverrides)
            writer.writeMessage(27, this.hardwareOverrides, () => this.hardwareOverrides.serialize(writer));
        for (const [key, value] of this.jobRunParams) {
            writer.writeMessage(28, this.jobRunParams, () => {
                writer.writeString(1, key);
                writer.writeString(2, value);
            });
        }
        if (this.status.length)
            writer.writeString(29, this.status);
        if (this.has_documentMeta)
            writer.writeMessage(100, this.documentMeta, () => this.documentMeta.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MethodologySet();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.methodId = reader.readString();
                    break;
                case 3:
                    message.name = reader.readString();
                    break;
                case 4:
                    message.description = reader.readString();
                    break;
                case 5:
                    message._id = reader.readString();
                    break;
                case 6:
                    message.timeCreated = reader.readInt64();
                    break;
                case 7:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 8:
                    message.createByUser = reader.readString();
                    break;
                case 9:
                    message.updateByUser = reader.readString();
                    break;
                case 10:
                    message.version = reader.readString();
                    break;
                case 11:
                    message.archive = reader.readBool();
                    break;
                case 19:
                    reader.readMessage(message.starccmConfig, () => message.starccmConfig = StarCCMConfig.deserialize(reader));
                    break;
                case 20:
                    reader.readMessage(message.ansa, () => message.ansa = AnsaDir.deserialize(reader));
                    break;
                case 21:
                    reader.readMessage(message.starccm, () => message.starccm = StarCCMDir.deserialize(reader));
                    break;
                case 22:
                    reader.readMessage(message.periscope, () => message.periscope = PeriscopeDir.deserialize(reader));
                    break;
                case 23:
                    reader.readMessage(message.selectedSystems, () => pb_1.Message.addToRepeatedWrapperField(message, 23, SelectedSystem.deserialize(reader), SelectedSystem));
                    break;
                case 24:
                    reader.readMessage(message.methodologyStates, () => pb_1.Message.addToRepeatedWrapperField(message, 24, MethodologyState.deserialize(reader), MethodologyState));
                    break;
                case 25:
                    reader.readMessage(message.systemCodeFiles, () => pb_1.Message.addToRepeatedWrapperField(message, 25, SystemCode.deserialize(reader), SystemCode));
                    break;
                case 26:
                    message.isHardwareOverride = reader.readBool();
                    break;
                case 27:
                    reader.readMessage(message.hardwareOverrides, () => message.hardwareOverrides = dependency_1.Hardware.deserialize(reader));
                    break;
                case 28:
                    reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.jobRunParams, reader, reader.readString, reader.readString));
                    break;
                case 29:
                    message.status = reader.readString();
                    break;
                case 100:
                    reader.readMessage(message.documentMeta, () => message.documentMeta = DocumentMeta.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return MethodologySet.deserialize(bytes);
    }
}
exports.MethodologySet = MethodologySet;
_MethodologySet_one_of_decls = new WeakMap();
class SystemMessage extends pb_1.Message {
    constructor(data) {
        super();
        _SystemMessage_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [6, 7, 10, 11], __classPrivateFieldGet(this, _SystemMessage_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("subject" in data && data.subject != undefined) {
                this.subject = data.subject;
            }
            if ("content" in data && data.content != undefined) {
                this.content = data.content;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("seriesRecipients" in data && data.seriesRecipients != undefined) {
                this.seriesRecipients = data.seriesRecipients;
            }
            if ("roleRecipients" in data && data.roleRecipients != undefined) {
                this.roleRecipients = data.roleRecipients;
            }
            if ("sendSuccess" in data && data.sendSuccess != undefined) {
                this.sendSuccess = data.sendSuccess;
            }
            if ("messageType" in data && data.messageType != undefined) {
                this.messageType = data.messageType;
            }
            if ("resolvedRecipients" in data && data.resolvedRecipients != undefined) {
                this.resolvedRecipients = data.resolvedRecipients;
            }
            if ("excludedRecipients" in data && data.excludedRecipients != undefined) {
                this.excludedRecipients = data.excludedRecipients;
            }
            if ("createByUserDisplay" in data && data.createByUserDisplay != undefined) {
                this.createByUserDisplay = data.createByUserDisplay;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get subject() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set subject(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get content() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set content(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get seriesRecipients() {
        return pb_1.Message.getFieldWithDefault(this, 6, []);
    }
    set seriesRecipients(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get roleRecipients() {
        return pb_1.Message.getFieldWithDefault(this, 7, []);
    }
    set roleRecipients(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get sendSuccess() {
        return pb_1.Message.getFieldWithDefault(this, 8, false);
    }
    set sendSuccess(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get messageType() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set messageType(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get resolvedRecipients() {
        return pb_1.Message.getFieldWithDefault(this, 10, []);
    }
    set resolvedRecipients(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get excludedRecipients() {
        return pb_1.Message.getFieldWithDefault(this, 11, []);
    }
    set excludedRecipients(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get createByUserDisplay() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set createByUserDisplay(value) {
        pb_1.Message.setField(this, 12, value);
    }
    static fromObject(data) {
        const message = new SystemMessage({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.subject != null) {
            message.subject = data.subject;
        }
        if (data.content != null) {
            message.content = data.content;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.seriesRecipients != null) {
            message.seriesRecipients = data.seriesRecipients;
        }
        if (data.roleRecipients != null) {
            message.roleRecipients = data.roleRecipients;
        }
        if (data.sendSuccess != null) {
            message.sendSuccess = data.sendSuccess;
        }
        if (data.messageType != null) {
            message.messageType = data.messageType;
        }
        if (data.resolvedRecipients != null) {
            message.resolvedRecipients = data.resolvedRecipients;
        }
        if (data.excludedRecipients != null) {
            message.excludedRecipients = data.excludedRecipients;
        }
        if (data.createByUserDisplay != null) {
            message.createByUserDisplay = data.createByUserDisplay;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.subject != null) {
            data.subject = this.subject;
        }
        if (this.content != null) {
            data.content = this.content;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.seriesRecipients != null) {
            data.seriesRecipients = this.seriesRecipients;
        }
        if (this.roleRecipients != null) {
            data.roleRecipients = this.roleRecipients;
        }
        if (this.sendSuccess != null) {
            data.sendSuccess = this.sendSuccess;
        }
        if (this.messageType != null) {
            data.messageType = this.messageType;
        }
        if (this.resolvedRecipients != null) {
            data.resolvedRecipients = this.resolvedRecipients;
        }
        if (this.excludedRecipients != null) {
            data.excludedRecipients = this.excludedRecipients;
        }
        if (this.createByUserDisplay != null) {
            data.createByUserDisplay = this.createByUserDisplay;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.subject.length)
            writer.writeString(2, this.subject);
        if (this.content.length)
            writer.writeString(3, this.content);
        if (this.timeCreated.length)
            writer.writeString(4, this.timeCreated);
        if (this.createByUser.length)
            writer.writeString(5, this.createByUser);
        if (this.seriesRecipients.length)
            writer.writeRepeatedString(6, this.seriesRecipients);
        if (this.roleRecipients.length)
            writer.writeRepeatedString(7, this.roleRecipients);
        if (this.sendSuccess != false)
            writer.writeBool(8, this.sendSuccess);
        if (this.messageType.length)
            writer.writeString(9, this.messageType);
        if (this.resolvedRecipients.length)
            writer.writeRepeatedString(10, this.resolvedRecipients);
        if (this.excludedRecipients.length)
            writer.writeRepeatedString(11, this.excludedRecipients);
        if (this.createByUserDisplay.length)
            writer.writeString(12, this.createByUserDisplay);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SystemMessage();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.subject = reader.readString();
                    break;
                case 3:
                    message.content = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readString();
                    break;
                case 5:
                    message.createByUser = reader.readString();
                    break;
                case 6:
                    pb_1.Message.addToRepeatedField(message, 6, reader.readString());
                    break;
                case 7:
                    pb_1.Message.addToRepeatedField(message, 7, reader.readString());
                    break;
                case 8:
                    message.sendSuccess = reader.readBool();
                    break;
                case 9:
                    message.messageType = reader.readString();
                    break;
                case 10:
                    pb_1.Message.addToRepeatedField(message, 10, reader.readString());
                    break;
                case 11:
                    pb_1.Message.addToRepeatedField(message, 11, reader.readString());
                    break;
                case 12:
                    message.createByUserDisplay = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SystemMessage.deserialize(bytes);
    }
}
exports.SystemMessage = SystemMessage;
_SystemMessage_one_of_decls = new WeakMap();
class SystemCode extends pb_1.Message {
    constructor(data) {
        super();
        _SystemCode_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _SystemCode_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("fileName" in data && data.fileName != undefined) {
                this.fileName = data.fileName;
            }
            if ("systemType" in data && data.systemType != undefined) {
                this.systemType = data.systemType;
            }
            if ("fileRef" in data && data.fileRef != undefined) {
                this.fileRef = data.fileRef;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get fileName() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set fileName(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get systemType() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set systemType(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get fileRef() {
        return pb_1.Message.getWrapperField(this, CFDFile, 5);
    }
    set fileRef(value) {
        pb_1.Message.setWrapperField(this, 5, value);
    }
    get has_fileRef() {
        return pb_1.Message.getField(this, 5) != null;
    }
    static fromObject(data) {
        const message = new SystemCode({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.fileName != null) {
            message.fileName = data.fileName;
        }
        if (data.systemType != null) {
            message.systemType = data.systemType;
        }
        if (data.fileRef != null) {
            message.fileRef = CFDFile.fromObject(data.fileRef);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.fileName != null) {
            data.fileName = this.fileName;
        }
        if (this.systemType != null) {
            data.systemType = this.systemType;
        }
        if (this.fileRef != null) {
            data.fileRef = this.fileRef.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.description.length)
            writer.writeString(2, this.description);
        if (this.fileName.length)
            writer.writeString(3, this.fileName);
        if (this.systemType.length)
            writer.writeString(4, this.systemType);
        if (this.has_fileRef)
            writer.writeMessage(5, this.fileRef, () => this.fileRef.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SystemCode();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.description = reader.readString();
                    break;
                case 3:
                    message.fileName = reader.readString();
                    break;
                case 4:
                    message.systemType = reader.readString();
                    break;
                case 5:
                    reader.readMessage(message.fileRef, () => message.fileRef = CFDFile.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SystemCode.deserialize(bytes);
    }
}
exports.SystemCode = SystemCode;
_SystemCode_one_of_decls = new WeakMap();
class WingState extends pb_1.Message {
    constructor(data) {
        super();
        _WingState_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], __classPrivateFieldGet(this, _WingState_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("drs" in data && data.drs != undefined) {
                this.drs = data.drs;
            }
            if ("fwState" in data && data.fwState != undefined) {
                this.fwState = data.fwState;
            }
            if ("location" in data && data.location != undefined) {
                this.location = data.location;
            }
            if ("isSwappablePart" in data && data.isSwappablePart != undefined) {
                this.isSwappablePart = data.isSwappablePart;
            }
            if ("cadPartNos" in data && data.cadPartNos != undefined) {
                this.cadPartNos = data.cadPartNos;
            }
        }
    }
    get drs() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set drs(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get fwState() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set fwState(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get location() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set location(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get isSwappablePart() {
        return pb_1.Message.getFieldWithDefault(this, 4, false);
    }
    set isSwappablePart(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get cadPartNos() {
        return pb_1.Message.getRepeatedWrapperField(this, Part, 5);
    }
    set cadPartNos(value) {
        pb_1.Message.setRepeatedWrapperField(this, 5, value);
    }
    static fromObject(data) {
        const message = new WingState({});
        if (data.drs != null) {
            message.drs = data.drs;
        }
        if (data.fwState != null) {
            message.fwState = data.fwState;
        }
        if (data.location != null) {
            message.location = data.location;
        }
        if (data.isSwappablePart != null) {
            message.isSwappablePart = data.isSwappablePart;
        }
        if (data.cadPartNos != null) {
            message.cadPartNos = data.cadPartNos.map(item => Part.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.drs != null) {
            data.drs = this.drs;
        }
        if (this.fwState != null) {
            data.fwState = this.fwState;
        }
        if (this.location != null) {
            data.location = this.location;
        }
        if (this.isSwappablePart != null) {
            data.isSwappablePart = this.isSwappablePart;
        }
        if (this.cadPartNos != null) {
            data.cadPartNos = this.cadPartNos.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.drs != 0)
            writer.writeFloat(1, this.drs);
        if (this.fwState != 0)
            writer.writeFloat(2, this.fwState);
        if (this.location.length)
            writer.writeString(3, this.location);
        if (this.isSwappablePart != false)
            writer.writeBool(4, this.isSwappablePart);
        if (this.cadPartNos.length)
            writer.writeRepeatedMessage(5, this.cadPartNos, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WingState();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.drs = reader.readFloat();
                    break;
                case 2:
                    message.fwState = reader.readFloat();
                    break;
                case 3:
                    message.location = reader.readString();
                    break;
                case 4:
                    message.isSwappablePart = reader.readBool();
                    break;
                case 5:
                    reader.readMessage(message.cadPartNos, () => pb_1.Message.addToRepeatedWrapperField(message, 5, Part.deserialize(reader), Part));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return WingState.deserialize(bytes);
    }
}
exports.WingState = WingState;
_WingState_one_of_decls = new WeakMap();
class AnsaDir extends pb_1.Message {
    constructor(data) {
        super();
        _AnsaDir_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _AnsaDir_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("meshTemplate" in data && data.meshTemplate != undefined) {
                this.meshTemplate = data.meshTemplate;
            }
            if ("ansaVersionRescale" in data && data.ansaVersionRescale != undefined) {
                this.ansaVersionRescale = data.ansaVersionRescale;
            }
            if ("codeDir" in data && data.codeDir != undefined) {
                this.codeDir = data.codeDir;
            }
            if ("steeringTable" in data && data.steeringTable != undefined) {
                this.steeringTable = data.steeringTable;
            }
            if ("carConfig" in data && data.carConfig != undefined) {
                this.carConfig = data.carConfig;
            }
            if ("template" in data && data.template != undefined) {
                this.template = data.template;
            }
            if ("code" in data && data.code != undefined) {
                this.code = data.code;
            }
            if ("cmd" in data && data.cmd != undefined) {
                this.cmd = data.cmd;
            }
        }
    }
    get meshTemplate() {
        return pb_1.Message.getWrapperField(this, CFDFile, 1);
    }
    set meshTemplate(value) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_meshTemplate() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get ansaVersionRescale() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set ansaVersionRescale(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get codeDir() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set codeDir(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get steeringTable() {
        return pb_1.Message.getWrapperField(this, SteeringTable, 18);
    }
    set steeringTable(value) {
        pb_1.Message.setWrapperField(this, 18, value);
    }
    get has_steeringTable() {
        return pb_1.Message.getField(this, 18) != null;
    }
    get carConfig() {
        return pb_1.Message.getWrapperField(this, CarConfig, 19);
    }
    set carConfig(value) {
        pb_1.Message.setWrapperField(this, 19, value);
    }
    get has_carConfig() {
        return pb_1.Message.getField(this, 19) != null;
    }
    get template() {
        return pb_1.Message.getWrapperField(this, CFDFile, 20);
    }
    set template(value) {
        pb_1.Message.setWrapperField(this, 20, value);
    }
    get has_template() {
        return pb_1.Message.getField(this, 20) != null;
    }
    get code() {
        return pb_1.Message.getWrapperField(this, CodeDir, 21);
    }
    set code(value) {
        pb_1.Message.setWrapperField(this, 21, value);
    }
    get has_code() {
        return pb_1.Message.getField(this, 21) != null;
    }
    get cmd() {
        return pb_1.Message.getWrapperField(this, CmdDir, 22);
    }
    set cmd(value) {
        pb_1.Message.setWrapperField(this, 22, value);
    }
    get has_cmd() {
        return pb_1.Message.getField(this, 22) != null;
    }
    static fromObject(data) {
        const message = new AnsaDir({});
        if (data.meshTemplate != null) {
            message.meshTemplate = CFDFile.fromObject(data.meshTemplate);
        }
        if (data.ansaVersionRescale != null) {
            message.ansaVersionRescale = data.ansaVersionRescale;
        }
        if (data.codeDir != null) {
            message.codeDir = data.codeDir;
        }
        if (data.steeringTable != null) {
            message.steeringTable = SteeringTable.fromObject(data.steeringTable);
        }
        if (data.carConfig != null) {
            message.carConfig = CarConfig.fromObject(data.carConfig);
        }
        if (data.template != null) {
            message.template = CFDFile.fromObject(data.template);
        }
        if (data.code != null) {
            message.code = CodeDir.fromObject(data.code);
        }
        if (data.cmd != null) {
            message.cmd = CmdDir.fromObject(data.cmd);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.meshTemplate != null) {
            data.meshTemplate = this.meshTemplate.toObject();
        }
        if (this.ansaVersionRescale != null) {
            data.ansaVersionRescale = this.ansaVersionRescale;
        }
        if (this.codeDir != null) {
            data.codeDir = this.codeDir;
        }
        if (this.steeringTable != null) {
            data.steeringTable = this.steeringTable.toObject();
        }
        if (this.carConfig != null) {
            data.carConfig = this.carConfig.toObject();
        }
        if (this.template != null) {
            data.template = this.template.toObject();
        }
        if (this.code != null) {
            data.code = this.code.toObject();
        }
        if (this.cmd != null) {
            data.cmd = this.cmd.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_meshTemplate)
            writer.writeMessage(1, this.meshTemplate, () => this.meshTemplate.serialize(writer));
        if (this.ansaVersionRescale.length)
            writer.writeString(2, this.ansaVersionRescale);
        if (this.codeDir.length)
            writer.writeString(3, this.codeDir);
        if (this.has_steeringTable)
            writer.writeMessage(18, this.steeringTable, () => this.steeringTable.serialize(writer));
        if (this.has_carConfig)
            writer.writeMessage(19, this.carConfig, () => this.carConfig.serialize(writer));
        if (this.has_template)
            writer.writeMessage(20, this.template, () => this.template.serialize(writer));
        if (this.has_code)
            writer.writeMessage(21, this.code, () => this.code.serialize(writer));
        if (this.has_cmd)
            writer.writeMessage(22, this.cmd, () => this.cmd.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AnsaDir();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.meshTemplate, () => message.meshTemplate = CFDFile.deserialize(reader));
                    break;
                case 2:
                    message.ansaVersionRescale = reader.readString();
                    break;
                case 3:
                    message.codeDir = reader.readString();
                    break;
                case 18:
                    reader.readMessage(message.steeringTable, () => message.steeringTable = SteeringTable.deserialize(reader));
                    break;
                case 19:
                    reader.readMessage(message.carConfig, () => message.carConfig = CarConfig.deserialize(reader));
                    break;
                case 20:
                    reader.readMessage(message.template, () => message.template = CFDFile.deserialize(reader));
                    break;
                case 21:
                    reader.readMessage(message.code, () => message.code = CodeDir.deserialize(reader));
                    break;
                case 22:
                    reader.readMessage(message.cmd, () => message.cmd = CmdDir.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return AnsaDir.deserialize(bytes);
    }
}
exports.AnsaDir = AnsaDir;
_AnsaDir_one_of_decls = new WeakMap();
class CarConfig extends pb_1.Message {
    constructor(data) {
        super();
        _CarConfig_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [20, 30], __classPrivateFieldGet(this, _CarConfig_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("cgCoord" in data && data.cgCoord != undefined) {
                this.cgCoord = data.cgCoord;
            }
            if ("slipCoord" in data && data.slipCoord != undefined) {
                this.slipCoord = data.slipCoord;
            }
            if ("fileRef" in data && data.fileRef != undefined) {
                this.fileRef = data.fileRef;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get cgCoord() {
        return pb_1.Message.getFieldWithDefault(this, 20, []);
    }
    set cgCoord(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get slipCoord() {
        return pb_1.Message.getFieldWithDefault(this, 30, []);
    }
    set slipCoord(value) {
        pb_1.Message.setField(this, 30, value);
    }
    get fileRef() {
        return pb_1.Message.getWrapperField(this, CFDFile, 40);
    }
    set fileRef(value) {
        pb_1.Message.setWrapperField(this, 40, value);
    }
    get has_fileRef() {
        return pb_1.Message.getField(this, 40) != null;
    }
    static fromObject(data) {
        const message = new CarConfig({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.cgCoord != null) {
            message.cgCoord = data.cgCoord;
        }
        if (data.slipCoord != null) {
            message.slipCoord = data.slipCoord;
        }
        if (data.fileRef != null) {
            message.fileRef = CFDFile.fromObject(data.fileRef);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.cgCoord != null) {
            data.cgCoord = this.cgCoord;
        }
        if (this.slipCoord != null) {
            data.slipCoord = this.slipCoord;
        }
        if (this.fileRef != null) {
            data.fileRef = this.fileRef.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(10, this.name);
        if (this.cgCoord.length)
            writer.writePackedFloat(20, this.cgCoord);
        if (this.slipCoord.length)
            writer.writePackedFloat(30, this.slipCoord);
        if (this.has_fileRef)
            writer.writeMessage(40, this.fileRef, () => this.fileRef.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CarConfig();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 10:
                    message.name = reader.readString();
                    break;
                case 20:
                    message.cgCoord = reader.readPackedFloat();
                    break;
                case 30:
                    message.slipCoord = reader.readPackedFloat();
                    break;
                case 40:
                    reader.readMessage(message.fileRef, () => message.fileRef = CFDFile.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return CarConfig.deserialize(bytes);
    }
}
exports.CarConfig = CarConfig;
_CarConfig_one_of_decls = new WeakMap();
class SteeringTable extends pb_1.Message {
    constructor(data) {
        super();
        _SteeringTable_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _SteeringTable_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("fileRef" in data && data.fileRef != undefined) {
                this.fileRef = data.fileRef;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get fileRef() {
        return pb_1.Message.getWrapperField(this, CFDFile, 40);
    }
    set fileRef(value) {
        pb_1.Message.setWrapperField(this, 40, value);
    }
    get has_fileRef() {
        return pb_1.Message.getField(this, 40) != null;
    }
    static fromObject(data) {
        const message = new SteeringTable({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.fileRef != null) {
            message.fileRef = CFDFile.fromObject(data.fileRef);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.fileRef != null) {
            data.fileRef = this.fileRef.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(10, this.name);
        if (this.has_fileRef)
            writer.writeMessage(40, this.fileRef, () => this.fileRef.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SteeringTable();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 10:
                    message.name = reader.readString();
                    break;
                case 40:
                    reader.readMessage(message.fileRef, () => message.fileRef = CFDFile.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return SteeringTable.deserialize(bytes);
    }
}
exports.SteeringTable = SteeringTable;
_SteeringTable_one_of_decls = new WeakMap();
class CodeDir extends pb_1.Message {
    constructor(data) {
        super();
        _CodeDir_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _CodeDir_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("path" in data && data.path != undefined) {
                this.path = data.path;
            }
        }
    }
    get path() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set path(value) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data) {
        const message = new CodeDir({});
        if (data.path != null) {
            message.path = data.path;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.path != null) {
            data.path = this.path;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.path.length)
            writer.writeString(1, this.path);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CodeDir();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.path = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return CodeDir.deserialize(bytes);
    }
}
exports.CodeDir = CodeDir;
_CodeDir_one_of_decls = new WeakMap();
class CmdDir extends pb_1.Message {
    constructor(data) {
        super();
        _CmdDir_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _CmdDir_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("path" in data && data.path != undefined) {
                this.path = data.path;
            }
        }
    }
    get path() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set path(value) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data) {
        const message = new CmdDir({});
        if (data.path != null) {
            message.path = data.path;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.path != null) {
            data.path = this.path;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.path.length)
            writer.writeString(1, this.path);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CmdDir();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.path = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return CmdDir.deserialize(bytes);
    }
}
exports.CmdDir = CmdDir;
_CmdDir_one_of_decls = new WeakMap();
class CFDFile extends pb_1.Message {
    constructor(data) {
        super();
        _CFDFile_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _CFDFile_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("fileId" in data && data.fileId != undefined) {
                this.fileId = data.fileId;
            }
            if ("file" in data && data.file != undefined) {
                this.file = data.file;
            }
            if ("path" in data && data.path != undefined) {
                this.path = data.path;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("archive" in data && data.archive != undefined) {
                this.archive = data.archive;
            }
            if ("system" in data && data.system != undefined) {
                this.system = data.system;
            }
            if ("version" in data && data.version != undefined) {
                this.version = data.version;
            }
            if ("fileType" in data && data.fileType != undefined) {
                this.fileType = data.fileType;
            }
            if ("rootType" in data && data.rootType != undefined) {
                this.rootType = data.rootType;
            }
            if ("partRef" in data && data.partRef != undefined) {
                this.partRef = data.partRef;
            }
            if ("storageAcct" in data && data.storageAcct != undefined) {
                this.storageAcct = data.storageAcct;
            }
            if ("containerName" in data && data.containerName != undefined) {
                this.containerName = data.containerName;
            }
            if ("branchName" in data && data.branchName != undefined) {
                this.branchName = data.branchName;
            }
            if ("commitId" in data && data.commitId != undefined) {
                this.commitId = data.commitId;
            }
            if ("vendorCompatibilityVersion" in data && data.vendorCompatibilityVersion != undefined) {
                this.vendorCompatibilityVersion = data.vendorCompatibilityVersion;
            }
            if ("documentMeta" in data && data.documentMeta != undefined) {
                this.documentMeta = data.documentMeta;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get fileId() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set fileId(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get file() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set file(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get path() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set path(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 7, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get archive() {
        return pb_1.Message.getFieldWithDefault(this, 11, false);
    }
    set archive(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get system() {
        return pb_1.Message.getFieldWithDefault(this, 13, "");
    }
    set system(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get version() {
        return pb_1.Message.getFieldWithDefault(this, 14, "");
    }
    set version(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get fileType() {
        return pb_1.Message.getFieldWithDefault(this, 15, "");
    }
    set fileType(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get rootType() {
        return pb_1.Message.getFieldWithDefault(this, 16, "");
    }
    set rootType(value) {
        pb_1.Message.setField(this, 16, value);
    }
    get partRef() {
        return pb_1.Message.getWrapperField(this, Part, 17);
    }
    set partRef(value) {
        pb_1.Message.setWrapperField(this, 17, value);
    }
    get has_partRef() {
        return pb_1.Message.getField(this, 17) != null;
    }
    get storageAcct() {
        return pb_1.Message.getFieldWithDefault(this, 18, "");
    }
    set storageAcct(value) {
        pb_1.Message.setField(this, 18, value);
    }
    get containerName() {
        return pb_1.Message.getFieldWithDefault(this, 19, "");
    }
    set containerName(value) {
        pb_1.Message.setField(this, 19, value);
    }
    get branchName() {
        return pb_1.Message.getFieldWithDefault(this, 20, "");
    }
    set branchName(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get commitId() {
        return pb_1.Message.getFieldWithDefault(this, 21, "");
    }
    set commitId(value) {
        pb_1.Message.setField(this, 21, value);
    }
    get vendorCompatibilityVersion() {
        return pb_1.Message.getFieldWithDefault(this, 22, "");
    }
    set vendorCompatibilityVersion(value) {
        pb_1.Message.setField(this, 22, value);
    }
    get documentMeta() {
        return pb_1.Message.getWrapperField(this, DocumentMeta, 100);
    }
    set documentMeta(value) {
        pb_1.Message.setWrapperField(this, 100, value);
    }
    get has_documentMeta() {
        return pb_1.Message.getField(this, 100) != null;
    }
    static fromObject(data) {
        const message = new CFDFile({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.fileId != null) {
            message.fileId = data.fileId;
        }
        if (data.file != null) {
            message.file = data.file;
        }
        if (data.path != null) {
            message.path = data.path;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.archive != null) {
            message.archive = data.archive;
        }
        if (data.system != null) {
            message.system = data.system;
        }
        if (data.version != null) {
            message.version = data.version;
        }
        if (data.fileType != null) {
            message.fileType = data.fileType;
        }
        if (data.rootType != null) {
            message.rootType = data.rootType;
        }
        if (data.partRef != null) {
            message.partRef = Part.fromObject(data.partRef);
        }
        if (data.storageAcct != null) {
            message.storageAcct = data.storageAcct;
        }
        if (data.containerName != null) {
            message.containerName = data.containerName;
        }
        if (data.branchName != null) {
            message.branchName = data.branchName;
        }
        if (data.commitId != null) {
            message.commitId = data.commitId;
        }
        if (data.vendorCompatibilityVersion != null) {
            message.vendorCompatibilityVersion = data.vendorCompatibilityVersion;
        }
        if (data.documentMeta != null) {
            message.documentMeta = DocumentMeta.fromObject(data.documentMeta);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.fileId != null) {
            data.fileId = this.fileId;
        }
        if (this.file != null) {
            data.file = this.file;
        }
        if (this.path != null) {
            data.path = this.path;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.archive != null) {
            data.archive = this.archive;
        }
        if (this.system != null) {
            data.system = this.system;
        }
        if (this.version != null) {
            data.version = this.version;
        }
        if (this.fileType != null) {
            data.fileType = this.fileType;
        }
        if (this.rootType != null) {
            data.rootType = this.rootType;
        }
        if (this.partRef != null) {
            data.partRef = this.partRef.toObject();
        }
        if (this.storageAcct != null) {
            data.storageAcct = this.storageAcct;
        }
        if (this.containerName != null) {
            data.containerName = this.containerName;
        }
        if (this.branchName != null) {
            data.branchName = this.branchName;
        }
        if (this.commitId != null) {
            data.commitId = this.commitId;
        }
        if (this.vendorCompatibilityVersion != null) {
            data.vendorCompatibilityVersion = this.vendorCompatibilityVersion;
        }
        if (this.documentMeta != null) {
            data.documentMeta = this.documentMeta.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.fileId.length)
            writer.writeString(3, this.fileId);
        if (this.file.length)
            writer.writeString(4, this.file);
        if (this.path.length)
            writer.writeString(5, this.path);
        if (this.timeCreated != 0)
            writer.writeInt64(6, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(7, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(8, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(9, this.updateByUser);
        if (this.description.length)
            writer.writeString(10, this.description);
        if (this.archive != false)
            writer.writeBool(11, this.archive);
        if (this.system.length)
            writer.writeString(13, this.system);
        if (this.version.length)
            writer.writeString(14, this.version);
        if (this.fileType.length)
            writer.writeString(15, this.fileType);
        if (this.rootType.length)
            writer.writeString(16, this.rootType);
        if (this.has_partRef)
            writer.writeMessage(17, this.partRef, () => this.partRef.serialize(writer));
        if (this.storageAcct.length)
            writer.writeString(18, this.storageAcct);
        if (this.containerName.length)
            writer.writeString(19, this.containerName);
        if (this.branchName.length)
            writer.writeString(20, this.branchName);
        if (this.commitId.length)
            writer.writeString(21, this.commitId);
        if (this.vendorCompatibilityVersion.length)
            writer.writeString(22, this.vendorCompatibilityVersion);
        if (this.has_documentMeta)
            writer.writeMessage(100, this.documentMeta, () => this.documentMeta.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CFDFile();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.fileId = reader.readString();
                    break;
                case 4:
                    message.file = reader.readString();
                    break;
                case 5:
                    message.path = reader.readString();
                    break;
                case 6:
                    message.timeCreated = reader.readInt64();
                    break;
                case 7:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 8:
                    message.createByUser = reader.readString();
                    break;
                case 9:
                    message.updateByUser = reader.readString();
                    break;
                case 10:
                    message.description = reader.readString();
                    break;
                case 11:
                    message.archive = reader.readBool();
                    break;
                case 13:
                    message.system = reader.readString();
                    break;
                case 14:
                    message.version = reader.readString();
                    break;
                case 15:
                    message.fileType = reader.readString();
                    break;
                case 16:
                    message.rootType = reader.readString();
                    break;
                case 17:
                    reader.readMessage(message.partRef, () => message.partRef = Part.deserialize(reader));
                    break;
                case 18:
                    message.storageAcct = reader.readString();
                    break;
                case 19:
                    message.containerName = reader.readString();
                    break;
                case 20:
                    message.branchName = reader.readString();
                    break;
                case 21:
                    message.commitId = reader.readString();
                    break;
                case 22:
                    message.vendorCompatibilityVersion = reader.readString();
                    break;
                case 100:
                    reader.readMessage(message.documentMeta, () => message.documentMeta = DocumentMeta.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return CFDFile.deserialize(bytes);
    }
}
exports.CFDFile = CFDFile;
_CFDFile_one_of_decls = new WeakMap();
class Part extends pb_1.Message {
    constructor(data) {
        super();
        _Part_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Part_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("partId" in data && data.partId != undefined) {
                this.partId = data.partId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("fromWorkflowSubmissionId" in data && data.fromWorkflowSubmissionId != undefined) {
                this.fromWorkflowSubmissionId = data.fromWorkflowSubmissionId;
            }
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
            if ("replaced" in data && data.replaced != undefined) {
                this.replaced = data.replaced;
            }
            if ("plmId" in data && data.plmId != undefined) {
                this.plmId = data.plmId;
            }
            if ("pid" in data && data.pid != undefined) {
                this.pid = data.pid;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get partId() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set partId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get fromWorkflowSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set fromWorkflowSubmissionId(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set type(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get replaced() {
        return pb_1.Message.getFieldWithDefault(this, 11, false);
    }
    set replaced(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get plmId() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set plmId(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get pid() {
        return pb_1.Message.getFieldWithDefault(this, 13, "");
    }
    set pid(value) {
        pb_1.Message.setField(this, 13, value);
    }
    static fromObject(data) {
        const message = new Part({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.partId != null) {
            message.partId = data.partId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.fromWorkflowSubmissionId != null) {
            message.fromWorkflowSubmissionId = data.fromWorkflowSubmissionId;
        }
        if (data.type != null) {
            message.type = data.type;
        }
        if (data.replaced != null) {
            message.replaced = data.replaced;
        }
        if (data.plmId != null) {
            message.plmId = data.plmId;
        }
        if (data.pid != null) {
            message.pid = data.pid;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.partId != null) {
            data.partId = this.partId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.fromWorkflowSubmissionId != null) {
            data.fromWorkflowSubmissionId = this.fromWorkflowSubmissionId;
        }
        if (this.type != null) {
            data.type = this.type;
        }
        if (this.replaced != null) {
            data.replaced = this.replaced;
        }
        if (this.plmId != null) {
            data.plmId = this.plmId;
        }
        if (this.pid != null) {
            data.pid = this.pid;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.partId != 0)
            writer.writeInt32(2, this.partId);
        if (this._id.length)
            writer.writeString(3, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(4, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(5, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(6, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(7, this.updateByUser);
        if (this.name.length)
            writer.writeString(8, this.name);
        if (this.fromWorkflowSubmissionId.length)
            writer.writeString(9, this.fromWorkflowSubmissionId);
        if (this.type.length)
            writer.writeString(10, this.type);
        if (this.replaced != false)
            writer.writeBool(11, this.replaced);
        if (this.plmId.length)
            writer.writeString(12, this.plmId);
        if (this.pid.length)
            writer.writeString(13, this.pid);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Part();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.partId = reader.readInt32();
                    break;
                case 3:
                    message._id = reader.readString();
                    break;
                case 4:
                    message.timeCreated = reader.readInt64();
                    break;
                case 5:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 6:
                    message.createByUser = reader.readString();
                    break;
                case 7:
                    message.updateByUser = reader.readString();
                    break;
                case 8:
                    message.name = reader.readString();
                    break;
                case 9:
                    message.fromWorkflowSubmissionId = reader.readString();
                    break;
                case 10:
                    message.type = reader.readString();
                    break;
                case 11:
                    message.replaced = reader.readBool();
                    break;
                case 12:
                    message.plmId = reader.readString();
                    break;
                case 13:
                    message.pid = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Part.deserialize(bytes);
    }
}
exports.Part = Part;
_Part_one_of_decls = new WeakMap();
class StarCCMDir extends pb_1.Message {
    constructor(data) {
        super();
        _StarCCMDir_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _StarCCMDir_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("codeDir" in data && data.codeDir != undefined) {
                this.codeDir = data.codeDir;
            }
            if ("codeSetupPath" in data && data.codeSetupPath != undefined) {
                this.codeSetupPath = data.codeSetupPath;
            }
            if ("codeSolvePath" in data && data.codeSolvePath != undefined) {
                this.codeSolvePath = data.codeSolvePath;
            }
            if ("starVersionServer" in data && data.starVersionServer != undefined) {
                this.starVersionServer = data.starVersionServer;
            }
            if ("starVersionRescale" in data && data.starVersionRescale != undefined) {
                this.starVersionRescale = data.starVersionRescale;
            }
            if ("template" in data && data.template != undefined) {
                this.template = data.template;
            }
            if ("configJson" in data && data.configJson != undefined) {
                this.configJson = data.configJson;
            }
            if ("codeFileName" in data && data.codeFileName != undefined) {
                this.codeFileName = data.codeFileName;
            }
            if ("config" in data && data.config != undefined) {
                this.config = data.config;
            }
            if ("code" in data && data.code != undefined) {
                this.code = data.code;
            }
            if ("cmd" in data && data.cmd != undefined) {
                this.cmd = data.cmd;
            }
            if ("macro" in data && data.macro != undefined) {
                this.macro = data.macro;
            }
        }
    }
    get codeDir() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set codeDir(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get codeSetupPath() {
        return pb_1.Message.getWrapperField(this, CFDFile, 2);
    }
    set codeSetupPath(value) {
        pb_1.Message.setWrapperField(this, 2, value);
    }
    get has_codeSetupPath() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get codeSolvePath() {
        return pb_1.Message.getWrapperField(this, CFDFile, 3);
    }
    set codeSolvePath(value) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_codeSolvePath() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get starVersionServer() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set starVersionServer(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get starVersionRescale() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set starVersionRescale(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get template() {
        return pb_1.Message.getWrapperField(this, CFDFile, 6);
    }
    set template(value) {
        pb_1.Message.setWrapperField(this, 6, value);
    }
    get has_template() {
        return pb_1.Message.getField(this, 6) != null;
    }
    get configJson() {
        return pb_1.Message.getWrapperField(this, CFDFile, 7);
    }
    set configJson(value) {
        pb_1.Message.setWrapperField(this, 7, value);
    }
    get has_configJson() {
        return pb_1.Message.getField(this, 7) != null;
    }
    get codeFileName() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set codeFileName(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get config() {
        return pb_1.Message.getWrapperField(this, CFDFile, 12);
    }
    set config(value) {
        pb_1.Message.setWrapperField(this, 12, value);
    }
    get has_config() {
        return pb_1.Message.getField(this, 12) != null;
    }
    get code() {
        return pb_1.Message.getWrapperField(this, CodeDir, 13);
    }
    set code(value) {
        pb_1.Message.setWrapperField(this, 13, value);
    }
    get has_code() {
        return pb_1.Message.getField(this, 13) != null;
    }
    get cmd() {
        return pb_1.Message.getWrapperField(this, CmdDir, 14);
    }
    set cmd(value) {
        pb_1.Message.setWrapperField(this, 14, value);
    }
    get has_cmd() {
        return pb_1.Message.getField(this, 14) != null;
    }
    get macro() {
        return pb_1.Message.getWrapperField(this, CFDFile, 15);
    }
    set macro(value) {
        pb_1.Message.setWrapperField(this, 15, value);
    }
    get has_macro() {
        return pb_1.Message.getField(this, 15) != null;
    }
    static fromObject(data) {
        const message = new StarCCMDir({});
        if (data.codeDir != null) {
            message.codeDir = data.codeDir;
        }
        if (data.codeSetupPath != null) {
            message.codeSetupPath = CFDFile.fromObject(data.codeSetupPath);
        }
        if (data.codeSolvePath != null) {
            message.codeSolvePath = CFDFile.fromObject(data.codeSolvePath);
        }
        if (data.starVersionServer != null) {
            message.starVersionServer = data.starVersionServer;
        }
        if (data.starVersionRescale != null) {
            message.starVersionRescale = data.starVersionRescale;
        }
        if (data.template != null) {
            message.template = CFDFile.fromObject(data.template);
        }
        if (data.configJson != null) {
            message.configJson = CFDFile.fromObject(data.configJson);
        }
        if (data.codeFileName != null) {
            message.codeFileName = data.codeFileName;
        }
        if (data.config != null) {
            message.config = CFDFile.fromObject(data.config);
        }
        if (data.code != null) {
            message.code = CodeDir.fromObject(data.code);
        }
        if (data.cmd != null) {
            message.cmd = CmdDir.fromObject(data.cmd);
        }
        if (data.macro != null) {
            message.macro = CFDFile.fromObject(data.macro);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.codeDir != null) {
            data.codeDir = this.codeDir;
        }
        if (this.codeSetupPath != null) {
            data.codeSetupPath = this.codeSetupPath.toObject();
        }
        if (this.codeSolvePath != null) {
            data.codeSolvePath = this.codeSolvePath.toObject();
        }
        if (this.starVersionServer != null) {
            data.starVersionServer = this.starVersionServer;
        }
        if (this.starVersionRescale != null) {
            data.starVersionRescale = this.starVersionRescale;
        }
        if (this.template != null) {
            data.template = this.template.toObject();
        }
        if (this.configJson != null) {
            data.configJson = this.configJson.toObject();
        }
        if (this.codeFileName != null) {
            data.codeFileName = this.codeFileName;
        }
        if (this.config != null) {
            data.config = this.config.toObject();
        }
        if (this.code != null) {
            data.code = this.code.toObject();
        }
        if (this.cmd != null) {
            data.cmd = this.cmd.toObject();
        }
        if (this.macro != null) {
            data.macro = this.macro.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.codeDir.length)
            writer.writeString(1, this.codeDir);
        if (this.has_codeSetupPath)
            writer.writeMessage(2, this.codeSetupPath, () => this.codeSetupPath.serialize(writer));
        if (this.has_codeSolvePath)
            writer.writeMessage(3, this.codeSolvePath, () => this.codeSolvePath.serialize(writer));
        if (this.starVersionServer.length)
            writer.writeString(4, this.starVersionServer);
        if (this.starVersionRescale.length)
            writer.writeString(5, this.starVersionRescale);
        if (this.has_template)
            writer.writeMessage(6, this.template, () => this.template.serialize(writer));
        if (this.has_configJson)
            writer.writeMessage(7, this.configJson, () => this.configJson.serialize(writer));
        if (this.codeFileName.length)
            writer.writeString(11, this.codeFileName);
        if (this.has_config)
            writer.writeMessage(12, this.config, () => this.config.serialize(writer));
        if (this.has_code)
            writer.writeMessage(13, this.code, () => this.code.serialize(writer));
        if (this.has_cmd)
            writer.writeMessage(14, this.cmd, () => this.cmd.serialize(writer));
        if (this.has_macro)
            writer.writeMessage(15, this.macro, () => this.macro.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StarCCMDir();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.codeDir = reader.readString();
                    break;
                case 2:
                    reader.readMessage(message.codeSetupPath, () => message.codeSetupPath = CFDFile.deserialize(reader));
                    break;
                case 3:
                    reader.readMessage(message.codeSolvePath, () => message.codeSolvePath = CFDFile.deserialize(reader));
                    break;
                case 4:
                    message.starVersionServer = reader.readString();
                    break;
                case 5:
                    message.starVersionRescale = reader.readString();
                    break;
                case 6:
                    reader.readMessage(message.template, () => message.template = CFDFile.deserialize(reader));
                    break;
                case 7:
                    reader.readMessage(message.configJson, () => message.configJson = CFDFile.deserialize(reader));
                    break;
                case 11:
                    message.codeFileName = reader.readString();
                    break;
                case 12:
                    reader.readMessage(message.config, () => message.config = CFDFile.deserialize(reader));
                    break;
                case 13:
                    reader.readMessage(message.code, () => message.code = CodeDir.deserialize(reader));
                    break;
                case 14:
                    reader.readMessage(message.cmd, () => message.cmd = CmdDir.deserialize(reader));
                    break;
                case 15:
                    reader.readMessage(message.macro, () => message.macro = CFDFile.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return StarCCMDir.deserialize(bytes);
    }
}
exports.StarCCMDir = StarCCMDir;
_StarCCMDir_one_of_decls = new WeakMap();
class PeriscopeDir extends pb_1.Message {
    constructor(data) {
        super();
        _PeriscopeDir_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _PeriscopeDir_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("full" in data && data.full != undefined) {
                this.full = data.full;
            }
            if ("half" in data && data.half != undefined) {
                this.half = data.half;
            }
            if ("cmd" in data && data.cmd != undefined) {
                this.cmd = data.cmd;
            }
        }
    }
    get full() {
        return pb_1.Message.getWrapperField(this, CFDFile, 10);
    }
    set full(value) {
        pb_1.Message.setWrapperField(this, 10, value);
    }
    get has_full() {
        return pb_1.Message.getField(this, 10) != null;
    }
    get half() {
        return pb_1.Message.getWrapperField(this, CFDFile, 11);
    }
    set half(value) {
        pb_1.Message.setWrapperField(this, 11, value);
    }
    get has_half() {
        return pb_1.Message.getField(this, 11) != null;
    }
    get cmd() {
        return pb_1.Message.getWrapperField(this, CmdDir, 14);
    }
    set cmd(value) {
        pb_1.Message.setWrapperField(this, 14, value);
    }
    get has_cmd() {
        return pb_1.Message.getField(this, 14) != null;
    }
    static fromObject(data) {
        const message = new PeriscopeDir({});
        if (data.full != null) {
            message.full = CFDFile.fromObject(data.full);
        }
        if (data.half != null) {
            message.half = CFDFile.fromObject(data.half);
        }
        if (data.cmd != null) {
            message.cmd = CmdDir.fromObject(data.cmd);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.full != null) {
            data.full = this.full.toObject();
        }
        if (this.half != null) {
            data.half = this.half.toObject();
        }
        if (this.cmd != null) {
            data.cmd = this.cmd.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_full)
            writer.writeMessage(10, this.full, () => this.full.serialize(writer));
        if (this.has_half)
            writer.writeMessage(11, this.half, () => this.half.serialize(writer));
        if (this.has_cmd)
            writer.writeMessage(14, this.cmd, () => this.cmd.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PeriscopeDir();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 10:
                    reader.readMessage(message.full, () => message.full = CFDFile.deserialize(reader));
                    break;
                case 11:
                    reader.readMessage(message.half, () => message.half = CFDFile.deserialize(reader));
                    break;
                case 14:
                    reader.readMessage(message.cmd, () => message.cmd = CmdDir.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return PeriscopeDir.deserialize(bytes);
    }
}
exports.PeriscopeDir = PeriscopeDir;
_PeriscopeDir_one_of_decls = new WeakMap();
class TyreSet extends pb_1.Message {
    constructor(data) {
        super();
        _TyreSet_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [12], __classPrivateFieldGet(this, _TyreSet_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("tyreId" in data && data.tyreId != undefined) {
                this.tyreId = data.tyreId;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("statesJSON" in data && data.statesJSON != undefined) {
                this.statesJSON = data.statesJSON;
            }
            if ("tyreStates" in data && data.tyreStates != undefined) {
                this.tyreStates = data.tyreStates;
            }
            if ("documentMeta" in data && data.documentMeta != undefined) {
                this.documentMeta = data.documentMeta;
            }
        }
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get tyreId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set tyreId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get statesJSON() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set statesJSON(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get tyreStates() {
        return pb_1.Message.getRepeatedWrapperField(this, TyreState, 12);
    }
    set tyreStates(value) {
        pb_1.Message.setRepeatedWrapperField(this, 12, value);
    }
    get documentMeta() {
        return pb_1.Message.getWrapperField(this, DocumentMeta, 100);
    }
    set documentMeta(value) {
        pb_1.Message.setWrapperField(this, 100, value);
    }
    get has_documentMeta() {
        return pb_1.Message.getField(this, 100) != null;
    }
    static fromObject(data) {
        const message = new TyreSet({});
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.tyreId != null) {
            message.tyreId = data.tyreId;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.statesJSON != null) {
            message.statesJSON = data.statesJSON;
        }
        if (data.tyreStates != null) {
            message.tyreStates = data.tyreStates.map(item => TyreState.fromObject(item));
        }
        if (data.documentMeta != null) {
            message.documentMeta = DocumentMeta.fromObject(data.documentMeta);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.tyreId != null) {
            data.tyreId = this.tyreId;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.statesJSON != null) {
            data.statesJSON = this.statesJSON;
        }
        if (this.tyreStates != null) {
            data.tyreStates = this.tyreStates.map((item) => item.toObject());
        }
        if (this.documentMeta != null) {
            data.documentMeta = this.documentMeta.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.raceTeamId.length)
            writer.writeString(1, this.raceTeamId);
        if (this.tyreId.length)
            writer.writeString(2, this.tyreId);
        if (this.name.length)
            writer.writeString(3, this.name);
        if (this._id.length)
            writer.writeString(4, this._id);
        if (this.timeCreated != 0)
            writer.writeInt64(5, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(6, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(7, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(8, this.updateByUser);
        if (this.description.length)
            writer.writeString(9, this.description);
        if (this.statesJSON.length)
            writer.writeString(10, this.statesJSON);
        if (this.tyreStates.length)
            writer.writeRepeatedMessage(12, this.tyreStates, (item) => item.serialize(writer));
        if (this.has_documentMeta)
            writer.writeMessage(100, this.documentMeta, () => this.documentMeta.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TyreSet();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.raceTeamId = reader.readString();
                    break;
                case 2:
                    message.tyreId = reader.readString();
                    break;
                case 3:
                    message.name = reader.readString();
                    break;
                case 4:
                    message._id = reader.readString();
                    break;
                case 5:
                    message.timeCreated = reader.readInt64();
                    break;
                case 6:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 7:
                    message.createByUser = reader.readString();
                    break;
                case 8:
                    message.updateByUser = reader.readString();
                    break;
                case 9:
                    message.description = reader.readString();
                    break;
                case 10:
                    message.statesJSON = reader.readString();
                    break;
                case 12:
                    reader.readMessage(message.tyreStates, () => pb_1.Message.addToRepeatedWrapperField(message, 12, TyreState.deserialize(reader), TyreState));
                    break;
                case 100:
                    reader.readMessage(message.documentMeta, () => message.documentMeta = DocumentMeta.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return TyreSet.deserialize(bytes);
    }
}
exports.TyreSet = TyreSet;
_TyreSet_one_of_decls = new WeakMap();
class TyreState extends pb_1.Message {
    constructor(data) {
        super();
        _TyreState_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [14, 16], __classPrivateFieldGet(this, _TyreState_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("tyreStateId" in data && data.tyreStateId != undefined) {
                this.tyreStateId = data.tyreStateId;
            }
            if ("cadDir" in data && data.cadDir != undefined) {
                this.cadDir = data.cadDir;
            }
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createByUser" in data && data.createByUser != undefined) {
                this.createByUser = data.createByUser;
            }
            if ("updateByUser" in data && data.updateByUser != undefined) {
                this.updateByUser = data.updateByUser;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("loadedRadius" in data && data.loadedRadius != undefined) {
                this.loadedRadius = data.loadedRadius;
            }
            if ("stateTransform" in data && data.stateTransform != undefined) {
                this.stateTransform = data.stateTransform;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("cadFileRef" in data && data.cadFileRef != undefined) {
                this.cadFileRef = data.cadFileRef;
            }
            if ("isSwappablePart" in data && data.isSwappablePart != undefined) {
                this.isSwappablePart = data.isSwappablePart;
            }
            if ("cadPartNos" in data && data.cadPartNos != undefined) {
                this.cadPartNos = data.cadPartNos;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get tyreStateId() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set tyreStateId(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get cadDir() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set cadDir(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get createByUser() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set createByUser(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get updateByUser() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set updateByUser(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get loadedRadius() {
        return pb_1.Message.getWrapperField(this, TyreLoadedRadius, 11);
    }
    set loadedRadius(value) {
        pb_1.Message.setWrapperField(this, 11, value);
    }
    get has_loadedRadius() {
        return pb_1.Message.getField(this, 11) != null;
    }
    get stateTransform() {
        return pb_1.Message.getWrapperField(this, TyreStateTransform, 12);
    }
    set stateTransform(value) {
        pb_1.Message.setWrapperField(this, 12, value);
    }
    get has_stateTransform() {
        return pb_1.Message.getField(this, 12) != null;
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 13, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get cadFileRef() {
        return pb_1.Message.getRepeatedWrapperField(this, CFDFile, 14);
    }
    set cadFileRef(value) {
        pb_1.Message.setRepeatedWrapperField(this, 14, value);
    }
    get isSwappablePart() {
        return pb_1.Message.getFieldWithDefault(this, 15, false);
    }
    set isSwappablePart(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get cadPartNos() {
        return pb_1.Message.getRepeatedWrapperField(this, Part, 16);
    }
    set cadPartNos(value) {
        pb_1.Message.setRepeatedWrapperField(this, 16, value);
    }
    static fromObject(data) {
        const message = new TyreState({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.tyreStateId != null) {
            message.tyreStateId = data.tyreStateId;
        }
        if (data.cadDir != null) {
            message.cadDir = data.cadDir;
        }
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createByUser != null) {
            message.createByUser = data.createByUser;
        }
        if (data.updateByUser != null) {
            message.updateByUser = data.updateByUser;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.loadedRadius != null) {
            message.loadedRadius = TyreLoadedRadius.fromObject(data.loadedRadius);
        }
        if (data.stateTransform != null) {
            message.stateTransform = TyreStateTransform.fromObject(data.stateTransform);
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.cadFileRef != null) {
            message.cadFileRef = data.cadFileRef.map(item => CFDFile.fromObject(item));
        }
        if (data.isSwappablePart != null) {
            message.isSwappablePart = data.isSwappablePart;
        }
        if (data.cadPartNos != null) {
            message.cadPartNos = data.cadPartNos.map(item => Part.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.tyreStateId != null) {
            data.tyreStateId = this.tyreStateId;
        }
        if (this.cadDir != null) {
            data.cadDir = this.cadDir;
        }
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createByUser != null) {
            data.createByUser = this.createByUser;
        }
        if (this.updateByUser != null) {
            data.updateByUser = this.updateByUser;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.loadedRadius != null) {
            data.loadedRadius = this.loadedRadius.toObject();
        }
        if (this.stateTransform != null) {
            data.stateTransform = this.stateTransform.toObject();
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.cadFileRef != null) {
            data.cadFileRef = this.cadFileRef.map((item) => item.toObject());
        }
        if (this.isSwappablePart != null) {
            data.isSwappablePart = this.isSwappablePart;
        }
        if (this.cadPartNos != null) {
            data.cadPartNos = this.cadPartNos.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.tyreStateId.length)
            writer.writeString(3, this.tyreStateId);
        if (this.cadDir.length)
            writer.writeString(4, this.cadDir);
        if (this.timeCreated != 0)
            writer.writeInt64(5, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(6, this.timeUpdated);
        if (this.createByUser.length)
            writer.writeString(7, this.createByUser);
        if (this.updateByUser.length)
            writer.writeString(8, this.updateByUser);
        if (this.description.length)
            writer.writeString(9, this.description);
        if (this.has_loadedRadius)
            writer.writeMessage(11, this.loadedRadius, () => this.loadedRadius.serialize(writer));
        if (this.has_stateTransform)
            writer.writeMessage(12, this.stateTransform, () => this.stateTransform.serialize(writer));
        if (this.name.length)
            writer.writeString(13, this.name);
        if (this.cadFileRef.length)
            writer.writeRepeatedMessage(14, this.cadFileRef, (item) => item.serialize(writer));
        if (this.isSwappablePart != false)
            writer.writeBool(15, this.isSwappablePart);
        if (this.cadPartNos.length)
            writer.writeRepeatedMessage(16, this.cadPartNos, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TyreState();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.tyreStateId = reader.readString();
                    break;
                case 4:
                    message.cadDir = reader.readString();
                    break;
                case 5:
                    message.timeCreated = reader.readInt64();
                    break;
                case 6:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 7:
                    message.createByUser = reader.readString();
                    break;
                case 8:
                    message.updateByUser = reader.readString();
                    break;
                case 9:
                    message.description = reader.readString();
                    break;
                case 11:
                    reader.readMessage(message.loadedRadius, () => message.loadedRadius = TyreLoadedRadius.deserialize(reader));
                    break;
                case 12:
                    reader.readMessage(message.stateTransform, () => message.stateTransform = TyreStateTransform.deserialize(reader));
                    break;
                case 13:
                    message.name = reader.readString();
                    break;
                case 14:
                    reader.readMessage(message.cadFileRef, () => pb_1.Message.addToRepeatedWrapperField(message, 14, CFDFile.deserialize(reader), CFDFile));
                    break;
                case 15:
                    message.isSwappablePart = reader.readBool();
                    break;
                case 16:
                    reader.readMessage(message.cadPartNos, () => pb_1.Message.addToRepeatedWrapperField(message, 16, Part.deserialize(reader), Part));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return TyreState.deserialize(bytes);
    }
}
exports.TyreState = TyreState;
_TyreState_one_of_decls = new WeakMap();
class TyreLoadedRadius extends pb_1.Message {
    constructor(data) {
        super();
        _TyreLoadedRadius_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _TyreLoadedRadius_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("LS_REAR" in data && data.LS_REAR != undefined) {
                this.LS_REAR = data.LS_REAR;
            }
            if ("RS_REAR" in data && data.RS_REAR != undefined) {
                this.RS_REAR = data.RS_REAR;
            }
            if ("LS_FRONT" in data && data.LS_FRONT != undefined) {
                this.LS_FRONT = data.LS_FRONT;
            }
            if ("RS_FRONT" in data && data.RS_FRONT != undefined) {
                this.RS_FRONT = data.RS_FRONT;
            }
        }
    }
    get LS_REAR() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set LS_REAR(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get RS_REAR() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set RS_REAR(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get LS_FRONT() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set LS_FRONT(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get RS_FRONT() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set RS_FRONT(value) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data) {
        const message = new TyreLoadedRadius({});
        if (data.LS_REAR != null) {
            message.LS_REAR = data.LS_REAR;
        }
        if (data.RS_REAR != null) {
            message.RS_REAR = data.RS_REAR;
        }
        if (data.LS_FRONT != null) {
            message.LS_FRONT = data.LS_FRONT;
        }
        if (data.RS_FRONT != null) {
            message.RS_FRONT = data.RS_FRONT;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.LS_REAR != null) {
            data.LS_REAR = this.LS_REAR;
        }
        if (this.RS_REAR != null) {
            data.RS_REAR = this.RS_REAR;
        }
        if (this.LS_FRONT != null) {
            data.LS_FRONT = this.LS_FRONT;
        }
        if (this.RS_FRONT != null) {
            data.RS_FRONT = this.RS_FRONT;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.LS_REAR != 0)
            writer.writeFloat(1, this.LS_REAR);
        if (this.RS_REAR != 0)
            writer.writeFloat(2, this.RS_REAR);
        if (this.LS_FRONT != 0)
            writer.writeFloat(3, this.LS_FRONT);
        if (this.RS_FRONT != 0)
            writer.writeFloat(4, this.RS_FRONT);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TyreLoadedRadius();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.LS_REAR = reader.readFloat();
                    break;
                case 2:
                    message.RS_REAR = reader.readFloat();
                    break;
                case 3:
                    message.LS_FRONT = reader.readFloat();
                    break;
                case 4:
                    message.RS_FRONT = reader.readFloat();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return TyreLoadedRadius.deserialize(bytes);
    }
}
exports.TyreLoadedRadius = TyreLoadedRadius;
_TyreLoadedRadius_one_of_decls = new WeakMap();
class TyreStateTransform extends pb_1.Message {
    constructor(data) {
        super();
        _TyreStateTransform_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _TyreStateTransform_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("FRH" in data && data.FRH != undefined) {
                this.FRH = data.FRH;
            }
            if ("RRH" in data && data.RRH != undefined) {
                this.RRH = data.RRH;
            }
            if ("ROLL" in data && data.ROLL != undefined) {
                this.ROLL = data.ROLL;
            }
            if ("STEER" in data && data.STEER != undefined) {
                this.STEER = data.STEER;
            }
        }
    }
    get FRH() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set FRH(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get RRH() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set RRH(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get ROLL() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set ROLL(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get STEER() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set STEER(value) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data) {
        const message = new TyreStateTransform({});
        if (data.FRH != null) {
            message.FRH = data.FRH;
        }
        if (data.RRH != null) {
            message.RRH = data.RRH;
        }
        if (data.ROLL != null) {
            message.ROLL = data.ROLL;
        }
        if (data.STEER != null) {
            message.STEER = data.STEER;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.FRH != null) {
            data.FRH = this.FRH;
        }
        if (this.RRH != null) {
            data.RRH = this.RRH;
        }
        if (this.ROLL != null) {
            data.ROLL = this.ROLL;
        }
        if (this.STEER != null) {
            data.STEER = this.STEER;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.FRH != 0)
            writer.writeFloat(1, this.FRH);
        if (this.RRH != 0)
            writer.writeFloat(2, this.RRH);
        if (this.ROLL != 0)
            writer.writeFloat(3, this.ROLL);
        if (this.STEER != 0)
            writer.writeFloat(4, this.STEER);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TyreStateTransform();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.FRH = reader.readFloat();
                    break;
                case 2:
                    message.RRH = reader.readFloat();
                    break;
                case 3:
                    message.ROLL = reader.readFloat();
                    break;
                case 4:
                    message.STEER = reader.readFloat();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return TyreStateTransform.deserialize(bytes);
    }
}
exports.TyreStateTransform = TyreStateTransform;
_TyreStateTransform_one_of_decls = new WeakMap();
class ProjectDocument extends pb_1.Message {
    constructor(data) {
        super();
        _ProjectDocument_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _ProjectDocument_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("documentId" in data && data.documentId != undefined) {
                this.documentId = data.documentId;
            }
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("documentName" in data && data.documentName != undefined) {
                this.documentName = data.documentName;
            }
            if ("fileSize" in data && data.fileSize != undefined) {
                this.fileSize = data.fileSize;
            }
            if ("fileType" in data && data.fileType != undefined) {
                this.fileType = data.fileType;
            }
            if ("timeUploaded" in data && data.timeUploaded != undefined) {
                this.timeUploaded = data.timeUploaded;
            }
            if ("uploadedBy" in data && data.uploadedBy != undefined) {
                this.uploadedBy = data.uploadedBy;
            }
            if ("uploadedDate" in data && data.uploadedDate != undefined) {
                this.uploadedDate = data.uploadedDate;
            }
            if ("link" in data && data.link != undefined) {
                this.link = data.link;
            }
        }
    }
    get documentId() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set documentId(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get documentName() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set documentName(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get fileSize() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set fileSize(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get fileType() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set fileType(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get timeUploaded() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set timeUploaded(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get uploadedBy() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set uploadedBy(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get uploadedDate() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set uploadedDate(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get link() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set link(value) {
        pb_1.Message.setField(this, 9, value);
    }
    static fromObject(data) {
        const message = new ProjectDocument({});
        if (data.documentId != null) {
            message.documentId = data.documentId;
        }
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.documentName != null) {
            message.documentName = data.documentName;
        }
        if (data.fileSize != null) {
            message.fileSize = data.fileSize;
        }
        if (data.fileType != null) {
            message.fileType = data.fileType;
        }
        if (data.timeUploaded != null) {
            message.timeUploaded = data.timeUploaded;
        }
        if (data.uploadedBy != null) {
            message.uploadedBy = data.uploadedBy;
        }
        if (data.uploadedDate != null) {
            message.uploadedDate = data.uploadedDate;
        }
        if (data.link != null) {
            message.link = data.link;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.documentId != null) {
            data.documentId = this.documentId;
        }
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.documentName != null) {
            data.documentName = this.documentName;
        }
        if (this.fileSize != null) {
            data.fileSize = this.fileSize;
        }
        if (this.fileType != null) {
            data.fileType = this.fileType;
        }
        if (this.timeUploaded != null) {
            data.timeUploaded = this.timeUploaded;
        }
        if (this.uploadedBy != null) {
            data.uploadedBy = this.uploadedBy;
        }
        if (this.uploadedDate != null) {
            data.uploadedDate = this.uploadedDate;
        }
        if (this.link != null) {
            data.link = this.link;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.documentId.length)
            writer.writeString(1, this.documentId);
        if (this._id.length)
            writer.writeString(2, this._id);
        if (this.documentName.length)
            writer.writeString(3, this.documentName);
        if (this.fileSize != 0)
            writer.writeInt32(4, this.fileSize);
        if (this.fileType.length)
            writer.writeString(5, this.fileType);
        if (this.timeUploaded != 0)
            writer.writeInt64(6, this.timeUploaded);
        if (this.uploadedBy.length)
            writer.writeString(7, this.uploadedBy);
        if (this.uploadedDate.length)
            writer.writeString(8, this.uploadedDate);
        if (this.link.length)
            writer.writeString(9, this.link);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ProjectDocument();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.documentId = reader.readString();
                    break;
                case 2:
                    message._id = reader.readString();
                    break;
                case 3:
                    message.documentName = reader.readString();
                    break;
                case 4:
                    message.fileSize = reader.readInt32();
                    break;
                case 5:
                    message.fileType = reader.readString();
                    break;
                case 6:
                    message.timeUploaded = reader.readInt64();
                    break;
                case 7:
                    message.uploadedBy = reader.readString();
                    break;
                case 8:
                    message.uploadedDate = reader.readString();
                    break;
                case 9:
                    message.link = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return ProjectDocument.deserialize(bytes);
    }
}
exports.ProjectDocument = ProjectDocument;
_ProjectDocument_one_of_decls = new WeakMap();
class WorkflowRecord extends pb_1.Message {
    constructor(data) {
        super();
        _WorkflowRecord_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _WorkflowRecord_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("_id" in data && data._id != undefined) {
                this._id = data._id;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("workflowSubmissionId" in data && data.workflowSubmissionId != undefined) {
                this.workflowSubmissionId = data.workflowSubmissionId;
            }
            if ("workflowId" in data && data.workflowId != undefined) {
                this.workflowId = data.workflowId;
            }
            if ("workflowTaskId" in data && data.workflowTaskId != undefined) {
                this.workflowTaskId = data.workflowTaskId;
            }
            if ("recordText" in data && data.recordText != undefined) {
                this.recordText = data.recordText;
            }
            if ("createDate" in data && data.createDate != undefined) {
                this.createDate = data.createDate;
            }
            if ("result" in data && data.result != undefined) {
                this.result = data.result;
            }
        }
    }
    get _id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set _id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get workflowSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set workflowSubmissionId(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get workflowId() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set workflowId(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get workflowTaskId() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set workflowTaskId(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get recordText() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set recordText(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get createDate() {
        return pb_1.Message.getFieldWithDefault(this, 7, 0);
    }
    set createDate(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get result() {
        return pb_1.Message.getFieldWithDefault(this, 8, RunStatus.UNSPECIFIED);
    }
    set result(value) {
        pb_1.Message.setField(this, 8, value);
    }
    static fromObject(data) {
        const message = new WorkflowRecord({});
        if (data._id != null) {
            message._id = data._id;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.workflowSubmissionId != null) {
            message.workflowSubmissionId = data.workflowSubmissionId;
        }
        if (data.workflowId != null) {
            message.workflowId = data.workflowId;
        }
        if (data.workflowTaskId != null) {
            message.workflowTaskId = data.workflowTaskId;
        }
        if (data.recordText != null) {
            message.recordText = data.recordText;
        }
        if (data.createDate != null) {
            message.createDate = data.createDate;
        }
        if (data.result != null) {
            message.result = data.result;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this._id != null) {
            data._id = this._id;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.workflowSubmissionId != null) {
            data.workflowSubmissionId = this.workflowSubmissionId;
        }
        if (this.workflowId != null) {
            data.workflowId = this.workflowId;
        }
        if (this.workflowTaskId != null) {
            data.workflowTaskId = this.workflowTaskId;
        }
        if (this.recordText != null) {
            data.recordText = this.recordText;
        }
        if (this.createDate != null) {
            data.createDate = this.createDate;
        }
        if (this.result != null) {
            data.result = this.result;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this._id.length)
            writer.writeString(1, this._id);
        if (this.raceTeamId.length)
            writer.writeString(2, this.raceTeamId);
        if (this.workflowSubmissionId.length)
            writer.writeString(3, this.workflowSubmissionId);
        if (this.workflowId.length)
            writer.writeString(4, this.workflowId);
        if (this.workflowTaskId.length)
            writer.writeString(5, this.workflowTaskId);
        if (this.recordText.length)
            writer.writeString(6, this.recordText);
        if (this.createDate != 0)
            writer.writeInt64(7, this.createDate);
        if (this.result != RunStatus.UNSPECIFIED)
            writer.writeEnum(8, this.result);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WorkflowRecord();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message._id = reader.readString();
                    break;
                case 2:
                    message.raceTeamId = reader.readString();
                    break;
                case 3:
                    message.workflowSubmissionId = reader.readString();
                    break;
                case 4:
                    message.workflowId = reader.readString();
                    break;
                case 5:
                    message.workflowTaskId = reader.readString();
                    break;
                case 6:
                    message.recordText = reader.readString();
                    break;
                case 7:
                    message.createDate = reader.readInt64();
                    break;
                case 8:
                    message.result = reader.readEnum();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return WorkflowRecord.deserialize(bytes);
    }
}
exports.WorkflowRecord = WorkflowRecord;
_WorkflowRecord_one_of_decls = new WeakMap();
class AzureBlobStorageWebHook extends pb_1.Message {
    constructor(data) {
        super();
        _AzureBlobStorageWebHook_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _AzureBlobStorageWebHook_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("blobUrl" in data && data.blobUrl != undefined) {
                this.blobUrl = data.blobUrl;
            }
            if ("server" in data && data.server != undefined) {
                this.server = data.server;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("systemRunId" in data && data.systemRunId != undefined) {
                this.systemRunId = data.systemRunId;
            }
            if ("geometryDir" in data && data.geometryDir != undefined) {
                this.geometryDir = data.geometryDir;
            }
            if ("filename" in data && data.filename != undefined) {
                this.filename = data.filename;
            }
            if ("workflowSubmissionId" in data && data.workflowSubmissionId != undefined) {
                this.workflowSubmissionId = data.workflowSubmissionId;
            }
            if ("jobKey_s" in data && data.jobKey_s != undefined) {
                this.jobKey_s = data.jobKey_s;
            }
            if ("workflowTaskRunId" in data && data.workflowTaskRunId != undefined) {
                this.workflowTaskRunId = data.workflowTaskRunId;
            }
            if ("wellFormed" in data && data.wellFormed != undefined) {
                this.wellFormed = data.wellFormed;
            }
            if ("workflowSubmissionRunGroupId" in data && data.workflowSubmissionRunGroupId != undefined) {
                this.workflowSubmissionRunGroupId = data.workflowSubmissionRunGroupId;
            }
        }
    }
    get blobUrl() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set blobUrl(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get server() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set server(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get systemRunId() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set systemRunId(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get geometryDir() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set geometryDir(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get filename() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set filename(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get workflowSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set workflowSubmissionId(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get jobKey_s() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set jobKey_s(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get workflowTaskRunId() {
        return pb_1.Message.getFieldWithDefault(this, 9, "");
    }
    set workflowTaskRunId(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get wellFormed() {
        return pb_1.Message.getFieldWithDefault(this, 10, false);
    }
    set wellFormed(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get workflowSubmissionRunGroupId() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set workflowSubmissionRunGroupId(value) {
        pb_1.Message.setField(this, 11, value);
    }
    static fromObject(data) {
        const message = new AzureBlobStorageWebHook({});
        if (data.blobUrl != null) {
            message.blobUrl = data.blobUrl;
        }
        if (data.server != null) {
            message.server = data.server;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.systemRunId != null) {
            message.systemRunId = data.systemRunId;
        }
        if (data.geometryDir != null) {
            message.geometryDir = data.geometryDir;
        }
        if (data.filename != null) {
            message.filename = data.filename;
        }
        if (data.workflowSubmissionId != null) {
            message.workflowSubmissionId = data.workflowSubmissionId;
        }
        if (data.jobKey_s != null) {
            message.jobKey_s = data.jobKey_s;
        }
        if (data.workflowTaskRunId != null) {
            message.workflowTaskRunId = data.workflowTaskRunId;
        }
        if (data.wellFormed != null) {
            message.wellFormed = data.wellFormed;
        }
        if (data.workflowSubmissionRunGroupId != null) {
            message.workflowSubmissionRunGroupId = data.workflowSubmissionRunGroupId;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.blobUrl != null) {
            data.blobUrl = this.blobUrl;
        }
        if (this.server != null) {
            data.server = this.server;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.systemRunId != null) {
            data.systemRunId = this.systemRunId;
        }
        if (this.geometryDir != null) {
            data.geometryDir = this.geometryDir;
        }
        if (this.filename != null) {
            data.filename = this.filename;
        }
        if (this.workflowSubmissionId != null) {
            data.workflowSubmissionId = this.workflowSubmissionId;
        }
        if (this.jobKey_s != null) {
            data.jobKey_s = this.jobKey_s;
        }
        if (this.workflowTaskRunId != null) {
            data.workflowTaskRunId = this.workflowTaskRunId;
        }
        if (this.wellFormed != null) {
            data.wellFormed = this.wellFormed;
        }
        if (this.workflowSubmissionRunGroupId != null) {
            data.workflowSubmissionRunGroupId = this.workflowSubmissionRunGroupId;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.blobUrl.length)
            writer.writeString(1, this.blobUrl);
        if (this.server.length)
            writer.writeString(2, this.server);
        if (this.raceTeamId.length)
            writer.writeString(3, this.raceTeamId);
        if (this.systemRunId.length)
            writer.writeString(4, this.systemRunId);
        if (this.geometryDir.length)
            writer.writeString(5, this.geometryDir);
        if (this.filename.length)
            writer.writeString(6, this.filename);
        if (this.workflowSubmissionId.length)
            writer.writeString(7, this.workflowSubmissionId);
        if (this.jobKey_s.length)
            writer.writeString(8, this.jobKey_s);
        if (this.workflowTaskRunId.length)
            writer.writeString(9, this.workflowTaskRunId);
        if (this.wellFormed != false)
            writer.writeBool(10, this.wellFormed);
        if (this.workflowSubmissionRunGroupId.length)
            writer.writeString(11, this.workflowSubmissionRunGroupId);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AzureBlobStorageWebHook();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.blobUrl = reader.readString();
                    break;
                case 2:
                    message.server = reader.readString();
                    break;
                case 3:
                    message.raceTeamId = reader.readString();
                    break;
                case 4:
                    message.systemRunId = reader.readString();
                    break;
                case 5:
                    message.geometryDir = reader.readString();
                    break;
                case 6:
                    message.filename = reader.readString();
                    break;
                case 7:
                    message.workflowSubmissionId = reader.readString();
                    break;
                case 8:
                    message.jobKey_s = reader.readString();
                    break;
                case 9:
                    message.workflowTaskRunId = reader.readString();
                    break;
                case 10:
                    message.wellFormed = reader.readBool();
                    break;
                case 11:
                    message.workflowSubmissionRunGroupId = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return AzureBlobStorageWebHook.deserialize(bytes);
    }
}
exports.AzureBlobStorageWebHook = AzureBlobStorageWebHook;
_AzureBlobStorageWebHook_one_of_decls = new WeakMap();
class ExecuteWorkflowTask extends pb_1.Message {
    constructor(data) {
        super();
        _ExecuteWorkflowTask_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _ExecuteWorkflowTask_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("workflow_b" in data && data.workflow_b != undefined) {
                this.workflow_b = data.workflow_b;
            }
            if ("userAccessToken" in data && data.userAccessToken != undefined) {
                this.userAccessToken = data.userAccessToken;
            }
            if ("workflowSubmissionId" in data && data.workflowSubmissionId != undefined) {
                this.workflowSubmissionId = data.workflowSubmissionId;
            }
            if ("jobSystemId" in data && data.jobSystemId != undefined) {
                this.jobSystemId = data.jobSystemId;
            }
            if ("taskIndex" in data && data.taskIndex != undefined) {
                this.taskIndex = data.taskIndex;
            }
            if ("workflowIndex" in data && data.workflowIndex != undefined) {
                this.workflowIndex = data.workflowIndex;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
        }
    }
    get workflow_b() {
        return pb_1.Message.getWrapperField(this, Workflow, 1);
    }
    set workflow_b(value) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_workflow_b() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get userAccessToken() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set userAccessToken(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get workflowSubmissionId() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set workflowSubmissionId(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get jobSystemId() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set jobSystemId(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get taskIndex() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set taskIndex(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get workflowIndex() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set workflowIndex(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 7, value);
    }
    static fromObject(data) {
        const message = new ExecuteWorkflowTask({});
        if (data.workflow_b != null) {
            message.workflow_b = Workflow.fromObject(data.workflow_b);
        }
        if (data.userAccessToken != null) {
            message.userAccessToken = data.userAccessToken;
        }
        if (data.workflowSubmissionId != null) {
            message.workflowSubmissionId = data.workflowSubmissionId;
        }
        if (data.jobSystemId != null) {
            message.jobSystemId = data.jobSystemId;
        }
        if (data.taskIndex != null) {
            message.taskIndex = data.taskIndex;
        }
        if (data.workflowIndex != null) {
            message.workflowIndex = data.workflowIndex;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.workflow_b != null) {
            data.workflow_b = this.workflow_b.toObject();
        }
        if (this.userAccessToken != null) {
            data.userAccessToken = this.userAccessToken;
        }
        if (this.workflowSubmissionId != null) {
            data.workflowSubmissionId = this.workflowSubmissionId;
        }
        if (this.jobSystemId != null) {
            data.jobSystemId = this.jobSystemId;
        }
        if (this.taskIndex != null) {
            data.taskIndex = this.taskIndex;
        }
        if (this.workflowIndex != null) {
            data.workflowIndex = this.workflowIndex;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_workflow_b)
            writer.writeMessage(1, this.workflow_b, () => this.workflow_b.serialize(writer));
        if (this.userAccessToken.length)
            writer.writeString(2, this.userAccessToken);
        if (this.workflowSubmissionId.length)
            writer.writeString(3, this.workflowSubmissionId);
        if (this.jobSystemId.length)
            writer.writeString(4, this.jobSystemId);
        if (this.taskIndex != 0)
            writer.writeInt32(5, this.taskIndex);
        if (this.workflowIndex != 0)
            writer.writeInt32(6, this.workflowIndex);
        if (this.raceTeamId.length)
            writer.writeString(7, this.raceTeamId);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ExecuteWorkflowTask();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.workflow_b, () => message.workflow_b = Workflow.deserialize(reader));
                    break;
                case 2:
                    message.userAccessToken = reader.readString();
                    break;
                case 3:
                    message.workflowSubmissionId = reader.readString();
                    break;
                case 4:
                    message.jobSystemId = reader.readString();
                    break;
                case 5:
                    message.taskIndex = reader.readInt32();
                    break;
                case 6:
                    message.workflowIndex = reader.readInt32();
                    break;
                case 7:
                    message.raceTeamId = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return ExecuteWorkflowTask.deserialize(bytes);
    }
}
exports.ExecuteWorkflowTask = ExecuteWorkflowTask;
_ExecuteWorkflowTask_one_of_decls = new WeakMap();
class DocumentMeta extends pb_1.Message {
    constructor(data) {
        super();
        _DocumentMeta_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _DocumentMeta_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("timeCreated" in data && data.timeCreated != undefined) {
                this.timeCreated = data.timeCreated;
            }
            if ("timeUpdated" in data && data.timeUpdated != undefined) {
                this.timeUpdated = data.timeUpdated;
            }
            if ("createdBy" in data && data.createdBy != undefined) {
                this.createdBy = data.createdBy;
            }
            if ("updatedBy" in data && data.updatedBy != undefined) {
                this.updatedBy = data.updatedBy;
            }
            if ("source" in data && data.source != undefined) {
                this.source = data.source;
            }
            if ("sourceUpdated" in data && data.sourceUpdated != undefined) {
                this.sourceUpdated = data.sourceUpdated;
            }
            if ("version" in data && data.version != undefined) {
                this.version = data.version;
            }
            if ("locked" in data && data.locked != undefined) {
                this.locked = data.locked;
            }
            if ("frontEndDisplayHint" in data && data.frontEndDisplayHint != undefined) {
                this.frontEndDisplayHint = data.frontEndDisplayHint;
            }
        }
    }
    get timeCreated() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set timeCreated(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get timeUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set timeUpdated(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get createdBy() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set createdBy(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get updatedBy() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set updatedBy(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get source() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set source(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get sourceUpdated() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set sourceUpdated(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get version() {
        return pb_1.Message.getFieldWithDefault(this, 7, 0);
    }
    set version(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get locked() {
        return pb_1.Message.getFieldWithDefault(this, 8, false);
    }
    set locked(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get frontEndDisplayHint() {
        return pb_1.Message.getFieldWithDefault(this, 9, false);
    }
    set frontEndDisplayHint(value) {
        pb_1.Message.setField(this, 9, value);
    }
    static fromObject(data) {
        const message = new DocumentMeta({});
        if (data.timeCreated != null) {
            message.timeCreated = data.timeCreated;
        }
        if (data.timeUpdated != null) {
            message.timeUpdated = data.timeUpdated;
        }
        if (data.createdBy != null) {
            message.createdBy = data.createdBy;
        }
        if (data.updatedBy != null) {
            message.updatedBy = data.updatedBy;
        }
        if (data.source != null) {
            message.source = data.source;
        }
        if (data.sourceUpdated != null) {
            message.sourceUpdated = data.sourceUpdated;
        }
        if (data.version != null) {
            message.version = data.version;
        }
        if (data.locked != null) {
            message.locked = data.locked;
        }
        if (data.frontEndDisplayHint != null) {
            message.frontEndDisplayHint = data.frontEndDisplayHint;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.timeCreated != null) {
            data.timeCreated = this.timeCreated;
        }
        if (this.timeUpdated != null) {
            data.timeUpdated = this.timeUpdated;
        }
        if (this.createdBy != null) {
            data.createdBy = this.createdBy;
        }
        if (this.updatedBy != null) {
            data.updatedBy = this.updatedBy;
        }
        if (this.source != null) {
            data.source = this.source;
        }
        if (this.sourceUpdated != null) {
            data.sourceUpdated = this.sourceUpdated;
        }
        if (this.version != null) {
            data.version = this.version;
        }
        if (this.locked != null) {
            data.locked = this.locked;
        }
        if (this.frontEndDisplayHint != null) {
            data.frontEndDisplayHint = this.frontEndDisplayHint;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.timeCreated != 0)
            writer.writeInt64(1, this.timeCreated);
        if (this.timeUpdated != 0)
            writer.writeInt64(2, this.timeUpdated);
        if (this.createdBy.length)
            writer.writeString(3, this.createdBy);
        if (this.updatedBy.length)
            writer.writeString(4, this.updatedBy);
        if (this.source.length)
            writer.writeString(5, this.source);
        if (this.sourceUpdated != 0)
            writer.writeInt64(6, this.sourceUpdated);
        if (this.version != 0)
            writer.writeInt32(7, this.version);
        if (this.locked != false)
            writer.writeBool(8, this.locked);
        if (this.frontEndDisplayHint != false)
            writer.writeBool(9, this.frontEndDisplayHint);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DocumentMeta();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.timeCreated = reader.readInt64();
                    break;
                case 2:
                    message.timeUpdated = reader.readInt64();
                    break;
                case 3:
                    message.createdBy = reader.readString();
                    break;
                case 4:
                    message.updatedBy = reader.readString();
                    break;
                case 5:
                    message.source = reader.readString();
                    break;
                case 6:
                    message.sourceUpdated = reader.readInt64();
                    break;
                case 7:
                    message.version = reader.readInt32();
                    break;
                case 8:
                    message.locked = reader.readBool();
                    break;
                case 9:
                    message.frontEndDisplayHint = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return DocumentMeta.deserialize(bytes);
    }
}
exports.DocumentMeta = DocumentMeta;
_DocumentMeta_one_of_decls = new WeakMap();
class JobQueueItem extends pb_1.Message {
    constructor(data) {
        super();
        _JobQueueItem_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _JobQueueItem_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("gmRefString" in data && data.gmRefString != undefined) {
                this.gmRefString = data.gmRefString;
            }
            if ("raceTeamId" in data && data.raceTeamId != undefined) {
                this.raceTeamId = data.raceTeamId;
            }
            if ("workflowSubmissionName" in data && data.workflowSubmissionName != undefined) {
                this.workflowSubmissionName = data.workflowSubmissionName;
            }
            if ("jsonPayload" in data && data.jsonPayload != undefined) {
                this.jsonPayload = data.jsonPayload;
            }
            if ("jobId" in data && data.jobId != undefined) {
                this.jobId = data.jobId;
            }
            if ("rescaleToken" in data && data.rescaleToken != undefined) {
                this.rescaleToken = data.rescaleToken;
            }
            if ("isCreate" in data && data.isCreate != undefined) {
                this.isCreate = data.isCreate;
            }
            if ("submitUserDbId" in data && data.submitUserDbId != undefined) {
                this.submitUserDbId = data.submitUserDbId;
            }
            if ("submitUserEmail" in data && data.submitUserEmail != undefined) {
                this.submitUserEmail = data.submitUserEmail;
            }
            if ("workflowTask" in data && data.workflowTask != undefined) {
                this.workflowTask = data.workflowTask;
            }
            if ("priority" in data && data.priority != undefined) {
                this.priority = data.priority;
            }
            if ("queuedTime" in data && data.queuedTime != undefined) {
                this.queuedTime = data.queuedTime;
            }
            if ("archive" in data && data.archive != undefined) {
                this.archive = data.archive;
            }
            if ("submitted" in data && data.submitted != undefined) {
                this.submitted = data.submitted;
            }
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
            if ("platformJobType" in data && data.platformJobType != undefined) {
                this.platformJobType = data.platformJobType;
            }
            if ("targetIdentifier" in data && data.targetIdentifier != undefined) {
                this.targetIdentifier = data.targetIdentifier;
            }
            if ("documentMeta" in data && data.documentMeta != undefined) {
                this.documentMeta = data.documentMeta;
            }
        }
    }
    get gmRefString() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set gmRefString(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get raceTeamId() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set raceTeamId(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get workflowSubmissionName() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set workflowSubmissionName(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get jsonPayload() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set jsonPayload(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get jobId() {
        return pb_1.Message.getFieldWithDefault(this, 20, "");
    }
    set jobId(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get rescaleToken() {
        return pb_1.Message.getFieldWithDefault(this, 30, "");
    }
    set rescaleToken(value) {
        pb_1.Message.setField(this, 30, value);
    }
    get isCreate() {
        return pb_1.Message.getFieldWithDefault(this, 40, false);
    }
    set isCreate(value) {
        pb_1.Message.setField(this, 40, value);
    }
    get submitUserDbId() {
        return pb_1.Message.getFieldWithDefault(this, 60, "");
    }
    set submitUserDbId(value) {
        pb_1.Message.setField(this, 60, value);
    }
    get submitUserEmail() {
        return pb_1.Message.getFieldWithDefault(this, 65, "");
    }
    set submitUserEmail(value) {
        pb_1.Message.setField(this, 65, value);
    }
    get workflowTask() {
        return pb_1.Message.getWrapperField(this, WorkflowTask, 70);
    }
    set workflowTask(value) {
        pb_1.Message.setWrapperField(this, 70, value);
    }
    get has_workflowTask() {
        return pb_1.Message.getField(this, 70) != null;
    }
    get priority() {
        return pb_1.Message.getFieldWithDefault(this, 80, 0);
    }
    set priority(value) {
        pb_1.Message.setField(this, 80, value);
    }
    get queuedTime() {
        return pb_1.Message.getFieldWithDefault(this, 90, 0);
    }
    set queuedTime(value) {
        pb_1.Message.setField(this, 90, value);
    }
    get archive() {
        return pb_1.Message.getFieldWithDefault(this, 100, false);
    }
    set archive(value) {
        pb_1.Message.setField(this, 100, value);
    }
    get submitted() {
        return pb_1.Message.getFieldWithDefault(this, 105, false);
    }
    set submitted(value) {
        pb_1.Message.setField(this, 105, value);
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 110, "");
    }
    set type(value) {
        pb_1.Message.setField(this, 110, value);
    }
    get platformJobType() {
        return pb_1.Message.getFieldWithDefault(this, 120, "");
    }
    set platformJobType(value) {
        pb_1.Message.setField(this, 120, value);
    }
    get targetIdentifier() {
        return pb_1.Message.getFieldWithDefault(this, 130, "");
    }
    set targetIdentifier(value) {
        pb_1.Message.setField(this, 130, value);
    }
    get documentMeta() {
        return pb_1.Message.getWrapperField(this, DocumentMeta, 140);
    }
    set documentMeta(value) {
        pb_1.Message.setWrapperField(this, 140, value);
    }
    get has_documentMeta() {
        return pb_1.Message.getField(this, 140) != null;
    }
    static fromObject(data) {
        const message = new JobQueueItem({});
        if (data.gmRefString != null) {
            message.gmRefString = data.gmRefString;
        }
        if (data.raceTeamId != null) {
            message.raceTeamId = data.raceTeamId;
        }
        if (data.workflowSubmissionName != null) {
            message.workflowSubmissionName = data.workflowSubmissionName;
        }
        if (data.jsonPayload != null) {
            message.jsonPayload = data.jsonPayload;
        }
        if (data.jobId != null) {
            message.jobId = data.jobId;
        }
        if (data.rescaleToken != null) {
            message.rescaleToken = data.rescaleToken;
        }
        if (data.isCreate != null) {
            message.isCreate = data.isCreate;
        }
        if (data.submitUserDbId != null) {
            message.submitUserDbId = data.submitUserDbId;
        }
        if (data.submitUserEmail != null) {
            message.submitUserEmail = data.submitUserEmail;
        }
        if (data.workflowTask != null) {
            message.workflowTask = WorkflowTask.fromObject(data.workflowTask);
        }
        if (data.priority != null) {
            message.priority = data.priority;
        }
        if (data.queuedTime != null) {
            message.queuedTime = data.queuedTime;
        }
        if (data.archive != null) {
            message.archive = data.archive;
        }
        if (data.submitted != null) {
            message.submitted = data.submitted;
        }
        if (data.type != null) {
            message.type = data.type;
        }
        if (data.platformJobType != null) {
            message.platformJobType = data.platformJobType;
        }
        if (data.targetIdentifier != null) {
            message.targetIdentifier = data.targetIdentifier;
        }
        if (data.documentMeta != null) {
            message.documentMeta = DocumentMeta.fromObject(data.documentMeta);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.gmRefString != null) {
            data.gmRefString = this.gmRefString;
        }
        if (this.raceTeamId != null) {
            data.raceTeamId = this.raceTeamId;
        }
        if (this.workflowSubmissionName != null) {
            data.workflowSubmissionName = this.workflowSubmissionName;
        }
        if (this.jsonPayload != null) {
            data.jsonPayload = this.jsonPayload;
        }
        if (this.jobId != null) {
            data.jobId = this.jobId;
        }
        if (this.rescaleToken != null) {
            data.rescaleToken = this.rescaleToken;
        }
        if (this.isCreate != null) {
            data.isCreate = this.isCreate;
        }
        if (this.submitUserDbId != null) {
            data.submitUserDbId = this.submitUserDbId;
        }
        if (this.submitUserEmail != null) {
            data.submitUserEmail = this.submitUserEmail;
        }
        if (this.workflowTask != null) {
            data.workflowTask = this.workflowTask.toObject();
        }
        if (this.priority != null) {
            data.priority = this.priority;
        }
        if (this.queuedTime != null) {
            data.queuedTime = this.queuedTime;
        }
        if (this.archive != null) {
            data.archive = this.archive;
        }
        if (this.submitted != null) {
            data.submitted = this.submitted;
        }
        if (this.type != null) {
            data.type = this.type;
        }
        if (this.platformJobType != null) {
            data.platformJobType = this.platformJobType;
        }
        if (this.targetIdentifier != null) {
            data.targetIdentifier = this.targetIdentifier;
        }
        if (this.documentMeta != null) {
            data.documentMeta = this.documentMeta.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.gmRefString.length)
            writer.writeString(1, this.gmRefString);
        if (this.raceTeamId.length)
            writer.writeString(5, this.raceTeamId);
        if (this.workflowSubmissionName.length)
            writer.writeString(6, this.workflowSubmissionName);
        if (this.jsonPayload.length)
            writer.writeString(10, this.jsonPayload);
        if (this.jobId.length)
            writer.writeString(20, this.jobId);
        if (this.rescaleToken.length)
            writer.writeString(30, this.rescaleToken);
        if (this.isCreate != false)
            writer.writeBool(40, this.isCreate);
        if (this.submitUserDbId.length)
            writer.writeString(60, this.submitUserDbId);
        if (this.submitUserEmail.length)
            writer.writeString(65, this.submitUserEmail);
        if (this.has_workflowTask)
            writer.writeMessage(70, this.workflowTask, () => this.workflowTask.serialize(writer));
        if (this.priority != 0)
            writer.writeInt32(80, this.priority);
        if (this.queuedTime != 0)
            writer.writeInt64(90, this.queuedTime);
        if (this.archive != false)
            writer.writeBool(100, this.archive);
        if (this.submitted != false)
            writer.writeBool(105, this.submitted);
        if (this.type.length)
            writer.writeString(110, this.type);
        if (this.platformJobType.length)
            writer.writeString(120, this.platformJobType);
        if (this.targetIdentifier.length)
            writer.writeString(130, this.targetIdentifier);
        if (this.has_documentMeta)
            writer.writeMessage(140, this.documentMeta, () => this.documentMeta.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new JobQueueItem();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.gmRefString = reader.readString();
                    break;
                case 5:
                    message.raceTeamId = reader.readString();
                    break;
                case 6:
                    message.workflowSubmissionName = reader.readString();
                    break;
                case 10:
                    message.jsonPayload = reader.readString();
                    break;
                case 20:
                    message.jobId = reader.readString();
                    break;
                case 30:
                    message.rescaleToken = reader.readString();
                    break;
                case 40:
                    message.isCreate = reader.readBool();
                    break;
                case 60:
                    message.submitUserDbId = reader.readString();
                    break;
                case 65:
                    message.submitUserEmail = reader.readString();
                    break;
                case 70:
                    reader.readMessage(message.workflowTask, () => message.workflowTask = WorkflowTask.deserialize(reader));
                    break;
                case 80:
                    message.priority = reader.readInt32();
                    break;
                case 90:
                    message.queuedTime = reader.readInt64();
                    break;
                case 100:
                    message.archive = reader.readBool();
                    break;
                case 105:
                    message.submitted = reader.readBool();
                    break;
                case 110:
                    message.type = reader.readString();
                    break;
                case 120:
                    message.platformJobType = reader.readString();
                    break;
                case 130:
                    message.targetIdentifier = reader.readString();
                    break;
                case 140:
                    reader.readMessage(message.documentMeta, () => message.documentMeta = DocumentMeta.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return JobQueueItem.deserialize(bytes);
    }
}
exports.JobQueueItem = JobQueueItem;
_JobQueueItem_one_of_decls = new WeakMap();
class Metric extends pb_1.Message {
    constructor(data) {
        super();
        _Metric_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Metric_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("gmRef" in data && data.gmRef != undefined) {
                this.gmRef = data.gmRef;
            }
            if ("runTimeSec" in data && data.runTimeSec != undefined) {
                this.runTimeSec = data.runTimeSec;
            }
            if ("startTime" in data && data.startTime != undefined) {
                this.startTime = data.startTime;
            }
            if ("endTime" in data && data.endTime != undefined) {
                this.endTime = data.endTime;
            }
            if ("taskName" in data && data.taskName != undefined) {
                this.taskName = data.taskName;
            }
            if ("source" in data && data.source != undefined) {
                this.source = data.source;
            }
            if ("queueTimeSec" in data && data.queueTimeSec != undefined) {
                this.queueTimeSec = data.queueTimeSec;
            }
        }
    }
    get gmRef() {
        return pb_1.Message.getWrapperField(this, GMRef, 1);
    }
    set gmRef(value) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_gmRef() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get runTimeSec() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set runTimeSec(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get startTime() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set startTime(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get endTime() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set endTime(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get taskName() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set taskName(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get source() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set source(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get queueTimeSec() {
        return pb_1.Message.getFieldWithDefault(this, 7, 0);
    }
    set queueTimeSec(value) {
        pb_1.Message.setField(this, 7, value);
    }
    static fromObject(data) {
        const message = new Metric({});
        if (data.gmRef != null) {
            message.gmRef = GMRef.fromObject(data.gmRef);
        }
        if (data.runTimeSec != null) {
            message.runTimeSec = data.runTimeSec;
        }
        if (data.startTime != null) {
            message.startTime = data.startTime;
        }
        if (data.endTime != null) {
            message.endTime = data.endTime;
        }
        if (data.taskName != null) {
            message.taskName = data.taskName;
        }
        if (data.source != null) {
            message.source = data.source;
        }
        if (data.queueTimeSec != null) {
            message.queueTimeSec = data.queueTimeSec;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.gmRef != null) {
            data.gmRef = this.gmRef.toObject();
        }
        if (this.runTimeSec != null) {
            data.runTimeSec = this.runTimeSec;
        }
        if (this.startTime != null) {
            data.startTime = this.startTime;
        }
        if (this.endTime != null) {
            data.endTime = this.endTime;
        }
        if (this.taskName != null) {
            data.taskName = this.taskName;
        }
        if (this.source != null) {
            data.source = this.source;
        }
        if (this.queueTimeSec != null) {
            data.queueTimeSec = this.queueTimeSec;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_gmRef)
            writer.writeMessage(1, this.gmRef, () => this.gmRef.serialize(writer));
        if (this.runTimeSec != 0)
            writer.writeDouble(2, this.runTimeSec);
        if (this.startTime != 0)
            writer.writeInt64(3, this.startTime);
        if (this.endTime != 0)
            writer.writeInt64(4, this.endTime);
        if (this.taskName.length)
            writer.writeString(5, this.taskName);
        if (this.source.length)
            writer.writeString(6, this.source);
        if (this.queueTimeSec != 0)
            writer.writeDouble(7, this.queueTimeSec);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Metric();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.gmRef, () => message.gmRef = GMRef.deserialize(reader));
                    break;
                case 2:
                    message.runTimeSec = reader.readDouble();
                    break;
                case 3:
                    message.startTime = reader.readInt64();
                    break;
                case 4:
                    message.endTime = reader.readInt64();
                    break;
                case 5:
                    message.taskName = reader.readString();
                    break;
                case 6:
                    message.source = reader.readString();
                    break;
                case 7:
                    message.queueTimeSec = reader.readDouble();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Metric.deserialize(bytes);
    }
}
exports.Metric = Metric;
_Metric_one_of_decls = new WeakMap();
